import React, { useState, useEffect } from 'react';

// DATA
const mainProtocols = [
  { id: 1, icon: '💆', title: 'Vücut Bakım', color: '#10B981', count: 9 },
  { id: 6, icon: '🌫️', title: 'Aspirasyon', color: '#EF4444', count: 3 },
  { id: 2, icon: '💉', title: 'İnvaziv', color: '#3B82F6', count: 9 },
  { id: 3, icon: '🩹', title: 'Stoma', color: '#F59E0B', count: 1 },
  { id: 4, icon: '🛏️', title: 'Pozisyon', color: '#8B5CF6', count: 1 },
];

const subProtocols = [
  { id: 'goz', name: 'Göz Bakımı', icon: '👁️', parentId: 1, color: '#10B981' },
  { id: 'agiz', name: 'Ağız Bakımı', icon: '👄', parentId: 1, color: '#10B981' },
  { id: 'gobek', name: 'Göbek Bakımı', icon: '🤰', parentId: 1, color: '#10B981' },
  { id: 'burun', name: 'Burun Bakımı', icon: '👃', parentId: 1, color: '#10B981' },
  { id: 'kulak', name: 'Kulak Bakımı', icon: '👂', parentId: 1, color: '#10B981' },
  { id: 'perine', name: 'Alt Değiştirme Bakımı', icon: '🧷', parentId: 1, color: '#10B981' },
  { id: 'pisik', name: 'Pişik Bakımı', icon: '🧴', parentId: 1, color: '#10B981' },
  { id: 'banyo', name: 'Silme Banyo', icon: '🛁', parentId: 1, color: '#10B981' },
  { id: 'filebanyo', name: 'File Banyo', icon: '🧽', parentId: 1, color: '#10B981' },
  { id: 'aspirasyon', name: 'Trakeal Aspirasyon', icon: '💨', parentId: 6, color: '#EF4444' },
  { id: 'oralnazal', name: 'Oral ve Nazal Aspirasyon', icon: '🔌', parentId: 6, color: '#EF4444' },
  { id: 'mideaspir', name: 'Mide İçeriği Aspirasyon', icon: '🖇️', parentId: 6, color: '#EF4444' },
  { id: 'nimv', name: 'NI Mekanik Ventilatör', icon: '📺', parentId: 2, color: '#3B82F6' },
  { id: 'ett', name: 'Endotrakeal Entübasyon', icon: '🔧', parentId: 2, color: '#3B82F6' },
  { id: 'mekventi', name: 'Mekanik Ventilatör Bakımı', icon: '🖥️', parentId: 2, color: '#3B82F6' },
  { id: 'ekstubasyon', name: 'Ekstübasyon Öncesi ve Sonrası Bakım', icon: '⚙️', parentId: 2, color: '#3B82F6' },
  { id: 'trakeostomi', name: 'Trakeostomi', icon: '⚕️', parentId: 2, color: '#3B82F6' },
  { id: 'pvk', name: 'Periferik Venöz Kateter', icon: '💉', parentId: 2, color: '#3B82F6' },
  { id: 'svk', name: 'Santral Venöz Kateter', icon: '🩸', parentId: 2, color: '#3B82F6' },
  { id: 'umbilikal', name: 'Umbilikal Kateter Hazırlık/Bakım/Çıkarma', icon: '🩸', parentId: 2, color: '#3B82F6' },
  { id: 'ng', name: 'NGS/OGS Takma/Bakım/Çıkarma', icon: '🍽️', parentId: 2, color: '#3B82F6' },
  { id: 'stoma', name: 'Stoma Bakımı', icon: '⭕', parentId: 3, color: '#F59E0B' },
  { id: 'pozisyon', name: 'Pozisyon ve Elevasyon', icon: '↔️', parentId: 4, color: '#8B5CF6', isParent: true },
];

const algorithms = [
  { id: 'a1', name: 'Göz Bakım Algoritması', icon: '👁️', color: '#10B981', protocolId: 'goz' },
  { id: 'a2', name: 'Ağız Bakım Algoritması', icon: '👄', color: '#10B981', protocolId: 'agiz' },
  { id: 'a3', name: 'Göbek Bakım Algoritması', icon: '🤰', color: '#10B981', protocolId: 'gobek' },
  { id: 'a4', name: 'Burun Bakım Algoritması', icon: '👃', color: '#10B981', protocolId: 'burun' },
  { id: 'a4b', name: 'Kulak Bakım Algoritması', icon: '👂', color: '#10B981', protocolId: 'kulak' },
  { id: 'a5', name: 'Alt Değiştirme Bakım Algoritması', icon: '🧷', color: '#10B981', protocolId: 'perine' },
  { id: 'a5b', name: 'Pişik Bakım Algoritması', icon: '🧴', color: '#10B981', protocolId: 'pisik' },
  { id: 'a6', name: 'Silme Banyo Algoritması', icon: '🛁', color: '#10B981', protocolId: 'banyo' },
  { id: 'a6b', name: 'File Banyo Algoritması', icon: '🧽', color: '#10B981', protocolId: 'filebanyo' },
  { id: 'a7', name: 'Trakeal Aspirasyon Algoritması', icon: '💨', color: '#EF4444', protocolId: 'aspirasyon' },
  { id: 'a7b', name: 'Oral ve Nazal Aspirasyon Algoritması', icon: '🔌', color: '#EF4444', protocolId: 'oralnazal' },
  { id: 'a7c', name: 'Mide İçeriği Aspirasyon Algoritması', icon: '🖇️', color: '#EF4444', protocolId: 'mideaspir' },
  { id: 'a7d', name: 'NI Mekanik Ventilatör Algoritması', icon: '📺', color: '#3B82F6', protocolId: 'nimv' },
  { id: 'a8', name: 'Endotrakeal Entübasyon Algoritması', icon: '🔧', color: '#3B82F6', protocolId: 'ett' },
  { id: 'a8b', name: 'Mekanik Ventilatör Bakım Algoritması', icon: '🖥️', color: '#3B82F6', protocolId: 'mekventi' },
  { id: 'a8c', name: 'Ekstübasyon Öncesi ve Sonrası Bakım Algoritması', icon: '⚙️', color: '#3B82F6', protocolId: 'ekstubasyon' },
  { id: 'a9', name: 'Trakeostomi Algoritması', icon: '⚕️', color: '#3B82F6', protocolId: 'trakeostomi' },
  { id: 'a10', name: 'Periferik Venöz Kateter Algoritması', icon: '💉', color: '#3B82F6', protocolId: 'pvk' },
  { id: 'a12', name: 'Santral Venöz Kateter Algoritması', icon: '💊', color: '#3B82F6', protocolId: 'svk' },
  { id: 'a12b', name: 'Umbilikal Kateter Algoritması', icon: '🩸', color: '#3B82F6', protocolId: 'umbilikal' },
  { id: 'a14', name: 'NG Kateter Algoritması', icon: '🍽️', color: '#3B82F6', protocolId: 'ng' },
  { id: 'a17', name: 'Stoma Bakım ve Uygulama Algoritması', icon: '⭕', color: '#F59E0B', protocolId: 'stoma' },
  { id: 'a18', name: 'Tüm Pozisyonlar', icon: '🛏️', color: '#8B5CF6', protocolId: 'pozisyon', isParent: true, expandedByDefault: true },
  { id: 'a18b', name: 'Pozisyon ve Elevasyon Algoritması', icon: '📊', color: '#8B5CF6', protocolId: 'pozisyonAlg' },
  { id: 'a19', name: 'Prone (Yüz Üstü) Pozisyonu', icon: '⬇️', color: '#8B5CF6', protocolId: 'prone' },
  { id: 'a20', name: 'Yan Yatış Pozisyonu', icon: '↔️', color: '#8B5CF6', protocolId: 'lateral' },
  { id: 'a21', name: 'Supine (Sırt Üstü) Pozisyonu', icon: '⬆️', color: '#8B5CF6', protocolId: 'supine' },
  { id: 'a22', name: 'Cenin Pozisyonu', icon: '↕️', color: '#8B5CF6', protocolId: 'cenin' },
];

const protocolDetails = {
  goz: {
    name: 'Göz Bakımı',
    icon: '👁️',
    color: '#10B981',
    onem: `Yenidoğanlarda ilk günlerde, göz kapağında ve gözde şişlik, kızarıklık ve akıntı ile karakterize olan konjonktivit gelişme riski vardır. Bu enfeksiyona yol açan etkenler doğum eylemi sırasında annenin doğum kanalından bulaşabilirler. Enfeksiyona bağlı gelişen bazı konjontivitlerde korneada ülserasyon, perforasyon, endoftalmi ve körlük gibi çok ciddi komplikasyonlar, görülmektedir. Bu nedenle doğumdan hemen sonra tüm yenidoğan bebeklere göz bakımı yapılmalı ve proflaksi uygulanmalıdır.
Göz proflaksisi için ilaç seçimi: Yenidoğan bebeklerde profilaksi için ilgili sağlık kuruluşu tarafından uygun bir preparat seçilebilir. Türkiye Oftalmoloji Derneği eritromisin %0,5 göz pomadı veya %2,5'luk povidone iodine veya azitromycin göz damlası önermektedir. Eritromisinin bulunmadığı durumlarda %1 tetrasiklin, her ikisinin de bulunmadığı durumlarda topikal yan etkilerine (göz kapağında şişme, göz çevresinde dermatit) rağmen %0,3 gentamisin ya da %0,3 tobramisin uygulanması önerilmektedir.
Hastanemizde %0,3 gentamisin ve %0,3 tobsin damla kullanılmaktadır.
**Yenidoğanlarda doğumdaki göz bakımından sonra, izlemi sırasında gözlerde çapaklanma yoksa özel göz bakımı gerekmez!**`,
    endikasyonlar: [
      { title: 'Subkonjoktival Kanama', content: 'Doğum travmasına bağlı oluşabilir. Tedavi gerekmez. Yaklaşık 10 günde kendiliğinden düzelir.' },
      { title: 'Yenidoğanda Gözyaşı Kanalının Tıkanıklığı', content: 'Gözyaşı gözümüzü sürekli ıslak tutan bir salgıdır. Üst göz kapağının dış kısmında, kaşın hemen altında bulunan gözyaşı bezleri tarafından salgılanır. Gözün burun köküne yakın, iç kısmındaki 2 adet küçük kanalla gözyaşı kesesine ve oradan da burun içine boşalır. Bebeğin, anne karnında gözyaşı kanallarının oluşumunu tamamlayamaması ve gözyaşı kesesinin buruna açıldığı yerdeki zarın delinmeden doğması yenidoğanlarda gözyaşı kanalı tıkanıklığına neden olabilir. Bu bebeklerin çoğunda kanallar birkaç haftada kendiliğinden açılır. Bebeğin doğumdan itibaren gözlerinin sürekli sulanması ve çapaklanması gözyaşı kanalı tıkanıklığının belirtisi olarak görülür.' },
      { title: 'Göz Kapağı Açık Kalması', content: 'Bilincin kapalı olması veya yüz felci gibi nedenlerle bebeğin gözleri açık kalıyorsa, gözyaşı azalması kornea hasarına neden olabilir.' },
      { title: 'Göz Enfeksiyonları (Konjonktivit gibi)', content: '' },
      { title: 'Doğumda Göz Bakımı ve Proflaksi Uygulaması', content: 'Bebek doğduktan sonra, vakit kaybetmeden, göz çevresi ve göz kapakları steril (distile) su veya SF ile ıslatılmış pamukla dıştan içe doğru silinir. Göz kapakları hafifçe açılır ve konjonktivaya, eritromisin 0,5 veya %2,5\'luk povidon iyot veya azitromisin göz damlası uygulanır ve bu işlem sonrası kapak serbest bırakılarak damlanın tüm konjonktivaya yayılması sağlanır. Uygulama doğum sonrası ilk saat içinde yapılmalıdır.' },
    ],
    endikasyonTablo: [
      { endikasyon: 'Subkonjonktival Kanama', malzemeler: ['Steril Spanç', 'Non-steril Eldiven', 'Steril Distile Su/ Serum Fizyolojik/ Kaynamış Ilımış Su'], siklik: 'Günde 4 kez' },
      { endikasyon: 'Yenidoğanda Gözyaşı Kanalının Tıkanıklığı', malzemeler: ['Steril Spanç', 'Non-steril Eldiven', 'Steril Distile Su/ Serum Fizyolojik/ Kaynamış Ilımış Su'], siklik: 'Günde 4 kez' },
      { endikasyon: 'Göz Enfeksiyonları (konjonktivit gibi)', malzemeler: ['Steril Spanç', 'Non-steril Eldiven', 'Steril Distile Su/ Serum Fizyolojik/ Kaynamış Ilımış Su', 'Antibiyotikli göz kremi/ antibiyotikli damla'], siklik: 'Günde 4 kez' },
      { endikasyon: 'Doğumda', malzemeler: ['Steril Spanç', 'Non-steril Eldiven', 'Steril Distile Su/ Serum Fizyolojik/ Kaynamış Ilımış Su', 'Antibiyotikli göz kremi/ antibiyotikli damla'], siklik: 'Doğumda 1 kez' },
    ],
    malzemeler: [
      'Steril Spanç',
      'Non-steril Eldiven',
      'Order Edilen Göz Damlası',
      'Steril Distile Su/Serum Fizyolojik/Kaynamış Ilımış Su',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Gerekli malzemeler hazırlanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
        'Eller el yıkama talimatı ve el yıkama politikasına göre yıkanır.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Yenidoğana sırtüstü veya hastaya özgü pozisyon verilir.',
        'Steril Distile Su/Serum Fizyolojik/Kaynamış Ilımış Su ile ıslatılmış gazlı bez ile gözler dıştan içe doğru tek seferde silinir atılır.',
        'Akıntı varlığına göre işlem tekrarlanır.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sağ/sol yan, yüzüstü veya sırtüstü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Tüm bulgular ve gözlemler kayıt altına alınır.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
        'Yenidoğanın gözü kızarıklık, çapaklanma, akıntı yönünden takip edilir.',
      ]},
    ],
    kaynaklar: [
      'Zenciroğlu, A., Gündüz, R. C., Onat, N., Dilli, D., İpek, M. Ş., ve Aydın, M. (t.y.). (2024) Temel Yenidoğan Bakımı Kitabı.',
      'Oygür, N., Önal, E., ve Zenciroğlu, A. (2021). Türk Neonatoloji Derneği Doğum Salonu Yönetimi Rehberi 2021 Güncellemesi',
      'E. Koç, M. Vural, N. Duman, Ö. Erdeve, A. Y. Baş, ve N. Narlı, Eds.). Türk Neonatoloji Derneği.',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Bozkurt G., ve Sönmez Düzkaya D., (2015) Yenidoğan Protokolleri Kitabı, Nobel Tıp Kitapevi',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Eldiven giyilir.', 'Yenidoğana sırtüstü veya hastaya özgü pozisyon verilir.', 'Steril Distile Su/Serum Fizyolojik/Kaynamış Ilımış Su ile ıslatılmış gazlı bez ile gözler dıştan içe doğru tek seferde silinir atılır.', 'Akıntı varlığına göre işlem tekrarlanır.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  agiz: {
    name: 'Ağız Bakımı',
    icon: '👄',
    color: '#10B981',
    onem: `Anne sütüyle beslenen bebekler için özellikli bir ağız bakımına gerek yoktur. Annenin günlük duş alarak göğüs bakımını sağlaması ya da duş alması mümkün değilse kaynamış soğutulmuş ılık su ile göğüslerini her emzirme öncesinde silmesi yeterlidir.
Ancak anne sütüyle beslenen bebeklerde ağzında süt artığı kalması sonucu mantar plakları oluşabilmektedir. Ayrıca oral beslenemeyen bebeklerde de ağız içi mukozasında oluşan kuruluk nedeniyle ağız içine bakteri ve mantarlar yerleşebilmektedir. Bunun sonucunda yenidoğanın dil ve yanak mukozasında, farenks bölgesinde moniliazis (pamukçuk) gelişebilir. Bu durum bebeklerin beslenmesini etkileyen iyi bir bakımla önlenmesi mümkün olan bir sorundur.
Ağız bakımında amaç oral enfeksiyonların oluşmasını önleyerek uygun ağız hijyenini sağlamaktır. Ağız bakımı bebek aç iken yapılır, aksi takdirde kusmalara neden olur.`,
    endikasyonlar: [
      { title: 'Yarık Dudak ve Damak', content: 'Yarık dudak ve damak, üst çene kemiği ve ağız tavanını oluşturan yumuşak doku ve kemik dokuları oluşturan embriyonik uzantıların yetersiz birleşmesinden ileri gelmektedir.' },
      { title: 'Pamukçuk', content: 'Ağız mukoza yüzeylerinde beyaz lekelere denir.' },
      { title: 'Nazogastrik (NG) / Orogastrik (OG) Sondası Olan Bebekler', content: '' },
      { title: 'Mekanik Ventilasyon Tedavisi Alan Bebekler', content: '' },
      { title: 'Oksijen Tedavisi Alan Hastalar', content: '' },
      { title: 'İnhaler Tedavi Alan Hastalar', content: '' },
      { title: 'Bağışıklık Sistemi Baskılanmış Hastalar', content: '' },
    ],
    endikasyonTablo: [
      { endikasyon: 'YARIK DUDAK VE DAMAK', malzemeler: ['Steril gazlı bez', 'Böbrek küvet', 'Nemlendirici', 'Serum fizyolojik/kaynatılmış ılık su', 'Non-steril eldiven', 'Enjektör'], siklik: 'Doktor istemine göre' },
      { endikasyon: 'PAMUKÇUK', malzemeler: ['Steril gazlı bez', 'Böbrek küvet', 'Nemlendirici', 'Sodyum bikarbonat/topikal antifungal', 'Non-steril eldiven', 'Enjektör'], siklik: 'Doktor istemine göre' },
      { endikasyon: 'NG/OG SONDASI OLAN BEBEKLER', malzemeler: ['Steril gazlı bez', 'Böbrek küvet', 'Nemlendirici', 'Serum fizyolojik/kaynatılmış ılık su', 'Non-steril eldiven', 'Enjektör'], siklik: 'Günde 4 kez' },
      { endikasyon: 'ENTÜBE VEYA CPAP TEDAVİSİ ALAN BEBEKLER', malzemeler: ['Steril gazlı bez', 'Böbrek küvet', 'Nemlendirici', 'Serum fizyolojik/kaynatılmış ılık su', 'Nonsteril eldiven', 'Enjektör'], siklik: 'Günde 4 kez' },
    ],
    malzemeler: [
      'Steril gazlı bez',
      'Böbrek küvet',
      'Nemlendirici',
      'Serum fizyolojik/kaynatılmış ılık su',
      'Non-steril eldiven',
      'Enjektör',
      'Ağız bakım çubuğu',
      'Aspirasyon sondası',
      'Order edilen ilaçlar',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Gerekli malzemeler hazırlanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
        'Eller el yıkama talimatı ve el yıkama politikasına göre yıkanır.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Bebeğe başına yan pozisyon verilir.',
        'Kaynamış ılık su ile ıslatılmış gazlı bez işaret veya serçe parmağa sarılır.',
        'Bebeğin dudak kenarlarına değdirilerek arama refleksi başlatılır ve bebeğin ağzını açması sağlanır.',
        'Bebeğin ağız içi sağ veya sol taraftan başlanarak tek hareket ile yanaklar, dil üstü, damak nazikçe temizlenir.',
        'Bebeğin ağız mukozası pamukçuk yönünden gözlenir.',
        'Dudaklar kuru ise ağız bakımı sonrası nemlendirici uygulanabilir.',
        'Yapılan tüm işlemler kayıt altına alınmaktadır.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sağ/sol yan, yüzüstü veya sırtüstü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Tüm bulgular ve gözlemler kayıt altına alınır.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Zenciroğlu, A., Gündüz, R. C., Onat, N., Dilli, D., İpek, M. Ş., ve Aydın, M. (t.y.). (2024) Temel Yenidoğan Bakımı Kitabı.',
      'Oygür, N., Önal, E., ve Zenciroğlu, A. (2021). Türk Neonatoloji Derneği Doğum Salonu Yönetimi Rehberi 2021 Güncellemesi',
      'E. Koç, M. Vural, N. Duman, Ö. Erdeve, A. Y. Baş, ve N. Narlı, Eds.). Türk Neonatoloji Derneği.',
      'Çetin Kaşıkcıoğlu, F., Efe, E., Öncel, S., Kırca, N., Taşkıran, B., Gönen, M., Bozyurt, F., Koçak, H., Erdoğan, E., Akman, D., ve Baştürk, A. (2014). "Riskli Bebeklerde Hemşirelik Bakımı ve Güvenli Taburculuk" Projesi. Atalla Matbaacılık San. Ltd. Şti.',
      'Conk, Z., Başbakkal, Z., Yılmaz, H. B., & Bolişik, B. (2013). Pediatri Hemşireliği. Akademisyen Tıp Kitabevi.',
      'Özbek, H., Say, A., & Çakır, D. (2022). Yenidoğan Sağlığını Koruyucu Bakımlar: Göz Bakımı, Ağız Bakımı ve Göbek Bakımı. Gaziosmanpaşa Üniversitesi, Sağlık Bilimleri Fakültesi.',
      'Bozkurt, G., ve Sönmez Düzkaya, D. (2015). Yenidoğan Protokolleri Kitabı. Nobel Tıp Kitabevi.',
      'Özoğlu, N. (2022). Yenidoğan Yoğun Bakım Hemşirelik Uygulamaları Kitabı. Nobel Tıp Kitabevi.',
      'Hastane Atık Yönetim Planı. [Kurumsal Doküman].',
      'El Hijyeni Talimatı. [Kurumsal Doküman].',
      'El Hijyeni Politikası. [Kurumsal Doküman].',
      'T.C. Sağlık Bakanlığı, Halk Sağlığı Genel Müdürlüğü, Çocuk ve Ergen Sağlığı Dairesi Başkanlığı. (2024). Temel Yenidoğan Bakımı Kitabı.',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Eldiven giyilir.', 'Bebeğe başına yan pozisyon verilir.', 'Kaynamış ılık su ile ıslatılmış gazlı bez işaret veya serçe parmağa sarılır.', 'Bebeğin dudak kenarlarına değdirilerek arama refleksi başlatılır ve bebeğin ağzını açması sağlanır.', 'Bebeğin ağız içi sağ veya sol taraftan başlanarak tek hareket ile yanaklar, dil üstü, damak nazikçe temizlenir.', 'Bebeğin ağız mukozası pamukçuk yönünden gözlenir.', 'Dudaklar kuru ise ağız bakımı sonrası nemlendirici uygulanır.', 'Yapılan tüm işlemler kayıt altına alınır.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ]
  },
  gobek: {
    name: 'Göbek Bakımı',
    icon: '🤰',
    color: '#10B981',
    onem: `Göbek kordonu fetus ve plasenta arasında kan akımını sağlayan damarları içeren ve çevresindeki wharton jeli ile desteklenen bir yapıdır. Term bir yenidoğanda göbek kordonunun ortalama çapı 1,5 cm, ortalama çevre uzunluğu 3,6 cm'dir. Kordonun ince ya da kalın olması patolojik bazı durumlarda görülebilir. Yirminci gebelik haftasında kordonun uzunluğu ortalama 32 cm iken term bir bebekte 60 cm'dir.
Kordonun uzunluğu fetal kan akımını etkilemez ancak uzun kordon, kord düğümlenmesine, doğumda bebeğin boynuna kord dolanmasına, kord prolapsusuna, trombüs ve fetal ölüme neden olabilir. Kısa umbilikal kordon (<35 cm) plasenta dekolmanı ve gelişim anomalilerine yol açabilir. Kıvrılması olmayan kısa kordon fetal büyümede bozulma ve fetal aktivitede azalmayla ilişkili olup ciddi nöral ve kas iskelet sistemi anomalileriyle birlikte olabilir.
Göbeğin kuru tutulması kaydı ile göbek bakımı uygulanmaktadır. Göbeğin bebek bezinin üstünde tutulması tek şarttır. Göbek düştükten birkaç gün kan lekeleri görmek normaldir.
Göbek bağı normalde 7-14 günde düşer. Bu sürede bebek, göbek ıslatılmadan yıkanabilir ya da silinebilir.`,
    endikasyonlar: [
      { title: 'Omfalit', content: 'Göbek bağının ve/veya çevresindeki dokuların enfeksiyonudur.' },
      { title: 'Göbekte Kızarıklık, Akıntı, Kanama, Şişlik ve Hassasiyet, Pis Koku Olması', content: '' },
      { title: 'Umbilikal Kateter Takılması', content: '' },
      { title: 'Evde Doğum', content: 'Evde sağlık personeli gözetiminde asepsi kurallarına uygun gerçekleşen doğumlarda göbek bakımı hastanede yapılan doğumlardan farklılık göstermez. Ancak geleneksel yöntemlerle evde yapılan doğumlarda göbek kordonunun steril şekilde kesilmemesi ölümcül bir hastalık olan yenidoğan tetanozuna yol açabilir. Yenidoğan tetanozunu önlemenin en temel yolu annenin gebelikte tetanoz aşısı ile uygun şekilde aşılanmasıdır. Evde uygun olmayan yöntemlerle göbeği kesilen bebekler en kısa sürede bir sağlık merkezine götürülmeli, göbek antiseptiklerle temizliği yapılarak steril olarak klemplenerek kesilmeli, bebeğe 250 ünite tetanoz immunoglobulini intramusküler olarak yapılmalıdır.' },
    ],
    endikasyonTablo: [
      { endikasyon: 'Omfalit', malzemeler: ['Steril Spanç', 'Non-steril Eldiven', 'Steril Distile Su', 'Povidon iyot'], siklik: 'Günde 4 Kez' },
      { endikasyon: 'Göbekte Kızarıklık, Akıntı, Kanama, Şişlik Ve Hassasiyet, Pis Koku Olması', malzemeler: ['Steril Spanç', 'Non-steril Eldiven', 'Steril Distile Su'], siklik: 'Günde 3 Kez' },
      { endikasyon: 'Umbilikal Kateter Takılması', malzemeler: ['Steril Spanç', 'Non-steril Eldiven', 'İnvaziv Hat Sabitleme Örtüsü', 'Steril Distile Su'], siklik: 'Kanama, akıntı, pansuman kirlendiğinde yenilenebilir.' },
      { endikasyon: 'Evde Doğum', malzemeler: ['Steril Spanç', 'Non Steril Eldiven', '%4 klorheksidin', 'Klemp', 'Tetanoz İmmun globini (doktor ordere ile)', 'Steril Distile Su'], siklik: 'Günde 4 Kez' },
    ],
    malzemeler: [
      'Steril Spanç',
      'Non-steril Eldiven',
      '% 4-2 Klorheksidin',
      'Klemp',
      'İnvaziv Hat Sabitleme Örtüsü',
      'Steril Distile Su',
      'Povidon iyot',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Gerekli malzemeler hazırlanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
        'Eller el yıkama talimatı ve el yıkama politikasına göre yıkanır.',
      ]},
      { title: 'İŞLEM', items: [
        'Göbek kordonuna dokunmadan önce eller yıkanmalıdır.',
        'Eldiven giyilir.',
        'Kıyafetleri varsa göbek çevresi açık olacak şekilde açılır.',
        'Yenidoğan ilk doğduğunda; kord kleplenerek temiz ve kuru tutulmalıdır.',
        'Göbek kordonunun idrar ya da gaita ile kontamine olmasını önlemek için alt bezini göbek kordonu dışarıda kalacak şekilde göbeğin altından bağlanmalı ve göbek kordonuyla temas etmeyecek şekilde katlamalıdır.',
        'Eğer göbek kordonu kontamine olursa steril su ile bölge temizlenmelidir.',
        'Steril suyla temizledikten sonra temiz ve kuru gazlı bezle kurulanmalıdır.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sağ/sol yan, yüzüstü veya sırtüstü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Tüm bulgular ve gözlemler kayıt altına alınır.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
        'Ebeveynlere umblikal kord bakımı ve gelişebilecek olası sorunlar hakkında eğitim verilir.',
      ]},
    ],
    kaynaklar: [
      'H. Özbek, A. Say, D. Çakır, (2022), Yenidoğan Sağlığını Koruyucu Bakımlar: Göz Bakımı, Ağız Bakımı Ve Göbek Bakımı, Gaziosmanpaşa Üniversitesi, Sağlık Bilimleri Fakültesi.',
      'Türkiye Halk Sağlığı Kurumu. (2017). Temel Yenidoğan Bakımı. Türkiye Halk Sağlığı Kurumu Temel Yenidoğan Bakımı Çocuk Ve Ergen Sağlığı Daire Başkanlığı.',
      'Oygür, N., Önal, E., ve Zenciroğlu, A. (2021). Türk Neonatoloji Derneği Doğum Salonu Yönetimi Rehberi 2021 Güncellemesi (E. Koç, M. Vural, N. Duman, Ö. Erdeve, A. Y. Baş, ve N. Narlı, Eds.)',
      'Çetin Kaşıkcıoğlu, F., Efe, E., Öncel, S., Kırca, N., Taşkıran, B., Gönen, M., Bozyurt, F., Koçak, H., Erdoğan, E., Akman, D., ve Baştürk, A. (2014). "Riskli Bebeklerde Hemşirelik Bakımı Ve Güvenli Taburculuk" Projesi. Atalla Matbaacılık San. Ltd. Şti.',
      'Conk, Z., Başbakkal, Z., Yılmaz, H. B., ve Bolışık, B. (2013). Pediatri Hemşireliği. Akademisyen Tıp Kitapevleri.',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Bozkurt G., ve Sönmez Düzkaya D., (2015) Yenidoğan Protokolleri Kitabı, Nobel Tıp Kitapevi',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Göbek kordonuna dokunmadan önce eller yıkanmalıdır.', 'Eldiven giyilir.', 'Kıyafetleri varsa göbek çevresi açık olacak şekilde açılır.', 'Yenidoğan ilk doğduğunda; kord kleplenerek temiz ve kuru tutulmalıdır.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  burun: {
    name: 'Burun Bakımı',
    icon: '👃',
    color: '#10B981',
    onem: `Yenidoğanlar burundan nefes almaya yatkındır. Burun delikleri çok dar olduğu için burun içi sıvı nedeniyle geçici burun tıkanıklığı ve sesli nefes alma (hırıltı) görülebilir. Yenidoğan bebekte hapşırma sık görülür, burun deliklerini temizlemeye yönelik normal bir reflekstir.
Bebeklerin burun salgıları, bağışıklık sisteminin bir parçasıdır ve mikropların vücuda girişinde ilk engeli oluşturur. Özellikle ortam havası kuru olduğunda, bu salgılar katılaşabilir ve bebeğin gürültülü nefes almasına, tam tıkanıklık oluştuğunda ise rahat etmemesine yol açabilir.
Normalde bebekler aksırarak bu katılaşmış burun salgılarını rahatça dışarı atabilirler. Emzirmeden önce burun deliklerine birkaç damla serum fizyolojik damlatılıp, bebeğin yüzüstü çevirilerek sırtına hafifçe vurulması, bu kurumuş salgıların dışarı atılmasına yardımcı olur.`,
    endikasyonlar: [
      { title: 'Non-invaziv Mekanik Ventilasyon Desteği Alan Yenidoğanlar', content: '' },
      { title: 'İnvaziv Mekanik Ventilasyon Desteği Alan Bebekler', content: '' },
      { title: 'Burunda Kızarıklık, Akıntı', content: '' },
      { title: 'Solunum Yolu Enfeksiyonları (Alt/Üst)', content: 'Bu tür enfeksiyonlar mukus artışına yol açar.' },
      { title: 'Kuru Hava Koşulları', content: 'Nem oranının düşük olduğu ortamlarda burun içi kurur ve tıkanıklık artar.' },
      { title: 'Prematüre Bebeklerde Nörogelişimi İndüklemek İçin Anne Sütü İle', content: '' },
    ],
    endikasyonTablo: [
      { endikasyon: 'Non-invaziv ventilasyon desteği alan bebekler', malzemeler: ['Steril gazlı bez', 'Non-steril Eldiven', 'Gerekli ise uygun nemlendirici', 'Steril Distile Su/Serum Fizyolojik'], siklik: 'Günde 3 defa' },
      { endikasyon: 'Solunum yolu enfeksiyonları olan bebekler', malzemeler: ['Steril gazlı bez', 'Non-steril Eldiven', 'Gerekli ise uygun nemlendirici', 'Steril Distile Su/Serum Fizyolojik'], siklik: 'Günde 3 defa' },
      { endikasyon: 'Prematüre bebekler', malzemeler: ['Non-steril Eldiven', 'Enjektör', 'Anne sütü'], siklik: 'Günde 4 kez' },
      { endikasyon: 'İnvaziv mekanik ventilasyon desteği alan bebekler', malzemeler: ['Steril gazlı bez', 'Non-steril Eldiven', 'Gerekli ise uygun nemlendirici', 'Steril Distile Su/Serum Fizyolojik'], siklik: 'Günde 3 defa' },
    ],
    malzemeler: [
      'Steril gazlı bez',
      'Non-steril Eldiven',
      'Gerekli ise uygun nemlendirici',
      'Steril Distile Su/Serum Fizyolojik/Kaynamış Ilımış Su',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Gerekli malzemeler hazırlanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
        'Eller el yıkama talimatı ve el yıkama politikasına göre yıkanır.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Yenidoğana sırtüstü veya hastaya özgü pozisyon verilir.',
        'Burnun iki deliğine de 0,5 ml serum fizyolojik damlatılır.',
        'Yenidoğan sekresyon açısından değerlendirilir. Gerekirse oral/nazal aspirasyon edilir.',
        'Nemlendirme gerekiyorsa, burun kenarlarına sürülür.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sağ/sol yan, yüzüstü veya sırtüstü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Sekresyon açısından değerlendirme yapılır, burun mukozasında bozulma varsa kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Türkiye Halk Sağlığı Kurumu. (2017). Temel Yenidoğan Bakımı. Türkiye Halk Sağlığı Kurumu Temel Yenidoğan Bakımı Çocuk Ve Ergen Sağlığı Daire Başkanlığı.',
      'Oygür, N., Önal, E., ve Zenciroğlu, A. (2021). Türk Neonatoloji Derneği Doğum Salonu Yönetimi Rehberi 2021 Güncellemesi',
      'H. Özbek, A. Say, D. Çakır, (2022), Yenidoğan Sağlığını Koruyucu Bakımlar: Göz Bakımı, Ağız Bakımı Ve Göbek Bakımı, Gaziosmanpaşa Üniversitesi, Sağlık Bilimleri Fakültesi.',
      'Çetin Kaşıkcıoğlu, F., Efe, E., Öncel, S., Kırca, N., Taşkıran, B., Gönen, M., Bozyurt, F., Koçak, H., Erdoğan, E., Akman, D., ve Baştürk, A. (2014). "Riskli Bebeklerde Hemşirelik Bakımı Ve Güvenli Taburculuk" Projesi. Atalla Matbaacılık San. Ltd. Şti.',
      'Conk, Z., Başbakkal, Z., Yılmaz, H. B., ve Bolışık, B. (2013). Pediatri Hemşireliği. Akademisyen Tıp Kitapevleri.',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Bozkurt G., ve Sönmez Düzkaya D., (2015) Yenidoğan Protokolleri Kitabı, Nobel Tıp Kitapevi',
      'Toksöz F. Sağlıklı Yenidoğanın Doğum Sonrası Temel Hijyenik Bakım Gereksinimleri. Hitit Med J 2023;5(2): 117-121.',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Eldiven giyilir.', 'Yenidoğana sırtüstü veya hastaya özgü pozisyon verilir.', 'Burnun iki deliğine de 0,5 ml serum fizyolojik damlatılır.', 'Yenidoğan sekresyon açısından değerlendirilir. Gerekirse oral/nazal aspirasyon edilir.', 'Nemlendirme gerekiyorsa, burun kenarlarına sürülür.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  kulak: {
    name: 'Kulak Bakımı',
    icon: '👂',
    color: '#10B981',
    onem: `Yenidoğan bebekte kıkırdak dokusu tam gelişmediğinden doğumdan hemen sonra kulaklarda anne karnındaki duruşa bağlı olarak hafif şekil bozukluğu olabilir. Kulağın önünde deri uzantısı (skin tag) veya küçük delik bulunması sık karşılaşılan bir durumdur. Bunların genellikle klinik önemi yoktur. Ancak 3 veya daha fazla sayıda bu tip küçük anomaliler olması ağır doğumsal anomalilerin bulgusu olabilir.
Bütün yeni doğanların olduğu gibi prematürelerin de cildi hassas ve narindir. Özellikle prematüre bebeklerde, kulaklar küçük ve yumuşaktır. Prematüreler de kıkırdak doku tam gelişmediği için; sağ, sol ve yan yatırıldığında uzun süre pozisyon değiştirilmemesine bağlı olarak kulaklarda yapışkanlıklar, nekrozlar oluşabilir. Bu nedenle pozisyon değişikliği önemlidir. Pozisyon değişimi sık sık (2 saat ara ile), hassas bölgelerine havlu, pet gibi malzemelerle desteklenerek yapılmalıdır.`,
    endikasyonlar: [
      { title: 'Prematüre Olması', content: '' },
      { title: 'Non-invaziv / İnvaziv Mekanik Ventilasyon Desteği Alan Bebekler', content: '' },
      { title: 'Akıntı Olması', content: '' },
      { title: 'Kulak Kepçesinde Ekimoz Olması', content: '' },
    ],
    endikasyonTablo: [
      { endikasyon: 'Tüm Endikasyonlar', malzemeler: ['Steril gazlı bez', 'Non-steril Eldiven', 'Steril Distile Su/Serum Fizyolojik'], siklik: '2 Saatte bir' },
    ],
    malzemeler: [
      'Steril gazlı bez',
      'Non-steril Eldiven',
      'Steril Distile Su/Serum Fizyolojik',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Gerekli malzemeler hazırlanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
        'Eller el yıkama talimatı ve el yıkama politikasına göre yıkanır.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Yenidoğana sırtüstü veya hastaya özgü pozisyon verilir.',
        'Steril distile su/serum fizyolojik/kaynamış ılımış su gazlı bez işaret parmağına sarılır.',
        'Kulağın dışta gözüken kısmı ve kulak arkası, kirli kısım ikinci defa kullanılmayacak şekilde silinir.',
        'Diğer kulakta aynı şekilde temizlenir.',
        'Kulak kesinlikle bir cisim sokularak içten temizlenmez, sadece dışarı gelen pislikler temizlenir.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sağ/sol yan, yüzüstü veya sırtüstü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Yapılan uygulama ve kulakta akıntı, soyulma gibi bulguları olup olmadığı kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Türkiye Halk Sağlığı Kurumu. (2017). Temel Yenidoğan Bakımı. Türkiye Halk Sağlığı Kurumu Temel Yenidoğan Bakımı Çocuk ve Ergen Sağlığı Daire Başkanlığı.',
      'Oygür, N., Önal, E., ve Zenciroğlu, A. (2021). Türk Neonatoloji Derneği Doğum Salonu Yönetimi Rehberi 2021 Güncellemesi',
      'H. Özbek, A. Say, ve D. Çakır, (2022), Yenidoğan Sağlığını Koruyucu Bakımlar: Göz Bakımı, Ağız Bakımı Ve Göbek Bakımı, Gaziosmanpaşa Üniversitesi, Sağlık Bilimleri Fakültesi.',
      'Çetin Kaşıkcıoğlu, F., Efe, E., Öncel, S., Kırca, N., Taşkıran, B., Gönen, M., Bozyurt, F., Koçak, H., Erdoğan, E., Akman, D., ve Baştürk, A. (2014). "Riskli Bebeklerde Hemşirelik Bakımı ve Güvenli Taburculuk" Projesi. Atalla Matbaacılık San. Ltd. Şti.',
      'Conk, Z., Başbakkal, Z., Yılmaz, H. B., ve Bolışık, B. (2013). Pediatri hemşireliği. Akademisyen Tıp Kitapevleri.',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Bozkurt G., ve Sönmez Düzkaya D., (2015) Yenidoğan Protokolleri Kitabı, Nobel Tıp Kitapevi',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Eldiven giyilir.', 'Yenidoğana sırtüstü veya hastaya özgü pozisyon verilir.', 'Steril distile su/serum fizyolojik/kaynamış ılımış su gazlı bez işaret parmağına sarılır.', 'Kulağın dışta gözüken kısmı ve kulak arkası, kirli kısım ikinci defa kullanılmayacak şekilde silinir.', 'Diğer kulakta aynı şekilde temizlenir.', 'Kulak kesinlikle bir cisim sokularak içten temizlenmez, sadece dışarı gelen pislikler temizlenir.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  perine: {
    name: 'Alt Değiştirme Bakımı',
    icon: '🧷',
    color: '#10B981',
    onem: `Bebeklerin cildi yetişkin cildine göre çok daha ince, hassas ve kurumaya daha yatkındır, bu durum yenidoğanlarda cildin koruyucu fonksiyonunu azaltmakta ve travmalara karşı yatkınlığını artırmaktadır, alt temizliğinin doğru şekilde yapılması, perinedeki cilt bütünlüğünün korunması için oldukça önemlidir.
Alt bakımının düzgün bir şekilde yapılmaması, bebekte kızarıklık, deri bütünlüğünün bozulması, akıntı, ödem, pişik, ağrı, idrar yolu enfeksiyonu gibi sorunlara neden olabilmektedir.
Düzenli ve doğru uygulanan alt bakımı, bebeklerin iyileşme süreçlerini destekler ve komplikasyon risklerini azaltır. Alt bakımı sırasında hijyen kurallarına dikkat edilmesi ve cilt bütünlüğünün sağlanmasında önemlidir.
Gestasyon yaşı 30 haftadan küçük olan prematüre bebeklerde serebral kan akımı dengesizlikleri, intrakranial basınç artışı ve intraventriküler hemorajileri önlemek amacıyla ilk 72 saat süresince baş omuzlarla birlikte yükseltilerek orta-hat pozisyonu (nötral baş pozisyonu) verilir. Alt bezi değişimi sırasında ayaklarının başının üzerine kaldırılmaması önemlidir. Bu süreçte, dizler hafif fleksiyona getirilerek göğse nazikçe yaklaştırılır. Prematüre bebeğin cildi ile temas eden her şeyin (dokunan el, tıbbi cihaz ve aletler vb.) uygun ısı ve sıcaklıkta olması sağlanmalıdır. Kullanılan bezin gevşek bağlanması gerekmektedir.`,
    endikasyonlar: [
      { title: 'Bebeğin İdrarını Yapmış Olması', content: '' },
      { title: 'Bebeğin Gaitasını Yapmış Olması', content: '' },
      { title: 'Bir Önceki Değişimin Üzerinden 3 Saat Geçmiş Olması', content: '' },
      { title: 'Bebekte Kızarıklık, Deri Bütünlüğünün Bozulması, Akıntı, Ödem, Pişik Olması', content: '' },
    ],
    endikasyonTablo: [
      { endikasyon: 'Bebeğin idrarını yapmış olması', malzemeler: ['Uygun boy bebek bezi', 'Islak pamuk veya alkolsüz ıslak mendil', 'Steril olmayan eldiven'], siklik: 'Günde 8 kez' },
      { endikasyon: 'Bebeğin gaitasını yapmış olması', malzemeler: ['Uygun boy bebek bezi', 'Islak pamuk veya alkolsüz ıslak mendil', 'Steril olmayan eldiven'], siklik: 'Günde 8 kez' },
      { endikasyon: 'Bir önceki değişimin üzerinden 3 saat geçmiş olması', malzemeler: ['Uygun boy bebek bezi', 'Islak pamuk veya alkolsüz ıslak mendil', 'Steril olmayan eldiven'], siklik: 'Günde 8 kez' },
      { endikasyon: 'Bebekte kızarıklık, deri bütünlüğünün bozulması, akıntı, ödem, pişik olması', malzemeler: ['Uygun boy bebek bezi', 'Islak pamuk veya alkolsüz ıslak mendil', 'Pişik önleyici bakım kremi (çinko oksit içeren kremler)', 'Steril olmayan eldiven'], siklik: 'Günde 10-12 kez' },
    ],
    malzemeler: [
      'Uygun boy bebek bezi',
      'Islak pamuk veya alkolsüz ıslak mendil',
      'Pişik önleyici bakım kremi (çinko oksit içeren kremler)',
      'Steril olmayan eldiven',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
        'Ilık suyla ıslatılmış pamuk veya alkolsüz ıslak mendil hazırlanır.',
        'Temiz bebek bezi hazırlanır.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Yenidoğanın varsa alt giysileri çıkarılır ve bezi açılır.',
        'Kız bebeklerde vulva labia kıvrımları ayrılarak önden arkaya doğru silinmeli ve her silinmede temiz ıslak mendil/pamuk kullanılmalıdır. Böylece üretraya dışkıda bulunan mikroorganizmaların bulaşması önlenir.',
        'Erkek bebeklerde ise sünnet derisi geri çekilmeden, penisin uç kısmından dip kısmına doğru temizlik sağlanır.',
        'Defekasyonlu bez eldiven içinde kalacak şekilde eldiven çıkarılır.',
        'Yenidoğanın altına temiz bezi konulur, yenidoğan pişik açısından değerlendirilir.',
        'Pişik yoksa pişik önleyici krem pişik varsa pişik bakım protokolüne göre bakım yapılır.',
        'Yenidoğana temiz bebek bezi göbek bağı açıkta kalacak şekilde bağlanır.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğan uygun pozisyon (sağ/sol yan, yüzüstü, sırtüstü vb.) verilir.',
        'Atık malzemeler hastane atık yönetim planına uygun olarak atılır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Gaita, idrarın özelliği ve varsa pişiğin özelliği kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Altuner, Y. (2024). Sağlık Bilimlerinde Kadın Sağlığı, Gebelik ve Yenidoğan Bakımı.',
      'Bozkurt, G., ve Sönmez Düzkaya, D. (2015). Yenidoğan Protokolleri Kitabı. Nobel Tıp Kitabevi.',
      'Özoğlu, N. (2022). Yenidoğan Yoğun Bakım Hemşirelik Uygulamaları Kitabı. Nobel Tıp Kitabevi.',
      'El Hijyeni Talimatı. [Kurumsal Doküman].',
      'Hastane Atık Yönetim Planı. [Kurumsal Doküman].',
      'El Hijyeni Politikası. [Kurumsal Doküman].',
      'Özbek, H., Say, A., ve Çakır, D. (2022). Yenidoğan Sağlığını Koruyucu Bakımlar: Göz Bakımı, Ağız Bakımı ve Göbek Bakımı. Gaziosmanpaşa Üniversitesi, Sağlık Bilimleri Fakültesi.',
      'Oygür, N., Önal, E., ve Zenciroğlu, A. (2021). Türk Neonatoloji Derneği Doğum Salonu Yönetimi Rehberi 2021 Güncellemesi',
      'T.C. Sağlık Bakanlığı, Halk Sağlığı Genel Müdürlüğü, Çocuk ve Ergen Sağlığı Dairesi Başkanlığı. (2024). Temel Yenidoğan Bakımı Kitabı.',
      'Üğücü G., Çelebioğlu A., ve Gökçe İsbir G., Yenidoğan Yoğun Bakım Ünitesindeki Prematüre Bebeğin Nörogelişiminin Desteklenmesi: İyileştirici Çevrenin Oluşturulması (2024), Adnan Menderes Üniversitesi Sağlık Bilimleri Fakültesi Dergisi',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Eldiven giyilir.', 'Yenidoğanın varsa alt giysileri çıkarılır ve bezi açılır.', 'Kız bebeklerde vulva labia kıvrımları ayrılarak önden arkaya doğru silinmeli ve her silinmede temiz ıslak mendil/pamuk kullanılmalıdır. Böylece üretraya dışkıda bulunan mikroorganizmaların bulaşması önlenir.', 'Erkek bebeklerde ise sünnet derisi geri çekilmeden, penisin uç kısmından dip kısmına doğru temizlik sağlanır.', 'Defekasyonlu bez eldiven içinde kalacak şekilde eldiven çıkarılır.', 'Yenidoğanın altına temiz bezi konulur, yenidoğan pişik açısından değerlendirilir.', 'Pişik yoksa pişik önleyici krem pişik varsa pişik bakım protokolüne göre bakım yapılır.', 'Yenidoğana temiz bebek bezi göbek bağı açıkta kalacak şekilde bağlanır.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen topikal krem uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  pisik: {
    name: 'Pişik Bakımı',
    icon: '🧴',
    color: '#10B981',
    onem: `Pişik olarak ifade edilen bebek bezi dermatiti, perinede, perinealtı bölgesinde ve çevresinde kapalılık, nem ve iritasyon sonucu oluşan bir cilt problemidir.
Pişiğin oluşum nedeni, derinin aşırı nem ve oranları sonucu gergin olması. Alt bezinin sık değiştirilmemesi sonucuyla temas eden bölgedeki pH'ı asitleri on alkaliye dönerek mikroorganizmalar ile kolonileşme olur. Alkali pH gaitadaki proteaz ve lipaz enzimini aktifleştirerek stratum korneum tabakasına zarar verir. Diyaper dermatitinin ilk klinik belirtileri deri kuruluğu olabilir. Erken dönemde eritem, hafif maserasyon ve ödem görülür. Zaman içerisinde miktarı azalmaya başlar; eritem ve maserasyon artar. Şiddetli evrede ise eritemli vücutta ülserasyon ve koşullar gelişir. İlerleyen dönemde mantar ve bakterilerle sekonder enfeksiyonlar gelişebilir.
Pişik oluşumunun önlenmesinde; bebek bezinin sık sık değiştirilmesi, altının havalandırılması, yüksek emme kapasitesi olan kumaşların tercih edilmesi, bezin sıkı olarak bağlanmaması, alkol içeren temizleyici mendillerin kullanılmaması, alt değiştirmede koruyucu kremlerin ince bir tabaka halinde sürülmesi ve nefes yollarına zarar verebilmek için pudra kullanımından kaçınılması büyük önem taşımaktadır.
Bebek bezi dermatit tedavisinin en önemli iki amacı; hasar almış derinin iyileşmesini hızlandırmak ve pişmenin tekrarlamasını önlemektir.`,
    endikasyonlar: [
      { title: 'Hafif/Geniş Kızarıklık', content: '' },
      { title: 'Hassasiyet, Ağrı', content: '' },
      { title: 'Kanama', content: '' },
      { title: 'Dışkı Sayısı ve Özelliği', content: '' },
    ],
    endikasyonTablo: [
      { endikasyon: 'Pişik Bakımı', malzemeler: ['Pamuk', 'Kaynamış ılık su', 'Non-steril eldiven', 'Bebek bezi', 'Antibakteriyel, antifungal ve epitelizan kremler'], siklik: 'Günde 8-10 kez / Bebek bezi her kirlendiğinde' },
    ],
    malzemeler: [
      'Pamuk',
      'Kaynamış ılık su',
      'Doktor istemine göre antibakteriyel, antifungal ve epitelizan kremler',
      'Non-steril eldiven',
      'Bebek bezi',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Yenidoğanın cilt durumu değerlendirilir.',
        'Gerekli malzemeler hazırlanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Yenidoğana sırt üstü veya hastaya özgü pozisyon verilir.',
        'Her alt değiştirmede gluteal bölge temizlenir.',
        'Her idrar ve dışkılama sonrası yenidoğanın altı kaynamış ılık su ile ıslatılmış pamuk ile bastırmadan temizlenip kurulanır. Pişik olmaması için deri kıvrımları iyice kurulanır.',
        'Yenidoğanın altı mümkün olduğunca havalandırılmalıdır. Ağır pişiklerde havalandırmaya ek olarak ısı lambası kullanılır.',
        'Derin pişiklerde lezyon alanına 40 cm mesafeden günde 4 kez 15-20 dakikalık aralıklarla, lamba ile kuru ısı/ışık uygulaması yapılır.',
        'Deri iyice kuruduktan sonra çinko oksit içeren krem kalın tabaka halinde sürülür.',
        'Yenidoğana temiz bebek bezi göbek bağı açıkta kalacak şekilde bağlanır.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğan uygun pozisyon (sağ/sol yan, yüzüstü, sırtüstü vb.) verilir.',
        'Atık malzemeler hastane atık yönetim planına uygun olarak atılır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Gaita, idrarın özelliği ve pişiğin özelliği kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Altuner, Y. (2024). Sağlık Bilimlerinde Kadın Sağlığı, Gebelik ve Yenidoğan Bakımı.',
      'Bozkurt, G., ve Sönmez Düzkaya, D. (2015). Yenidoğan Protokolleri Kitabı. Nobel Tıp Kitabevi.',
      'Özoğlu, N. (2022). Yenidoğan Yoğun Bakım Hemşirelik Uygulamaları Kitabı. Nobel Tıp Kitabevi.',
      'El Hijyeni Talimatı. [Kurumsal Doküman].',
      'Hastane Atık Yönetim Planı. [Kurumsal Doküman].',
      'El Hijyeni Politikası. [Kurumsal Doküman].',
      'Oygür, N., Önal, E., ve Zenciroğlu, A. (2021). Türk Neonatoloji Derneği Doğum Salonu Yönetimi Rehberi 2021 Güncellemesi',
      'T.C. Sağlık Bakanlığı, Halk Sağlığı Genel Müdürlüğü, Çocuk ve Ergen Sağlığı Dairesi Başkanlığı. (2024). Temel Yenidoğan Bakımı Kitabı.',
      'Gözen D., Çağlar S., ve Doğan Z., (2011) 0-24 Ay Arası Bebeği Olan Annelerin Pişiği Önleme ve Bakımına Yönelik Uygulamaları, İ.Ü.F.N. Hem. Dergisi, Cilt 19 - Sayı 1: 17-22',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Eldiven giyilir.', 'Yenidoğana sırt üstü veya hastaya özgü pozisyon verilir.', 'Her alt değiştirmede gluteal bölge temizlenir.', 'Her idrar ve dışkılama sonrası yenidoğanın altı kaynamış ılık su ile ıslatılmış pamuk ile bastırmadan temizlenip kurulanır. Pişik olmaması için deri kıvrımları iyice kurulanır.', 'Yenidoğanın altı mümkün olduğunca havalandırılmalıdır.', 'Deri iyice kuruduktan sonra çinko oksit içeren krem kalın tabaka halinde sürülür.', 'Yenidoğana temiz bebek bezi göbek bağı açıkta kalacak şekilde bağlanır.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen krem uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  banyo: {
    name: 'Silme Banyo',
    icon: '🛁',
    color: '#10B981',
    onem: `Bebek banyosunun amacı cildi temizlemek ve korumak, banyonun dolaşımı uyarması ile bebeğe iyilik ve rahatlık hissi vermesidir. Bebek banyosu yenidoğanda ağrı kontrolünde kullanılan non-farmakolojik yöntemleri arasında yer almaktadır. Yenidoğanın banyosu ile birlikte bebekte kan dolaşımı artmakta, kaslar rahatlamakta ve sinir uçlarının duyarlılığı azalmaktadır.
Yenidoğan bebeklerin ciltlerindeki kan vb. artık maddeler, mikrobik kolonizasyona neden olmaması için doğumdan hemen sonra temizlenmelidir. Bunun için doğum salonunda sıcak kuru havlular ile iyice kurulanmaları genellikle yeterlidir. Ancak mekonyum boyalı veya çok kanlı olanlarda cilt sadece kurulama ile iyi temizlenemez, yıkanması gerekebilir. Annede hepatit B, hepatit C veya HIV enfeksiyonu olduğu bilinen bebekler de doğumdan sonra anne yanına verilmeden yıkanmalıdır.
Bebeklerin doğumdan hemen sonra yıkanmaları, ısılarını düşürüp yararından fazla zarar verebilir. Hipotermi; oksijen tüketimini ve solunum sıkıntısını arttırabilir. Bu nedenle, ilk banyo bebeğin vital bulguları birkaç saat süreyle stabil oluncaya kadar ertelenmelidir. Ancak prematüre, doğum ağırlığı 2500gr altında olan bebekler annede enfeksiyon bilinse dahi yıkanmamalı, kuvöz içinde ılık su ve pamukla silinerek kurulanmalıdır. Silme ve yıkama işlemleri sırasında eldiven kullanımına dikkat edilmelidir.
Yenidoğan döneminde banyo için şampuan veya sabun kullanılması gerekmez. Sabunlar derinin normalde hafif asidik olan pH'sını bozar ve epidermisin koruyucu lipit tabakasını azaltır. Kullanılması gerekiyorsa nötral pH'lı, boya ve parfüm içermeyen bir sabun, saçların yıkanması için yine nötral pH'lı, göz yakmayan bebek şampuanı mümkün olduğu kadar az miktarda kullanılmalıdır. Banyo sırasında kullanılacak şampuanın içeriği sls (sodyum loril sülfat) / sles (sodyum loril eter sülfat) içermeyen yenidoğana özel renksiz kokusuz olmalıdır. Sabun veya şampuan kullanılması durumunda iyice durulanmasına dikkat edilmelidir. Sabun artıkları kalırsa bebeğin cildini tahriş edebilir. Banyo bebeğin beslenmesinden önce yapılmalıdır.
**Yenidoğan cildinden kimyasal maddelerin kolaylıkla emilebildiğini de unutmamak gerekir.**`,
    endikasyonlar: [
      { title: 'Kateter', content: 'Yenidoğana tam banyo verilemediği durumlarda silme banyo yapılmaktadır.' },
      { title: 'Yakın Zamanda Cerrahi Girişim ya da İnvaziv İşlem Yapılmış Olması', content: '' },
      { title: 'Dren Varlığı', content: '' },
      { title: 'Solunum Güçlüğü', content: '' },
    ],
    endikasyonTablo: [
      { endikasyon: 'Tüm Endikasyonlar', malzemeler: ['Steril olmayan eldiven', 'Steril distile su ya da kaynatılmış ılıtılmış su', 'Böbrek küvet', 'Silmek için yumuşak bez', 'Steril gazlı bez', 'Bebek şampuanı', 'Bebek bezi', 'Bebek nemlendiricisi', '2 adet havlu', 'Temiz yatak çarşafı'], siklik: 'Günde 3 defa / Gerektiği durumlarda' },
    ],
    malzemeler: [
      'Steril olmayan eldiven',
      'Steril distile su ya da kaynatılmış ılıtılmış su',
      'Böbrek küvet',
      'Silmek için yumuşak bez',
      'Steril gazlı bez',
      'Bebek şampuanı',
      'Bebek bezi',
      'Bebek nemlendiricisi',
      '2 adet havlu',
      'Temiz yatak çarşafı',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
        'Ortam ısısı ayarlanır (22-26°C).',
        'Suyun ısısı ayarlanır (36,5-37°C).',
        'Biri şampuanlı diğeri duru olmak üzere 2 tane su hazırlanır.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Bebeğin giysileri varsa çıkarılır ve bir havluya sarılır (alt bezi hemen çıkarılmaz).',
        'Ilık duru su ile ıslatılmış gazlı bez ile bebeğin gözleri dıştan içe doğru tek seferde silinir (her göz için ayrı gazlı bez kullanılır).',
        'Temiz bir gazlı bez ile yüz orta bölümden dışa doğru silinir, kurulanır.',
        'Burun, kulak çevresi ve kulakların arkası silinir.',
        'Kulak içinde kir görünen yerdeyse alınır, kulak içine kesinlikle bir şey sokulmaz.',
        'Burnunun görünen yerlerindeki kirler steril gazlı bez ile alınır.',
        'Saçlar önden arkaya doğru masaj yapılarak yıkanır, durulanır ve hemen kurulanır.',
        'Boyun kıvrımları nazikçe silinir.',
        'Boyundan ayaklara kadar genital bölge hariç tüm gövde köpüklü gazlı bez ile nazikçe silinir, ardından temiz suyla ıslatılmış gazlı bezle durulanır ve hemen tüm gövde kurulanır.',
        'Genital bölge alt değişim protokolüne göre temizlenir.',
        'Islak havlular uzaklaştırılır.',
        'Göbeği düşmemiş ise göbek bakım protokolüne göre bakım verilir.',
        'Yenidoğanın kateteri varsa umblikal kateter bakım protokolüne göre bakım verilir.',
        'Yenidoğanın tırnakları uzun ise dezenfekte edilmiş tırnak makası ile küt bir şekilde çok derin olmamak koşulu ile kesilir.',
        'Bebek fototerapi almayacaksa ve cildi çok kuru ise uygun bebek nemlendiricisi tüm vücuduna sürülür ve kıyafetleri giydirilir.',
        'Silme banyodan sonra kuvöz ısısı ayarlanır.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğan uygun pozisyon (sağ/sol yan, yüzüstü, sırtüstü vb.) verilir.',
        'Atık malzemeler hastane atık yönetim planına uygun olarak atılır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Tüm bulgu ve gözlemler kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Sibel Serap Ceylan, Zehra Bahire Bolışık, (2022), Yenidoğan Yoğun Bakım Ünitelerinde Bebek Banyosu: Yenidoğan Hemşireleri İçin Önerileri',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Bozkurt G., ve Sönmez Düzkaya D., (2015) Yenidoğan Protokolleri Kitabı, Nobel Tıp Kitapevi',
      'Aydoğan B., (2025), Yenidoğanda Banyo Yaptırma Ve Yaptırmamanın Umbilikal Kord Komplikasyonlarına Ve Düşme Süresine Etkisi, Karadeniz Teknik Üniversitesi Sağlık Bilimleri Enstitüsü Çocuk Sağlığı ve Hastalıkları Hemşireliği Anabilim Dalı',
      'Bolışık B., (2020), Sarmalama Ve Silme Yöntemi İle Yaptırılan Prematüre Bebek Banyosunun Stres-Ağrı Belirteçlerine Etkisi, Ege Üniversitesi, Sağlık Bilimleri Enstitüsü',
      'Zenciroğlu, A., Gündüz, R. C., Onat, N., Dilli, D., İpek, M. Ş., ve Aydın, M. (t.y.). (2024) Temel Yenidoğan Bakımı Kitabı.',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Ortam ısısı (22-26°C) ve su ısısı (36,5-37°C) ayarlanır.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Eldiven giyilir. Bebeğin giysileri varsa çıkarılır ve bir havluya sarılır (alt bezi hemen çıkarılmaz).', 'Ilık duru su ile ıslatılmış gazlı bez ile bebeğin gözleri gözler dıştan içe doğru tek seferde silinir (her göz için ayrı gazlı bez kullanılır).', 'Temiz bir gazlı bez ile yüz orta bölümden dışa doğru silinir, kurulanır. Burun, kulak çevresi ve kulakların arkası silinir.', 'Kulak içinde kir görünen yerdeyse alınır, kulak içine kesinlikle bir şey sokulmaz.', 'Burnunun görünen yerlerindeki kirler steril gazlı bez ile alınır.', 'Saçlar önden arkaya doğru masaj yapılarak yıkanır, durulanır ve hemen kurulanır.', 'Boyun kıvrımları nazikçe silinir. Genital bölge hariç tüm gövde köpüklü gazlı bez ile nazikçe silinir, ardından temiz suyla ıslatılmış gazlı bezle durulanır ve hemen tüm gövde kurulanır.', 'Islak havlular uzaklaştırılır.', 'Bebek fototerapi almayacaksa ve cildi çok kuru ise uygun bebek nemlendiricisi tüm vücuduna sürülür ve kıyafetleri giydirilir.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen nemlendirici krem varsa uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  filebanyo: {
    name: 'File Banyo',
    icon: '🧽',
    color: '#10B981',
    onem: `File banyo bebeğin bir file ya da ağ benzeri destek üzerine yerleştirilerek uygulanan banyo işlemidir. File çoğunlukla banyo küveti veya lavabonun içerisine yerleştirilir ve su nazikçe bebeğin vücuduna temas eder. Bebeğin vücudu, kullanılan destek üzerinde sabitlenir. Başı, boynu ve sırtı için ek destek uygulanır. Bu uygulama ile bebek güvenli bir şekilde yıkanır.
Bebeğin tüm vücudunun suya değmemesi, sadece filenin deliklerinden geçen suyun bebeğin cildine temas etmesi yani kısmi su teması ile bebeğin vücut sıcaklığının korunmasını sağlar. Bebeğin file üzerine yatması banyoyu rahat, konforlu ve stressiz hale getirir. Doğal vücut kıvrımlarına uyum sağlayan file banyo sırasında bebeğin postürüne destek sağlanır.`,
    endikasyonlar: [
      { title: 'Sağlıklı Doğan', content: '' },
      { title: 'Gebelik Haftası 38-42. Hafta Arasında Olan', content: '' },
      { title: 'APGAR Skoru Birinci ve Beşinci Dakikada 7 ve Üzerinde Olan', content: '' },
      { title: 'Bulaşıcı Hastalığı Olan Anneden Doğan Bebek', content: '' },
    ],
    endikasyonTablo: [
      { endikasyon: 'Tüm Endikasyonlar', malzemeler: ['Steril olmayan eldiven', 'Kaynatılmış ılıtılmış su', 'Böbrek küvet', 'Yıkamak için yumuşak bez', 'Steril gazlı bez', 'Bebek şampuanı', 'Bebek bezi', 'Bebek nemlendiricisi', '2 adet havlu', 'Temiz yatak çarşafı', 'Bebek küveti ve filesi'], siklik: 'Haftada iki defa / Bebek kirlendikçe' },
    ],
    malzemeler: [
      'Steril olmayan eldiven',
      'Kaynatılmış ılıtılmış su',
      'Böbrek küvet',
      'Yıkamak için yumuşak bez',
      'Steril gazlı bez',
      'Bebek şampuanı',
      'Bebek bezi',
      'Bebek nemlendiricisi',
      '2 adet havlu',
      'Temiz yatak çarşafı',
      'Bebek küveti ve filesi',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
        'Ortam ısısı ayarlanır (22-26°C).',
        'Suyun ısısı ayarlanır (36,5-37°C). Banyo suyunun vücut ısısında (35-37°C) olması gerekir.',
      ]},
      { title: 'İŞLEM', items: [
        'Bebek fileye yerleştirilmeden önce, suyun ısısı derece ile ölçerek dikkatli bir şekilde kontrol edilir.',
        'Bebek yerleştirilirken bir kol başının altından geçirilir, koltuk altından sıkıca kavranır, diğer elle iki bacağının altından tutulur.',
        'Önce yüz ve saç silme banyosundaki gibi yıkanır.',
        'Sonra bir bez veya sünger yardımıyla bebeğin vücudu yukarıdan aşağıya doğru yıkanır.',
        'Kurulama işlemi havluyu hafifçe değdirerek, cildi zedelemeden dikkatlice yapılmalıdır.',
        'Banyo sonrası bebeğin cildi kuru değilse ayrıca cilt bakımı gerekmez.',
        'Cilt kuru ise ince bir tabaka şeklinde iyice yayarak bakım kremleri kullanılabilir.',
        'Yenidoğanın kateteri varsa umblikal kateter bakım protokolüne göre bakım verilir.',
        'Yenidoğanın tırnakları uzun ise dezenfekte edilmiş tırnak makası ile küt bir şekilde çok derin olmamak koşulu ile kesilir.',
        'Bebek fototerapi almayacaksa ve cildi çok kuru ise uygun bebek nemlendiricisi tüm vücuduna sürülür ve kıyafetleri giydirilir.',
        'File banyosundan sonra kuvöz ısısı ayarlanır.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğan uygun pozisyon (sağ/sol yan, yüzüstü, sırtüstü vb.) verilir.',
        'Atık malzemeler hastane atık yönetim planına uygun olarak atılır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Tüm bulgu ve gözlemler kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Ceylan S., Bolışık Z., (2022), Yenidoğan Yoğun Bakım Ünitelerinde Bebek Banyosu: Yenidoğan Hemşireleri İçin Önerileri',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Bulut H. (2025) Yenidoğanda Banyo Yaptırma Veya Yaptırmamanın Umbilikal Kord Komplikasyonlarına Ve Düşme Süresine Etkisi, Çocuk Sağlığı Ve Hastalıkları Hemşireliği Anabilim Dalı',
      'Bozkurt G., ve Sönmez Düzkaya D., (2015) Yenidoğan Protokolleri Kitabı, Nobel Tıp Kitapevi',
      'Aydoğan B., (2025), Yenidoğanda Banyo Yaptırma Ve Yaptırmamanın Umbilikal Kord Komplikasyonlarına Ve Düşme Süresine Etkisi, Karadeniz Teknik Üniversitesi Sağlık Bilimleri Enstitüsü Çocuk Sağlığı ve Hastalıkları Hemşireliği Anabilim Dalı',
      'Bolışık B., (2020), Sarmalama Ve Silme Yöntemi İle Yaptırılan Prematüre Bebek Banyosunun Stres-Ağrı Belirteçlerine Etkisi, Ege Üniversitesi, Sağlık Bilimleri Enstitüsü',
      'Zenciroğlu, A., Gündüz, R. C., Onat, N., Dilli, D., İpek, M. Ş., ve Aydın, M. (t.y.). (2024) Temel Yenidoğan Bakımı Kitabı.',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.', 'Ortam ısısı (22-26°C) ve su ısısı (36,5-37°C) ayarlanır.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Bebek fileye yerleştirilmeden önce, suyun ısısı derece ile ölçerek dikkatli bir şekilde kontrol edilir.', 'Bebek yerleştirilirken bir kol başının altından geçirilir, koltuk altından sıkıca kavranır, diğer elle iki bacağının altından tutulur.', 'Önce yüz ve saç silme banyosundaki gibi yıkanır.', 'Sonra bir bez veya sünger yardımıyla bebeğin vücudu yukarıdan aşağıya doğru yıkanır.', 'Kurulama işlemi havluyu hafifçe değdirerek, cildi zedelemeden dikkatlice yapılmalıdır.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen nemlendirici krem varsa uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  aspirasyon: {
    name: 'Trakeal Aspirasyon',
    icon: '💨',
    color: '#EF4444',
    onem: `Yenidoğanda doğum sonu hava yolu açıklığının sağlanması, solunum işlevinin normal olarak devam edebilmesi için önemli bir durumdur. Hava yolu açıklığının sağlanamadığı bazı durumlarda, solunum fonksiyonunun devamını sağlayabilmek amacıyla aspirasyon işlemi uygulanmaktadır. Doğum odasında sık uygulanan uygulamalar arasında yer alan aspirasyon, solunum sistemi sekresyonlarının negatif basınçla çalışan bir vakum cihazı ile dışarı alınması işlemidir.
Yenidoğanda aspirasyon işlemine bağlı solunum ve dolaşım sisteminin çalışmasını olumsuz etkileyen ve travma, kanama ve ağrı gibi birçok komplikasyon gelişebilmektedir. Bu açıdan yenidoğanda dikkatli uygulanması gereken bir girişimdir.
Yenidoğanda aspirasyon oro-nazofarenks, endotrakeal ve mide içeriği aspirasyonu şeklinde uygulanmaktadır.
**Endotrakeal Aspirasyon:** Endotrakeal aspirasyon, bir aspiratörle negatif basınç oluşturarak, ucuna yerleştirilen kateter aracılığı ile trakeadaki sekresyonların azaltılması işlemidir. Yenidoğanda iki şekilde yapılabilmektedir. Birincisi laringoskop yardımıyla trakeanın aspirasyonu ve ikincisi endotrakeal tüpün (ET) epiglottan ve vokal kordlardan geçirilerek trakeaya yerleştirilmesi ve tüp içerisinden aspire sondası geçirilerek yapılan aspirasyon işlemidir.`,
    endikasyonlar: [
      { title: 'Solunum Sıkıntısı', content: '' },
      { title: 'Tüp İçi Sekresyon Varlığı', content: '' },
      { title: 'Atelektazi', content: '' },
      { title: 'SpO2 Düşmesi', content: '' },
      { title: 'Kan Basıncında Değişiklik', content: '' },
      { title: 'Bradikardi', content: '' },
      { title: 'Kan Gazında pCO2 Artması', content: '' },
      { title: 'Akciğer Grafisinde İnfiltrasyon', content: '' },
      { title: 'Siyanoz', content: '' },
      { title: 'Hırıltılı Solunum', content: '' },
    ],
    endikasyonTablo: [
      { endikasyon: 'Tüm Endikasyonlar', malzemeler: ['Steril eldiven', 'Non-steril eldiven', 'Steril Serum fizyolojik', 'Steril enjektör', 'Steril aspirasyon sondası/kapalı aspirasyon sistemi', 'Aspiratör', 'Balon maske', 'Oksijen kaynağı'], siklik: '3 saatte bir / Doktor istemi ile daha sık ya da daha az uygulanabilir.' },
    ],
    malzemeler: [
      'Steril eldiven',
      'Non-steril eldiven',
      'Steril Serum fizyolojik',
      'Steril enjektör',
      'Steril aspirasyon Kateteri (6 Fr, 8 Fr, 10 Fr) / kapalı aspirasyon sistemi',
      'Aspiratör',
      'Balon maske',
      'Oksijen kaynağı',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Sterilitesi bozulmayacak şekilde enjektöre steril serum fizyolojik çekilir.',
        'Steril olmayan eldiven giyilir.',
        'Aspiratör basıncı 80-100 mmHg olacak şekilde açılır. Çalışıp çalışmadığı kontrol edilir.',
      ]},
      { title: 'İŞLEM (Açık Sistem)', items: [
        'Aspiratörün ucuna sterilitesi bozulmayacak şekilde aspirasyon sondası yerleştirilir.',
        'Yenidoğan aspirasyona uygun pozisyona (supine) getirilir.',
        'Endotrakeal/Trakeostomi kanülü tüpünün boyu ölçülür. Aspirasyon sondası bu ölçüye göre trakea içinde ilerletilir.',
        'Steril eldiven giyilir.',
        'Doktor ya da bakım veren sağlık profesyoneli tarafından tüpün ucu ventilatörden ayrılır. Aspirasyonu yapan kişi sondayı eli ile klempleyerek sistem kapalı iken hızlı bir şekilde sonda trakea içine ilerletilir.',
        'Klemp açılarak sonda kendi çevresinde döndürülerek aspirasyon gerçekleştirilir.',
        'Aspirasyon işleminin endotrakeal tüp içine sıvı verilmeden yapılması tercih edilir.',
        'Sekresyonları koyu kıvamlı yenidoğanlarda aspirasyon; prematürelerde maximum 0,3 ml, term yenidoğanlarda ise 0,5 ml steril serum fizyolojik verilerek yapılır. Trakea içine sekresyonları yumuşatmak için verilen izotonik hızla geri alınır.',
        'Doktor ya da bakım veren sağlık profesyoneli tarafından yenidoğan hemen ventilatöre bağlanır. SpO2 ve kalp atım hızı kontrol edilir. Gerekirse balon maske ile pozitif basınçlı ventilasyon uygulanır.',
        'İşlemin tekrarlanması gerekiyorsa aynı şekilde yapılır.',
      ]},
      { title: 'İŞLEM (Kapalı Sistem)', items: [
        'Kateter ölçümü ET tüp boyuna göre belirlenir ve 5 cm ilave edilerek ilerletilecek uzunluk hesaplanır.',
        'Enjektör steril serum fizyolojik çekilip Y bağlantısına takılır.',
        'Aspiratör uygun basınca getirilerek katetere bağlantısı yapılır.',
        'Kateter yaklaşık 3 cm ilerletilerek gerekli ise serum fizyolojik verilir sonra kateter ölçülen renge kadar ilerletilir.',
        'Aspirasyon butonunun kilidi açılır, butona basılarak kateter yavaşça geri çekilip aspirasyon işlemi yapılır.',
        'Gerekli ise aynı işlem tekrarlanır.',
        'Aspiratör ile kateter bağlantısı ayrılır. Kateterin aspirasyon kapağı kapatılır. Aspiratör cihazı kapatılıp enjektör Y bağlantısından ayrılır.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sırtüstü veya hastaya özgü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'İşlem öncesi ve işlem sonrası yenidoğanın solunum sayısı/tipi, kalp atım hızı, oksijen satürasyon değerleri ve sekresyonun özelliği, yoğunluğu/rengi kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Batman D., (2020), Yenidoğanın Doğum Odasında Aspirasyon İlkelerinde Güncel Yaklaşımlar; Ebelerin Rol ve Sorumlulukları, Adnan Menderes Üniversitesi Sağlık Bilimleri Fakültesi Dergisi, 4(3); 258-267',
      'Kadıoğlu Şimşek G., Büyüktiryaki M., Okur N., Kanmaz Kutman G., ve Canpolat F., (2019), Prematüre Bebeklerde İki Farklı Endotrakeal Aspirasyon Yönteminin Karşılaştırılması, İzmir Dr. Behçet Uz Çocuk Hast. Dergisi 2019;9(2):131-136',
      'Akyıldız D., (2020), Yenidoğanın Doğum Odasında Aspirasyon İlkelerinde Güncel Yaklaşımlar; Ebelerin Rol ve Sorumlulukları, Adnan Menderes Üniversitesi Sağlık Bilimleri Fakültesi Dergisi 4(3):258-267',
      'Bozkurt G., ve Sönmez Düzkaya D., (2015) Yenidoğan Protokolleri Kitabı, Nobel Tıp Kitapevi',
      'Başer, Y., (2023). Yoğun Bakım Hemşirelerinin Endotrakeal Aspirasyon Uygulamaları ve Etkileyen Faktörler. Yüksek Lisans Tezi, Marmara Üniversitesi Sağlık Bilimleri Enstitüsü, İstanbul.',
      'Bozan, S., (2019), Yoğun Bakım Ünitelerinde Çalışan Hemşirelerin Aspirasyon Uygulamasına Yönelik Bilgi ve Davranışlarının Değerlendirilmesi. Yüksek Lisans Tezi, Nevşehir Hacı Bektaş Veli Üniversitesi, Fen Bilimleri Enstitüsü, Nevşehir',
      'Demir, M., (2022). Yoğun Bakım Hemşirelerinde Aspirasyon Kararını Etkileyen Faktörler. Yüksek Lisans Tezi, İstanbul Okan Üniversitesi Lisansüstü Eğitim Enstitüsü, İstanbul.',
      'Yılmaz, İ., Özden, D., ve Arslan, G.G., (2023). Yoğun Bakımda Uygulanan Endotrakeal Aspirasyon İşlem Basamaklarının Aspirasyon Komplikasyonlarına Etkisi. Adnan Menderes Üniversitesi Sağlık Bilimleri Fakültesi Dergisi, 8(1), 117-117.',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Aspiratörün ucuna sterilitesi bozulmayacak şekilde aspirasyon sondası yerleştirilir.', 'Yenidoğan aspirasyona uygun pozisyona (supine) getirilir.', 'Endotrakeal/Trakeostomi kanülü tüpünün boyu ölçülür. Aspirasyon sondası bu ölçüye göre trakea içinde ilerletilir.', 'Steril eldiven giyilir.', 'Doktor tarafından tüpün ucu ventilatörden ayrılır. Aspirasyonu yapan kişi sondayı eli ile klempleyerek sistem kapalı iken hızlı bir şekilde sonda trakea içine ilerletilir.', 'Klemp açılarak sonda kendi çevresinde döndürülerek aspirasyon gerçekleştirilir.', 'Aspirasyon işleminin endotrakeal tüp içine sıvı verilmeden yapılması tercih edilir.', 'Sekresyonları koyu kıvamlı yenidoğanlarda aspirasyon; prematürelerde maximum 0,3 ml, term yenidoğanlarda ise 0,5 ml steril serum fizyolojik verilerek yapılır. Trakea içine sekresyonları yumuşatmak için verilen izotonik hızla geri alınır.', 'Doktor tarafından yenidoğan hemen ventilatöre bağlanır. SpO2 ve kalp atım hızı kontrol edilir. Gerekirse balon maske ile pozitif basınçlı ventilasyon uygulanır.', 'İşlemin tekrarlanması gerekiyorsa aynı şekilde yapılır.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  oralnazal: {
    name: 'Oral ve Nazal Aspirasyon',
    icon: '🔌',
    color: '#EF4444',
    onem: `Oro/nazofarenks aspirasyon, bir aspirasyon kateteri veya enjektör/puar gövdesiyle ile negatif basınç oluşturarak orofarenks ve nazofarenksin sekresyonlarını gidermek için kullanılan bir yöntemdir. Oro/nazofarenks aspirasyon sadece oral ya da sadece nazal olarak uygulanabildiği gibi birlikte de uygulanabilmektedir.`,
    endikasyonlar: [
      { title: 'Ağız İçinde Sekresyonun Varlığı', content: '' },
      { title: 'İnterkostal Çekilmeler', content: '' },
      { title: 'Burun Kanadı Solunumu', content: '' },
      { title: 'Dispne', content: '' },
      { title: 'Siyanoz', content: '' },
      { title: 'Apne', content: '' },
      { title: "SPO2'de Azalma", content: '' },
      { title: 'Bradikardi', content: '' },
    ],
    endikasyonTablo: [
      { endikasyon: 'Tüm Endikasyonlar', malzemeler: ['Steril aspirasyon Kateteri (6 Fr, 8 Fr, 10 Fr)', 'Steril serum fizyolojik', 'Enjektör (2-5 cc)', 'Non-steril eldiven', 'Aspiratör', 'Steril gazlı bez', 'Oksijen maskesi', 'Oksijen flowmetresi', 'Balon maske'], siklik: 'Günde 3 defa / Doktor istemi ile daha sık ya da daha az uygulanabilir.' },
    ],
    malzemeler: [
      'Steril aspirasyon Kateteri (6 Fr, 8 Fr, 10 Fr)',
      'Steril serum fizyolojik',
      'Enjektör (2-5 cc)',
      'Non-steril eldiven',
      'Aspiratör',
      'Steril gazlı bez',
      'Oksijen maskesi',
      'Oksijen flowmetresi',
      'Balon maske',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Aspiratör cihazının çalışıp çalışmadığı kontrol edilir.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Aspiratör 80-100 mmHg olacak şekilde açılır.',
        'Steril sonda aspiratör ucuna takılır.',
        'Oksijen tedavisi alıyorsa 1-2 lt/dk artırılır.',
        'Yenidoğan sırt üstü pozisyonda yatırılır, omuzlarının altına ince yastık konularak başı hafif yükseltilir ve başı hemşireye bakacak şekilde çevrilir. Gerekli ise burnun iki deliğine 0,2-0,3 ml serum fizyolojik damlatılır.',
        'Önce aspirasyon sondası yenidoğanın dilinin üzerinden kaydırılıp farenkse kadar ilerletilerek aspirasyon yapılır.',
        'Daha sonra burnun iki deliği de sırayla aspire edilir.',
        'Sonda burun içinde ilerletilirken klemplenir. Aspire edilirken klemp açılır. Kateter parmaklar arasında, kendi çevresinde döndürülerek ve geri çekilerek aspirasyon uygulanır.',
        'Gerekli ise işlem tekrarlanır.',
        'Monitörde kalp atım hızı ve satürasyon izlemi yapılır. Gerekirse serbest oksijen verilir.',
        'Ağızda kalan sekresyonlar steril gazlı bez ile silinir.',
        'Ağız ve burun bakım protokolüne göre bakım verilir.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğanın başı 30-45 derece yükseltilerek uygun pozisyon (sırtüstü veya hastaya özgü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'İşlem öncesi ve işlem sonrası yenidoğanın solunum sayısı/tipi, kalp atım hızı, oksijen satürasyon değerleri ve sekresyonun özelliği, yoğunluğu/rengi kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Akyıldız D., (2020), Yenidoğanın Doğum Odasında Aspirasyon İlkelerinde Güncel Yaklaşımlar; Ebelerin Rol ve Sorumlulukları, Adnan Menderes Üniversitesi Sağlık Bilimleri Fakültesi Dergisi 4(3):258-267',
      'Bozkurt G., ve Sönmez Düzkaya D., (2015) Yenidoğan Protokolleri Kitabı, Nobel Tıp Kitapevi',
      'Tez N., (2025), Pediatri Hemşirelerinin Aspirasyon İşlemine Yönelik Uygulamalarının Gözlemsel Değerlendirilmesi, Karamanoğlu Mehmetbey Üniversitesi Sağlık Bilimleri Enstitüsü Yüksek Lisans Tezi',
      'Bozan, S., (2019), Yoğun Bakım Ünitelerinde Çalışan Hemşirelerin Aspirasyon Uygulamasına Yönelik Bilgi ve Davranışlarının Değerlendirilmesi. Yüksek Lisans Tezi, Nevşehir Hacı Bektaş Veli Üniversitesi, Fen Bilimleri Enstitüsü, Nevşehir',
      'Demir, M., (2022). Yoğun Bakım Hemşirelerinde Aspirasyon Kararını Etkileyen Faktörler. Yüksek Lisans Tezi, İstanbul Okan Üniversitesi Lisansüstü Eğitim Enstitüsü, İstanbul',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Aspiratör 80-100 mmHg olacak şekilde açılır.', 'Steril sonda aspiratör ucuna takılır.', 'Oksijen tedavisi alıyorsa 1-2 lt artırılır.', 'Yenidoğan sırt üstü pozisyonda yatırılır, omuzlarının altına ince yastık konularak baş hafifçe yükseltilir ve başı hemşireye bakacak şekilde çevrilir. Mümkünse işlem iki kişi ile steril olarak yapılır. İşlem tek kişi ile yapılıyorsa, aktif olan ele steril eldiven, aktif olmayan ele nonsteril eldiven giyilir ve steril el ile kateter tutulurken, non steril el ile tüp ve ventilatör/balon birbirinden ayrılır, kateter ve aspiratör bağlantısı yapılır.', 'Gerekli ise burnun iki deliğine 0,2-0,3 ml serum fizyolojik damlatılır.', 'Önce aspirasyon sondası yenidoğanın dilinin üzerinden kaydırılıp farenkse kadar ilerletilerek aspirasyon yapılır.', 'Daha sonra burnun iki deliği de sırayla aspire edilir.', 'Sonda burun içinde ilerletilirken klemplenir. Aspire edilirken klemp açılır. Kateter parmaklar arasında, kendi çevresinde döndürülerek ve geri çekilerek aspirasyon uygulanır.', 'Gerekli ise işlem tekrarlanır.', 'Monitörde kalp atım hızı ve satürasyon izlemi yapılır. Gerekirse serbest oksijen verilir.', 'Ağızda kalan sekresyonlar steril gazlı bez ile silinir.', 'Ağız ve burun bakım protokolüne göre bakım verilir.'] },
      { title: 'İLAÇ UYGULAMA', items: ['İlaç uygulanmaz.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  nimv: {
    name: 'NI Mekanik Ventilatör',
    icon: '📺',
    color: '#3B82F6',
    onem: `Yenidoğanlar gestasyon haftaları ile ilişkili olmakla birlikte organ ve sistemlerinin yeterince olgunlaşmaması nedeni ile birçok sorun ile karşılaşmaktadır. Bu sorunların başında solunum sıkıntısı gelmektedir. Solunum yetmezliği, ventilasyonun veya akciğer fonksiyonlarının bozulması anlamına gelir. Solunum sıkıntısının tedavisinde medikal tedavi ile birlikte destekleyici tedavinin de uygulanması gerekmektedir. Destekleyici tedavi yöntemi olarak mekanik ventilasyon (MV) uygulaması yapılmaktadır. Mekanik ventilasyon uygulaması bebeğin ihtiyacına göre invaziv ventilasyon IMV, noninvaziv ventilasyon NIMV uygulanabilmektedir. NİMV, bir arayüz aracılığıyla ventilatör ve yenidoğanın üst solunum yolları arasında bağlantı sağlanarak uygulanır.
İnvaziv olmayan ventilasyon, bebeklerde spontan solunumu desteklemek için endotrakeal tüp yerleştirmeden burun hava yolu yoluyla sağlanan herhangi bir solunum desteği modunu ifade eder. En yaygın invaziv olmayan modlar arasında nazal sürekli pozitif hava yolu basıncı (nCPAP), invaziv olmayan aralıklı zorunlu ventilasyon (nIPPV) ve nemlendirilmiş yüksek akışlı nazal kanül (HHHFNC) bulunur. Bu cihazların her birinin nihai amacı, akciğer hasarına ve uzun vadeli komplikasyonlara katkıda bulunan barotravma, volutravma ve atelektotravmayı önlemektir.
Sürekli Pozitif Hava Yolu Basıncı (CPAP), üst solunum yolu tıkanıklığı veya solunum yetmezliği olan yenidoğanlara solunum desteği sağlamanın bir yoludur. CPAP, hafif–orta solunum sıkıntısında ilk basamak noninvaziv basınçlı destektir.
**Noninvaziv solunum desteği (NSD) yöntemleri:** nCPAP: Nazal sürekli pozitif hava yolu basıncı, NIPPV: Nazal aralıklı pozitif basınçlı ventilasyon, BİPAP: İki düzeyli sürekli pozitif hava yolu basıncı, nHFV: Nazal yüksek frekanslı ventilasyon, nNAVA: Nöronal ayarlanan solunum desteği.`,
    endikasyonlar: [
      { title: 'RDS', content: '' },
      { title: 'TTN', content: '' },
      { title: 'Post-Ekstübasyon Desteği', content: '' },
      { title: 'Sık Apne-Bradikardi Atakları (Özellikle Prematür)', content: '' },
      { title: 'Hafif-Orta Mekonyum Aspirasyonu Sonrası Stabil Olgular', content: '' },
      { title: 'Akciğer Hacmini Korumakta Zorlanan Durumlar', content: '' },
    ],
    endikasyonTablo: [],
    malzemeler: [
      'Ventilatör ve solunum devresi, arayüzler',
      'Steril distile su',
      'Stetoskop',
      'Nonsteril eldiven',
      'Steril gazlı bez',
      'Oksijen kaynağı',
      'Balon maske',
      'Enjektör (2-5-10 cc)',
      'Steril serum fizyolojik',
      'Hipoallerjenik flaster',
      'Uygun arayüz (kanül, şapka, ara yüz, alın desteği gibi) (tek kullanımlık)',
      'Nemlendirmek için sıvı nemlendirici',
      'Yedek nabız oksimetre probu',
      'Test balonu',
      'Burun koruyucu transparan yara örtüsü',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Yenidoğana uygun pozisyon (genelde sırtüstü) verilir.',
        'Orogastrik sonda (OGS) takma protokolüne göre orogastrik sonda takılır.',
        'OGS ile mide 2-4 saatte bir boşaltılır ya da dekomprese bırakılır. Eğer yenidoğan besleniyorsa; beslenme esnasında ve sonrasında kullanılan beslenme enjektörü mide seviyesinden 15-20 cm yukarıda tutulmalıdır.',
        'Ventilatör ve uygun arayüz hazırlanıp kontrol edilir.',
        'Yenidoğanı NIMV\'e almadan önce ve sırasında gerekli ise oral aspirasyon protokolüne uygun aspire edilir.',
        'Burunda olası ülserasyonları önlemek için transparan koruyucu materyal \'T\' şeklinde kesilerek ters \'T\' şeklinde yapıştırılır. Nazal basınç yaralanmasını önlemek için doğru boyutta şapka, kanül ve arayüz kullanılır.',
        'Şapka bebeğin kaşlarını, kulaklarını ve ensede saç bitimini kapatacak şekilde yerleştirilir.',
        'Yenidoğana uygun NIMV arayüzü kullanılır.',
        'Prong\'un yüzde bası oluşturmaması için koruyucu bariyerler yerleştirilir.',
        'Kullanılan markanın belirlemiş olduğu talimata uygun tespit edilir.',
        'Kanülün tahrişini önlemek için nazal nem sürülür.',
        'Ventilatör parametreleri doktor tarafından ayarlanır.',
        'Yenidoğanın başı 30-45 derece yüksekte tutulur.',
        'Nabız oksimetre prob yeri 2-3 saatte bir değiştirilmelidir.',
        'NIMV desteği alan yenidoğan abdominal distansiyon açısından takip edilir.',
        'Yenidoğanın günlük bakım gereksinimleri (vücut, ağız, burun, kulak, göz bakımları ve alt değiştirme) protokollerine uygun olarak verilir.',
        'Kondensasyon (yoğuşma) nedeniyle sette biriken sıvı, belirli aralıkla boşaltılmalıdır. Bu şekilde direnç artışı ve kolonizasyon engellenir.',
        'Ağrı değerlendirmesi düzenli bir şekilde yapılmalıdır.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sağ/sol yan, yüzüstü veya sırtüstü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Ventilatör değerleri, NIMV bağlanma saati, mekanik ventilasyondaki vital bulguları, monitörizasyon verileri, aldığı çıkardığı takibi, sekresyon özelliği ve yapılan diğer uygulamalar kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Türkiye Halk Sağlığı Kurumu. (2017). Temel Yenidoğan Bakımı. Türkiye Halk Sağlığı Kurumu Temel Yenidoğan Bakımı Çocuk Ve Ergen Sağlığı Daire Başkanlığı.',
      'Oygür, N., Önal, E., ve Zenciroğlu, A. (2021). Türk Neonatoloji Derneği Doğum Salonu Yönetimi Rehberi 2021 Güncellemesi',
      'H. Özbek, A. Say, D. Çakır, (2022), Yenidoğan Sağlığını Koruyucu Bakımlar: Göz Bakımı, Ağız Bakımı Ve Göbek Bakımı, Gaziosmanpaşa Üniversitesi, Sağlık Bilimleri Fakültesi.',
      'Çetin Kaşıkcıoğlu, F., Efe, E., Öncel, S., Kırca, N., Taşkıran, B., Gönen, M., Bozyurt, F., Koçak, H., Erdoğan, E., Akman, D., ve Baştürk, A. (2014). "Riskli Bebeklerde Hemşirelik Bakımı Ve Güvenli Taburculuk" Projesi. Atalla Matbaacılık San. Ltd. Şti.',
      'Conk, Z., Başbakkal, Z., Yılmaz, H. B., ve Bolışık, B. (2013). Pediatri Hemşireliği. Akademisyen Tıp Kitapevleri.',
      'Kübra Ergün, Eda Aktaş, Yenidoğanlarda Noninvaziv Ventilasyona Bağlı Nazal Basınç Yaralanması Ve Hemşirelik Bakımı, Türkiye Sağlık Bilimleri Ve Araştırmaları Dergisi, 6(3), 94-103',
      'Çalışır H, Güler F. (2017) Yenidoğan Yoğun Bakım Ünitesinde Mekanik Ventilasyon Uygulanan Prematüre Bebeklere Pozisyon Verme. Turkiye Klinikleri 9(3):227-232.',
      'Özdemir Ş. (2020) Mekanik Ventilasyonda Temel Kavramlar. İçinde: Can E, Bülbül A, Editör. Temel Mekanik Ventilasyon. İstanbul: Tıbbi Yayınlar Merkezi, S. 1-28.',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Yenidoğana uygun pozisyon (genelde sırtüstü) verilir.', 'Oragastrik sonda (OGS) takma protokolüne göre oragastrik sonda takılır.', 'OGS ile mide 2-4 saatte bir boşaltılır ya da dekomprese bırakılır. Eğer yenidoğan besleniyorsa; beslenme esnasında ve sonrasında kullanılan beslenme enjektörü mide seviyesinden 15-20 cm yukarıda tutulmalıdır.', 'Ventilatör ve uygun arayüz hazırlanıp kontrol edilir.', 'Yenidoğanı NIMV\'e almadan önce ve sırasında gerekli ise oral aspirasyon protokolüne uygun aspire edilir.', 'Şapka bebeğin kaşlarını, kulaklarını ve ensede saç bitimini kapatacak şekilde yerleştirilir.', 'Yenidoğana uygun NIMV arayüzü kullanılır.', 'Prongun yüzde bası oluşturmaması için koruyucu bariyerler yerleştirilir.', 'Kullanılan markanın belirlemiş olduğu talimata uygun tespit edilir.', 'Ventilatör parametreleri doktor tarafından ayarlanır.', 'Yenidoğanın başı 30-45 derece yüksekte tutulur.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen nazal nem uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  mideaspir: {
    name: 'Mide İçeriği Aspirasyon',
    icon: '🖇️',
    color: '#EF4444',
    onem: `Doğumda yenidoğanın midesinde bulunan sekresyonların, sıvıların hava yollarına aspirasyona yol açacağı düşüncesi yaygındır. Bu durumu engellemek amacıyla mide içeriğinin aspire edilmesi işlemi ülkemizde ve dünyada halen uygulanmaktadır. Yenidoğanda mide içeriği aspirasyonu, bir aspirasyon kateterin orogastrik ya da nazogastrik sonda gibi mideye ilerletilmesi ve negatif basınç oluşturarak midede yer alan sıvı ve sekresyonların dışarı çekilmesi işlemidir.
Literatürde mide aspirasyonu işleminin etkilerini inceleyen sınırlı sayıda çalışma yer almaktadır. Bu çalışmalar mide aspirasyonun yenidoğanlarda fizyolojik ve davranışsal parametreler üzerinde yarar sağlamadığı, bunun yanı sıra mide aspirasyonu yapılan bebeklerde beşinci dakika sistolik kan basıncının daha yüksek olduğu bildirilmiştir. Ulusal ve uluslararası yenidoğan rehberleri incelendiğinde hiç birinde bu aspirasyon türüne yönelik öneri yer almamaktadır. Buna rağmen bazı durumlarda uygulanmaktadır.`,
    endikasyonlar: [
      { title: 'Gastrointestinal Malformasyon Şüphesi', content: '' },
      { title: 'Pozitif Basınçlı Ventilasyon (PBV) Uygulandıktan Sonra', content: '' },
      { title: 'Non-invaziv Mekanik Ventilasyon Desteği Alan Bebekte Batın Distansiyonu Varsa', content: '' },
      { title: 'Gastrointestinal Kanama Şüphesi Varsa', content: '' },
      { title: 'Tekrarlayan Kusmaları Olan ve Aspirasyon Riski Taşıyan Bebeklerde (Hipotonik, Hipoksik İskemik Ensefalopati vb.)', content: '' },
    ],
    endikasyonTablo: [
      { endikasyon: 'Tüm Endikasyonlar', malzemeler: ['Steril aspirasyon Kateteri (6 Fr, 8 Fr, 10 Fr)', 'Steril serum fizyolojik', 'Enjektör (2-5 cc)', 'Non-steril eldiven', 'Aspiratör', 'Steril gazlı bez'], siklik: 'Doktor istemine göre (rutin olarak önerilmez)' },
    ],
    malzemeler: [
      'Steril aspirasyon Kateteri (6 Fr, 8 Fr, 10 Fr)',
      'Steril serum fizyolojik',
      'Enjektör (2-5 cc)',
      'Non-steril eldiven',
      'Aspiratör',
      'Steril gazlı bez',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Gerekli malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Yenidoğan sırt üstü pozisyonda yatırılır, omuzlarının altına ince yastık konularak başı hafif yükseltilir ve başı hemşireye bakacak şekilde çevrilir.',
        'Nazogastrik / orogastrik sonda takma protokolüne göre takılarak, aspire edilir.',
        'Monitörde kalp atım hızı ve satürasyon izlemi yapılır. Gerekirse serbest oksijen verilir.',
        'Ağızda kalan sekresyonlar steril gazlı bez ile silinir.',
        'Ağız ve burun bakım protokolüne göre bakım verilir.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğanın başı 30-45 derece yükseltilerek uygun pozisyon (sırtüstü veya hastaya özgü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'İşlem öncesi ve işlem sonrası yenidoğanın solunum sayısı/tipi, kalp atım hızı, oksijen satürasyon değerleri ve sekresyonun özelliği, yoğunluğu/rengi kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Batman D., (2020), Yenidoğanın Doğum Odasında Aspirasyon İlkelerinde Güncel Yaklaşımlar; Ebelerin Rol ve Sorumlulukları, Adnan Menderes Üniversitesi Sağlık Bilimleri Fakültesi Dergisi 4(3):258-267',
      'Bozkurt G., ve Sönmez Düzkaya D., (2015) Yenidoğan Protokolleri Kitabı, Nobel Tıp Kitapevi',
      'Tez N., (2025), Pediatri Hemşirelerinin Aspirasyon İşlemine Yönelik Uygulamalarının Gözlemsel Değerlendirilmesi, Karamanoğlu Mehmetbey Üniversitesi Sağlık Bilimleri Enstitüsü Yüksek Lisans Tezi',
      'Bozan, S., (2019), Yoğun Bakım Ünitelerinde Çalışan Hemşirelerin Aspirasyon Uygulamasına Yönelik Bilgi ve Davranışlarının Değerlendirilmesi. Yüksek Lisans Tezi, Nevşehir Hacı Bektaş Veli Üniversitesi, Fen Bilimleri Enstitüsü, Nevşehir',
      'Demir, M., (2022). Yoğun Bakım Hemşirelerinde Aspirasyon Kararını Etkileyen Faktörler. Yüksek Lisans Tezi, İstanbul Okan Üniversitesi Lisansüstü Eğitim Enstitüsü, İstanbul',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Eldiven giyilir.', 'Yenidoğan sırt üstü pozisyonda yatırılır, omuzlarının altına ince yastık konularak başı hafif yükseltilir ve başı hemşireye bakacak şekilde çevrilir.', 'Bir aspirasyon kateterin orogastrik ya da nazogastrik sondanın mideye ilerletilmesi ve negatif basınç oluşturarak midede yer alan sıvı ve sekresyonlar aspire edilir.', 'Monitörde kalp atım hızı ve satürasyon izlemi yapılır. Gerekirse serbest oksijen verilir.', 'Ağızda kalan sekresyonlar steril gazlı bez ile silinir.', 'Ağız ve burun bakım protokolüne göre bakım verilir.'] },
      { title: 'İLAÇ UYGULAMA', items: ['İlaç uygulanmaz.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  ett: {
    name: 'Endotrakeal Entübasyon',
    icon: '🔧',
    color: '#3B82F6',
    onem: `Solunum yetmezliği olan yenidoğan bebeklerin tedavisi için sıklıkla invaziv ventilasyon gereklidir. Yenidoğan hasta, küçük hava yolu çapı, az sayıda kollateral hava yolu, uyumlu göğüs duvarı, zayıf hava yolu stabilitesi ve düşük fonksiyonel rezidüel kapasite gibi kendine özgü fizyolojik özelliklere sahiptir. Yenidoğanın akciğerini etkileyen patolojiler, yaşamın ilerleyen dönemlerinde görülen diğer patolojilerden de farklıdır. Mekanik ventilasyonu optimize etmek ve ventilatör kaynaklı akciğer hasarını önlemek için çeşitli ventilasyon modları ve stratejileri mevcuttur.
Yenidoğanların ventilasyonu sırasında dikkate alınması gereken önemli hususlar arasında hava yolu direncini ve solunum işini en aza indirmek için doğru boyutta endotrakeal tüp kullanımı, hastanın pozisyonu, hemşirelik bakımı, solunum kinezyoterapisi, sedasyon ve analjezi, ventilatörle ilişkili pnömoni ve hastane enfeksiyonu gibi enfeksiyonların önlenmesi ve hava kaçakları ve pulmoner kanama gibi komplikasyonların önlenmesi ve tedavisi yer alır.`,
    endikasyonlar: [
      { title: 'Yüksek Oksijen İhtiyacı', content: 'CPAP/NIPPV altında hâlâ orta-yüksek FiO₂ gereksinimi.' },
      { title: 'Kan Gazında Belirgin Bozulma', content: 'Asidoz ve hiperkapni.' },
      { title: 'Sık ve Ağır Apne-Bradikardi', content: '' },
      { title: 'Hemodinamik İnstabilite', content: '' },
      { title: 'Özel Durumlar', content: 'Ağır mekonyum aspirasyonu ve belirgin pulmoner hipertansiyon, ağır akciğer kompliyans bozukluğu, şüpheli yetersiz ventilasyon gibi.' },
    ],
    endikasyonTablo: [],
    malzemeler: [
      'Uygun boyutta kafsız ETT (2.0-2.5-3.0-3.5-4.0-4.5)',
      'Laringoskop ve uygun boyda blade (00-0-1)',
      'Laringoskop için 2 adet pil (yedek 2 adet daha olmalı)',
      'Maske-balon (preterm ve term boyda)',
      'Acil ilaçlar (adrenalin vb.)',
      'ET tüpüne uygun esnek stile',
      'Flaster',
      'Makas',
      'Oksijen kaynağı (hava-oksijen karışımı)',
      'Çalışır durumda hazırlanmış ventilasyon cihazı',
      'Aspiratör ve aspirasyon sondaları (6Fr-8Fr-10Fr)',
      'Steril ve non-steril eldiven',
      'Nabız oksimetresi/hasta başı monitör ve prop',
      'Stetoskop (yenidoğanlara uygun)',
      'Steril gazlı bez',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Ventilatör hazırlanır. Çalışıp çalışmadığı kontrol edilir.',
        'Laringoskop hazırlanır. Işığının etkin yanıp yanmadığı kontrol edilir.',
        'Maske-balon hazırlanır ve oksijen kaynağı takılır.',
        'Yenidoğan monitörize edilir.',
        'Fiksasyon için yapışkan bantlar hazırlanır.',
        'NGS/OGS takma protokolüne göre beslenme sondası takılır. Mide boşaltılarak sonda dekompresyona alınır.',
        'Gerekli ise yenidoğan oral nazal aspirasyon protokolüne göre aspire edilir.',
        'Doktor istemine göre uygun analjezik ve sedatif verilir.',
        'Yenidoğan sırt üstü veya hastaya özgü pozisyonda omuz altına rulo havlu vb. konarak baş hafif ekstansiyona getirilir.',
        'Doktor tarafından steril eldiven giyilir.',
      ]},
      { title: 'İŞLEM', items: [
        'Doktor stile kullanacak ise ET tüpün içinden ucu çıkmayacak şekilde yerleştirilir.',
        'Yenidoğanın baş kısmı işlemi yapacak doktora yakın olmalıdır.',
        'Balon maske ile yenidoğanın SpO₂ ve KTA\'sı normal değerlere getirilir.',
        'Laringoskop çalışır durumda doktora verilir.',
        'Sekresyonu varsa aspirasyonun steril bir şekilde yapılması sağlanır.',
        'İşlem esnasında yenidoğanın genel durumu, monitördeki değerleri, rengi takip edilir.',
        'Entübasyon tüpü yerleştirildiğinde doktor tarafından stile nazikçe çekilir.',
        'Hemşire tarafından balon maske ile hasta ventile edilirken, doktor tarafından stetoskopla akciğer sesleri dinlenerek entübasyon tüpünün yerinde olup olmadığı belirlenir.',
        'Yenidoğanın ağız kenarındaki sekresyonları temizlenir ve fiksasyon yeri kurulanır.',
        'Entübasyon tüpünün ağız kenarından fiksasyonu yapılır.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'ET entübasyon devam edecek ise yenidoğan mekanik ventilatöre bağlanır.',
        'Doktor tarafından akciğer filmi çekilmesi istenir.',
        'Tüp yerinde ise ETT uygun boyda kısaltılır.',
        'Yenidoğana uygun pozisyon (sağ/sol yan, yüzüstü veya sırtüstü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Ventilatör değerleri, bağlanma saati, mekanik ventilasyondaki vital bulguları, monitörizasyon verileri ve yapılan diğer uygulamalar kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Başara, S.G., ve Küçük, S., (2020). Mekanik Ventilasyon Tedavisi Alan Yenidoğanların Bakımında Hemşire: Eğitim ve Bilgi Düzeyi İlişkisi. Acıbadem Üniversitesi Sağlık Bilimleri Dergisi, 2, 330-336.',
      'Dursun M., Bülbül A., (2014), Mekanik Ventilasyondaki Yenidoğan Bebeğin Bakımı, Şişli Etfal Hastanesi Tıp Bülteni, Cilt: 48, Sayı: 2',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Ventilatör ve laringoskop kontrol edilir. Yenidoğan monitörize edilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Doktor stile kullanacak ise ET tüpün içinden ucu çıkmayacak şekilde yerleştirilir.', 'Yenidoğanın baş kısmı işlemi yapacak doktora yakın olmalıdır.', 'Balon maske ile yenidoğanın SpO₂ ve KTA\'sı normal değerlere getirilir.', 'Laringoskop çalışır durumda doktora verilir.', 'Sekresyonu varsa aspirasyonun steril bir şekilde yapılması sağlanır.', 'İşlem esnasında yenidoğanın genel durumu, monitördeki değerleri, rengi takip edilir.', 'Entübasyon tüpü yerleştirildiğinde doktor tarafından stile nazikçe çekilir.', 'Hemşire tarafından balon maske ile hasta ventile edilirken, doktor tarafından steteskopla akciğer sesleri dinlenerek entübasyon tüpünün yerinde olup olmadığı belirlenir.', 'Yenidoğanın ağız kenarındaki sekresyonları temizlenir ve fiksasyon yeri kurulanır.', 'Entübasyon tüpünün ağız kenarından fiksasyonu yapılır.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  mekventi: {
    name: 'Mekanik Ventilatör Bakımı',
    icon: '🖥️',
    color: '#3B82F6',
    onem: `Yenidoğan bebeklerde solunum yetmezliğinin desteklenmesi amacıyla uygulanan mekanik ventilasyon, morbidite ve mortalite oranlarını önemli oranda etkilemektedir. Bebeklerin bakımı yenidoğan konusunda uzmanlaşmış hekimlerin liderliğinde; yenidoğan hemşiresi ve diğer sağlık personellerini de içeren multidisipliner yaklaşım ile sağlanmalıdır.
Yenidoğanlarda mekanik ventilasyon; solunum işlevi yetersiz olan veya solunumu olmayan bebeklerde alveolar ventilasyon yoluyla oksijenizasyonu ve biriken karbondioksitin atılımını sağlamak, solunumu rahatlatmak ve desteklemek amacıyla kullanılır. Mekanik ventilasyonda izlemin temel amacı; bebeğin en kısa sürede mekanik ventilatörden ayrılabilecek aşamaya gelebilmesidir.
Bu nedenle bebeğin dakikadaki solunum ve kalp atım sayısının, vücut ısısının yaşa göre normal seyretmesini ve uygulanan bakımların tam ve zamanında yapılmasını sağlamak çok önemlidir.`,
    endikasyonlar: [
      { title: 'Standart Uygulama', content: 'Bu protokol yenidoğan yoğun bakım ünitesindeki mekanik ventilatörde takip edilen tüm bebeklere standart olarak uygulanır.' },
    ],
    endikasyonTablo: [],
    malzemeler: [
      'Nabız oksimetre, monitörizasyon ekipmanları',
      'Ventilatör devresi ve su haznesi',
      'Tüp tespit materyali (tüp sabitleyici bandaj / İnvaziv Hat Sabitleme Örtüsü)',
      'Steril enjektör',
      'Steril aspirasyon Kateteri (6 Fr, 8 Fr, 10 Fr) / kapalı aspirasyon sistemi',
      'Steril distile su',
      'Stetoskop',
      'Non-steril eldiven',
      'Nemlendirici (gerekiyorsa)',
      'Pozisyonlama yastıkları/roller',
      'Steril eldiven',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Bebeğin solunum parametreleri, monitör bulguları değerlendirilir.',
        'İşlem sırasında bebeğin termal stabilitesi korunur.',
      ]},
      { title: 'ETT POZİSYONU VE TESPİTİNİN DEĞERLENDİRİLMESİ', items: [
        'Endotrakeal tüpün dudak hizasındaki seviyesi her bakımda kontrol edilir ve kayma olup olmadığı izlenir.',
        'Tüp sağ-sol kayma, sekresyon birikimi, bant gevşemesi açısından değerlendirilir.',
        'Tespit materyali gevşemişse yenilenir; bebek cilt bütünlüğü açısından incelenir.',
        'Tüpün ciltte temas eden bölgelerinde bası-kızarıklık varsa kayıt edilir ve gerekli korunma uygulanır.',
        'Tüp tespit materyali değişiminde: Bebeğe uygun pozisyon verilir, gerektiğinde ikinci personel tüpü sabitler, yeni bant ile sağlam şekilde tespit edilir.',
      ]},
      { title: 'SEKRESYON YÖNETİMİ VE ASPİRASYON', items: [
        'Bebeğin solunum sesleri, ventilatör basınçları, dalga formları, oksijen satürasyonu, kalp hızı değerlendirilerek aspirasyon ihtiyacı belirlenir.',
        'Steril teknik ile aspirasyon yapılır.',
        'İşlem kısa tutulur, hipoksi ve bradikardi açısından monitörizasyon yapılır.',
        'Aspirasyon sonrası bebek değerlendirilir ve ventilatör ayarları kontrol edilir.',
        'Sekresyon rengi, kıvamı, miktarı kayıt edilir.',
      ]},
      { title: 'POZİSYON VERME', items: [
        'Bebek 2-4 saatte bir sağ/sol yan, sırt üstü veya prone pozisyonunda olacak şekilde çevrilir.',
        'Pozisyonlama; atelektazi gelişimini önler, sekresyon drenajını kolaylaştırır.',
        'ETT\'nin pozisyonu, pozisyon değişikliği sonrası tekrar kontrol edilir.',
        'Baş hafif ekstansiyonda, havayolu açıklığı korunacak şekilde tutulur.',
      ]},
      { title: 'VENTİLATÖR DEVRESİ VE NEMLENDİRME YÖNETİMİ', items: [
        'Devrede kıvrılma, sıkışma, yoğunlaşma olup olmadığı her bakım turunda kontrol edilir.',
        'Devre içinde biriken su, ventilatör üretici talimatlarına uygun şekilde boşaltılır; suyun bebeğe geri kaçmaması sağlanır.',
        'Nemlendirici haznedeki su seviyesi kontrol edilir ve gerekirse steril su eklenir.',
        'Devre bağlantıları sıkı olmalıdır; ayrılma riski gözlemlenir.',
      ]},
      { title: 'AĞIZ, BURUN VE GÖZ BAKIMI', items: [
        'Ağız içi günlük olarak değerlendirilir ve ağız bakım protokolüne göre temizlik yapılır.',
        'Ağız çevresinde nemlendirme, iritasyon, pamukçuk açısından düzenli kontrol yapılır.',
        'ET tüpü ve sabitleme materyalinin dudak ve çevresinde iritasyona yol açıp açmadığı değerlendirilir.',
        'Gözler kuruluk, çapaklanma yönünden kontrol edilir.',
      ]},
      { title: 'CİLT VE BASI ALANI İZLEMİ', items: [
        'Kafa, kulak arkası, omuzlar, sakrum ve ekstremiteler bası açısından değerlendirilir.',
        'Tespit materyalleri nedeniyle oluşan bası-kızarıklık kayıt edilir ve önleyici materyal kullanılır.',
        'Bebeğin cildi kuru tutulur; nemli alanlar hemen temizlenir.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sağ/sol yan, yüzüstü veya sırtüstü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Ventilatör değerleri, bağlanma saati, mekanik ventilasyondaki vital bulguları, monitörizasyon verileri, aldığı çıkardığı takibi, sekresyon özelliği ve yapılan diğer uygulamalar kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Neonatal Resusitasyon-Yenidoğan Canlandırması (2024). Ankara: T.C. Sağlık Bakanlığı Ana Çocuk Sağlığı Ve Aile Planlaması Basımevi',
      'Bebek Ve Çocuk İzlem Protokolü. Sağlık Bakanlığı Ana Çocuk Sağlığı Ve Aile Planlaması Genel Müdürlüğü, 2018',
      'Özkeçeci C., Karagöl B., (2021). Mekanik Ventilatördeki Yenidoğan Bebeğin Bakımı, Kocatepe Tıp Dergisi, 22:73-79',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Başara, S.G., ve Küçük, S., (2020). Mekanik Ventilasyon Tedavisi Alan Yenidoğanların Bakımında Hemşire: Eğitim ve Bilgi Düzeyi İlişkisi. Acıbadem Üniversitesi Sağlık Bilimleri Dergisi, 2, 330-336.',
      'Dursun M., Bülbül A., (2014), Mekanik Ventilasyondaki Yenidoğan Bebeğin Bakımı, Şişli Etfal Hastanesi Tıp Bülteni, Cilt: 48, Sayı: 2',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Yenidoğanın pozisyonu 2-3 saatte bir pozisyon verme talimatına göre değiştirilir.', 'Yenidoğanın fizik muayenesi hemşiresi her shifte değerlendirilir.', 'Yenidoğanın bakımları mümkün oldukça az ışık ve sessiz bir fiziki ortamda yapılır.', 'Yenidoğana yapılacak tüm girişimler bir arada yapılmalı, dokunma sınırlandırılmalıdır.', 'Humidifer kontrol edilerek boş ise içine işaretli yere kadar steril distile su konulur ve ısı ayarı yapılır.', 'Kondensasyon (yoğuşma) nedeniyle sette biriken sıvı belirli aralıkla boşaltılmalıdır. Bu şekilde direnç artışı ve kolonizasyon engellenir.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  ekstubasyon: {
    name: 'Ekstübasyon Öncesi ve Sonrası Bakım',
    icon: '⚙️',
    color: '#3B82F6',
    onem: `Ekstübasyon, bir hastanın mekanik ventilatörden ayrılmasının son adımı olan endotrakeal tüpün çıkarılmasıdır.
Mekanik ventilasyona bağlı olan tüm bebeklerin mümkün olan en kısa sürede ekstübe edilmesi gerekmektedir. Bebeklerde solunum yetmezliğinin nedenini, prognozunu, hastalığın beklenen seyrini ve mekanik ventilasyonda daha uzun süre kalmayı gerektiren herhangi bir nedenin bulunup bulunmadığını değerlendirmelidir. Entübasyonun ilk gününden itibaren ekstübasyon planlamasına başlamalıdır.
Ekstübasyon, yalnızca ventilatör desteği ve oksijen gereksinimi azalmış, klinik ve kan gazı açısından stabil bebeklerde planlanmalıdır.
**Hazırlık kriterleri:** Sedatif etkilerden arınma, yeterli spontan efor, sekresyonları tolere edebilme, hemodinamik stabilite, düşük FiO₂ ihtiyacı (yaklaşık %30–40 ve altı), kabul edilebilir pH/PaCO₂, apne/bradikardi yokluğu ve azalmış iş yükü.
Ekstübasyon sonrası genellikle CPAP veya n-IPPV ile köprü desteği verilir; apne eğilimi olanlarda kafein desteği gözden geçirilir.`,
    endikasyonlar: [
      { title: 'Standart Uygulama', content: 'Bu protokol yenidoğan yoğun bakım ünitesinde ekstübasyon uygunluk kriterlerini sağlayan tüm bebeklere standart olarak uygulanır.' },
    ],
    endikasyonTablo: [],
    malzemeler: [
      'Non-steril eldiven',
      'Oksijen kaynağı',
      'Enjektör',
      'Aspiratör',
      'Oksijen maskesi/nazal kanül',
      'Steril distile su',
      'Aspirasyon sondası',
      'Re-entübasyon için ekipmanlar',
      'Balon maske',
      'Steril gazlı bez',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Yenidoğanın midesi enjektör ile boşaltılarak dekompresyona alınır.',
        'Yenidoğana sırt üstü pozisyon verilir.',
        'Gerekli ise yenidoğana endotrakeal tüp aspirasyonu ve oral nazal aspirasyon protokolüne uygun aspirasyon yapılır.',
        'Entübasyon tüpünün flasterleri gevşetilir.',
        'Balon maske tüpe takılarak ventile edilir ve bu sırada entübasyon tüpü geri çekilerek çıkarılır.',
        'Oksijen maskesi/nazal kanül takılarak oksijen verilir.',
        'Gerekli ise oral/nazal aspirasyon protokolüne uygun sekresyonlar temizlenir.',
        'Ekstübasyon sonrası solunum, kalp tepe atımı, SPO2, dolaşım, kas tonüsü, distansiyon açısından yenidoğan 1-2 saatte (duruma göre daha sık takip edilir) bir takip edilir.',
        'Ekstübasyonu tolere etmemesine karşın uygun blade/ET tüpü vb. diğer malzemeler hazırda bulunur.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sağ/sol yan, yüzüstü veya sırtüstü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Tüm bulgu ve gözlemler kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Neonatal Resusitasyon-Yenidoğan Canlandırması (2024). Ankara: T.C. Sağlık Bakanlığı Ana Çocuk Sağlığı Ve Aile Planlaması Basımevi',
      'Bebek Ve Çocuk İzlem Protokolü (2018). Sağlık Bakanlığı Ana Çocuk Sağlığı Ve Aile Planlaması Genel Müdürlüğü',
      'Özkeçeci C., Karagöl B., (2021). Mekanik Ventilatördeki Yenidoğan Bebeğin Bakımı, Kocatepe Tıp Dergisi, 22:73-79',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Başara, S.G., ve Küçük, S., (2020). Mekanik Ventilasyon Tedavisi Alan Yenidoğanların Bakımında Hemşire: Eğitim ve Bilgi Düzeyi İlişkisi. Acıbadem Üniversitesi Sağlık Bilimleri Dergisi, 2, 330-336.',
      'Dursun M., Bülbül A., (2014), Mekanik Ventilasyondaki Yenidoğan Bebeğin Bakımı, Şişli Etfal Hastanesi Tıp Bülteni, Cilt: 48, Sayı: 2',
      'Ateş Özcelep G., (2021), Ekstübasyon Sonrası Preterm Bebeklere Verilen Pozisyonların Solunum Fonksiyonları Üzerine Olan Etkisi, Karadeniz Teknik Üniversitesi Sağlık Bilimleri Enstitüsü',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Yenidoğanın midesi enjektör ile boşaltılarak dekompresyona alınır.', 'Yenidoğana sırt üstü pozisyon verilir.', 'Entübasyon tüpünün flasterleri gevşetilir.', 'Balon maske tüpe takılarak ventile edilir ve bu sırada entübasyon tüpü geri çekilerek çıkarılır.', 'Oksijen maskesi/nazal kanül takılarak oksijen verilir.', 'Gerekli ise oral/nazal aspirasyon protokolüne uygun sekresyonlar temizlenir.', 'Ekstübasyon sonrası solunum, kalp tepe atımı, SPO2, dolaşım, kas tonüsü, distansiyon açısından yenidoğan 1-2 saatte (duruma göre daha sık takip edilir) bir takip edilir.', 'Ekstübasyonu tolere etmemesine karşın uygun blade/ET tüpü vb. diğer malzemeler hazırda bulunur.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  trakeostomi: {
    name: 'Trakeostomi',
    icon: '⚕️',
    color: '#3B82F6',
    onem: `Yenidoğan trakeostomileri, akut veya kronik hava yolu tıkanıklığı, nörolojik bozukluk ve pulmoner yetmezliği olan çocuklara yaşamı sürdüren hava yolu desteği sağlayarak ventilasyona yönelik anatomik ve fizyolojik tıkanıklığı önler. Son literatür taraması, trakeostomi uygulanan tüm pediatrik hastaların yaklaşık yarısının 1 yaşından küçük olduğunu göstermektedir.
Trakeostomi, ilişkili risklere rağmen birçok kritik hasta preterm yenidoğanın hayatta kalmasını kolaylaştırır.
Solunum sıkıntısı sendromu (RDS), prematüre bebeklerde en sık görülen akciğer hastalığıdır ve normal gaz değişimini engelleyen pulmoner sürfaktan eksikliğinden kaynaklanır. Daha fazla yüksek riskli, prematüre, düşük doğum ağırlıklı bebek, sürfaktan tedavisi ve gelişmiş ventilasyon tekniklerinin birleşimiyle RDS'den kurtulmaktadır ve bu sayede bu popülasyonda trakeostomi ihtiyacı azalmaktadır.
Üst solunum yolu tıkanıklığı, yenidoğanlarda trakeostomi için bir diğer birincil endikasyondur. Tıkanıklık, hava akışının mekanik olarak engellenmesiyle hava yolunu tehlikeye atan çok sayıda patofizyolojik süreci kapsar. Burun ve ağız boşlukları seviyesindeki proksimal lezyonlar arasında Pierre Robin sekans ve diğer kraniyofasiyal anormallikler bulunurken, larinksi doğrudan etkileyenler arasında subglottik stenoz, laringomalazi ve ses teli felci bulunur. Diğer patolojik mekanizmalar arasında kistler, hemanjiyomlar ve lenfanjiyomlar bulunur.`,
    endikasyonlar: [
      { title: 'Standart Uygulama', content: 'Bu protokol yenidoğan yoğun bakım ünitesinde trakeostomili takip edilen tüm bebeklere standart olarak uygulanır.' },
    ],
    endikasyonTablo: [],
    malzemeler: [
      'Antiseptik solüsyon',
      'Steril gazlı bez',
      'Trakeostomi pedi',
      'Steril eldiven',
      'Non-steril eldiven',
      'Boyun bağı (gerekiyorsa)',
      'Serum fizyolojik',
      'Enjektör',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
      ]},
      { title: 'İŞLEM', items: [
        'Steril olmayan eldiven giyilir.',
        'Yenidoğana uygun pozisyon (sırt üstü veya hastaya özgü) boynunun altına bir destek konulup baş hafif ekstansiyona getirilerek verilir.',
        'Trakeostominin boyun bağı gevşetilip bir elle kanül tutularak trakeostomi pet/steril gazlı bez çıkarılır.',
        'Çıkarılan trakeostomi pet/steril gazlı bez akıntı, kanama ve koku açısından değerlendirilir.',
        'Kirli eldiven çıkarılıp steril eldiven giyilir.',
        'Stoma çevresi bakımlarda kurum politikasına uygun antiseptik ile merkezden perifere silinmeli, kuruduktan sonra steril distile su ve gazlı bez ile solüsyon ciltten temizlenmelidir.',
        'Serum fizyolojik ile ıslatılmış steril gazlı bez ile bölge antiseptik solüsyondan temizlenir.',
        'Steril gazlı bez ile kurulanır ve yeni steril gazlı bez/trakeostomi pedi değiştirilir.',
        'Boyun bağı değiştirilecek ise (kirlendikçe, nemlendikçe, yıprandıkça) kanüle zarar vermeden dikkatlice çıkartılır.',
        'Boyun bölgesi değerlendirilip ılık su ile bakımı verilip kurulanır.',
        'Boyun bölgesinde pişik bakım protokolüne uygun olarak bakım yapılır.',
        'Yeni boyun bağı bağlanır (Bağın bir ucu kanülden geçirilir. Yenidoğanın ensesinden kıvrılma yapmayacak şekilde diğer ucu da kanüle geçirilir. Ortalanarak gevşek/sıkı olmayacak şekilde bağlanır).',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sırtüstü veya hastaya özgü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Tüm bulgu ve gözlemler kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Amal Isaiah, MD, DPhil; Kelly Moyer, MD; Kevin D. Pereira, (2016), Yenidoğan Trakeostomisinde Güncel Trendler',
      'Julia Chang, BS; Douglas R. Sidell, (2020). MD Yenidoğan Yoğun Bakım Ünitesindeki Bebeklerde Trakeostomi, Cilt 21, Sayı 5',
      'Işık Ş., Dizdar E., Ertekin Ö., Bezirganoğlu H., Uraş N., Işık M., Oğuz Ş. (2020) Yenidoğan Yoğun Bakım Ünitesinde Trakeostomi Uygulamaları, Cilt: 17 Sayı: 2, 339-341',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Işık Ş., Alyamaç Dizdar E., Bezirganoğlu H., Uraş N., Işık M., Oğuz Ş., Ertekin Ö., (2019) Yenidoğan Yoğun Bakım Ünitesinde Trakeostomi Uygulamaları, Jinekoloji - Obstetrik ve Neonatoloji Tıp Dergisi',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Yenidoğana uygun pozisyon (sırt üstü veya hastaya özgü) boynunu altına bir destek konulup baş hafif ekstansiyona getirilerek verilir.', 'Trakeostominin boyun bağı gevşetilip bir elle kanül tutularak trakeostomi pet/steril gazlı bez çıkarılır.', 'Çıkarılan trakeostomi pet/steril gazlı bz akıntı, kanama ve koku açısından değerlendirilir.', 'Kirli eldiven çıkarılıp steril eldiven giyilir.', 'Stoma çevresi bakımlarda kurum politikasına uygun antiseptik ile merkezden perifere silinmeli, kuruduktan sonra steril distile su ve gazlı bez ile solüsyon ciltten temizlenmelidir.', 'Serum fizyolojik ile ıslatılmış steril gazlı bez ile bölge antiseptik solüsyondan temizlenir.', 'Steril gazlı bez ile kurulanır ve yeni steril gazlı bez/trakeostomi pedi değiştirilir.', 'Boyun bapı değiştirilecek ise (kirlendikçe, nemlendikçe, yıprandıkça) kanüle zarar vermeden dikkatlice çıkartılır.', 'Boyun bölgesi değerlendirilip ılık su ile bakımı verilip kurulanır.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç/krem uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  pvk: {
    name: 'Periferik Venöz Kateter',
    icon: '💉',
    color: '#3B82F6',
    onem: `İntravenöz girişimler bireylerin sağlık durumunun devamlılığının sağlanması için yüzyıllardır uygulanmaktadır. İntravenöz girişimlerin gerçekleştirilmesi amacıyla en çok kullanılan araç ise periferik intravenöz kateterdir.
Periferik intravenöz kateter (PİK) uygulaması hemşirelerin sık uyguladığı bir işlemdir. Periferik intravenöz kateter uygulanacak alanın belirlenmesi, gerekli kateter numarasının seçilmesi, PİK uygulama işlemine dair uygun yöntemin bilinmesi, kontrollerle uygulamanın sürdürülmesi, intravenöz kateter bakımının gerçekleştirilmesi ve gelişebilecek komplikasyonlara karşı gözlem yapılarak girişimin etkin bir şekilde devam ettirilmesi hemşirelerin sorumlulukları arasındadır.`,
    endikasyonlar: [
      { title: 'Sıvı-Elektrolit Dengesi', content: 'Hastanın sıvı-elektrolit dengesini sağlamak/sürdürmek.' },
      { title: 'Sıvı Gereksinimi', content: 'Hastanın sıvı gereksinimini karşılamak.' },
      { title: 'Kan ve Kan Ürünleri', content: 'Hastaya kan ve kan ürünleri transferi sağlamak.' },
      { title: 'Gıda İhtiyacı', content: 'Hastanın gerekli gıda ihtiyacını karşılamak.' },
      { title: 'Damar Yolu Açıklığı', content: 'Damar yolu açıklığı sağlamak/sürdürmek.' },
      { title: 'İlaç Tedavisi', content: 'Hastanın ilaç tedavilerini uygulamak.' },
      { title: 'Acil Müdahale', content: 'Acil durumlara karşı hastaya müdahaleyi kolaylaştırmak.' },
    ],
    endikasyonTablo: [],
    malzemeler: [
      'Steril pamuk ya da gazlı bez',
      'Antiseptik solüsyon',
      'Non-steril eldiven',
      'Serum fizyolojik çekilmiş enjektör (2cc)',
      'Flaster',
      'İntravenöz kateter',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Uygun ven açısından (eller ve kollar) başlayarak, alt ekstremiteler (ayak, bilek) ve saçlı deri sırası ile değerlendirilir.',
        'Tüm venler değerlendirildikten sonra uygun ven seçilir.',
        'Bölge antiseptik solüsyon ile merkezden dışa doğru dairesel hareketlerle temizlenir ve kuruması beklenir.',
        'Uygulama yapılacak bölgenin yaklaşık 5 cm yukarısından 2. kişi tarafından elle turnike uygulanır.',
        'Kateter sterilliği bozulmadan çıkarılır.',
        'Serbest el ile uygulama yapılacak bölge gerdirilerek damarın kayması engellenir.',
        'Damara girilecek yerin yaklaşık 1 cm altından, 30-45 derece açı oluşturulacak biçimde vene girilir. Girer girmez açı yaklaşık 15 dereceye küçültülerek kateter ven içinde kan gelişi gözleninceye kadar yavaşça ilerletilir.',
        'Kan gelişi gözlendiğinde iğne plastik kısım önde kalacak kadar geri çekilir, turnike açılır. Kateterin plastik kısmı tamamen ven içine yerleştirilir.',
        'Kateter içindeki iğne çıkarılır, serum fizyolojik bulunan enjektör kateter girişine yerleştirilerek yavaş yavaş enjekte edilerek kateterin ven içinde olup olmadığı kontrol edilir (serum fizyolojik uygulanırken; uygulama bölgesinde şişme, kızarıklık, beyazlık ve ağrı gözlenmesi katerin ven içinde olmadığını gösterir).',
        'Katerin ven içinde olduğuna karar verildikten sonra tespit edilir, stopper/serum seti takılır. Kateter tespiti üzerine takılış tarihi yazılır.',
        'Gerekmedikçe değiştirilmemelidir.',
        'Aseptik teknikle takılmadığından şüphelenilen durumlarda, Flebit (ısı artışı, hassasiyet, eritem gibi) veya enfeksiyon belirti ve bulguları geliştiğinde veya iyi çalışmadığı tespit edildiğinde kateter değiştirilmelidir.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sırtüstü veya hastaya özgü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Tüm bulgu ve gözlemler kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Çetinkaya Şardan, Y., Güner, R., Çakar, N., Ağalar, F., Bolaman, Z., Yavaşoğlu, İ., … Yılmaz, G.R. (2013). Damar İçi Kateter Enfeksiyonlarının Önlenmesi Kılavuzu. Hastane İnfeksiyonları Dergisi, 17(2), 233-279.',
      'Kuş, B., ve Büyükyılmaz, F. (2019). Periferik İntravenöz Kateter Uygulamalarında Güncel Kılavuz Önerileri. Gümüşhane Üniversitesi Sağlık Bilimleri Dergisi, 8(3), 326-332.',
      'Denat, Y., ve Erdoğan, B.C. (2016). Periferik İntravenöz Kateter Komplikasyonlarından Flebit Ve Hemşirelik Bakımı. Journal of Human Rhythm, 2(1), 6-12.',
      'Çelik, Ş., ve Avşar, G. (2021). Periferik İntravenöz Kateter Uygulamasında Hemşirelik Bakımı: Kanıta Dayalı Uygulamalar. SBÜ Hemşirelik Dergisi, 3(3), 177-182. doi: 10.48071/sbuhemsirelik.962136',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Uygun ven açısından (eller ve kollar) başlayarak, alt ekstremiteler (ayak, bilek) ve saçlı deri sırası ile değerlendirilir.', 'Tüm venler değerlendirildikten sonra uygun ven seçilir.', 'Bölge antiseptik solüsyon ile merkezden dışa doğru dairesel hareketlerle temizlenir ve kuruması beklenir.', 'Uygulama yapılacak bölgenin yaklaşık 5 cm yukarısından 2. kişi tarafından elle turnike uygulanır.', 'Kateter sterilliği bozulmadan çıkarılır.', 'Serbest el ile uygulama yapılacak bölge gerdirilerek damarın kayması engellenir.', 'Damara girilecek yerin yaklaşık 1 cm altından, 30-45 derece açı oluşturulacak biçimde vene girilir. Girer girmez açı yaklaşık 15 dereceye küçültülerek kateter ven içinde kan gelişi gözleninceye kadar yavaşça ilerletilir.', 'Kan gelişi gözlendiğinde iğne plastik kısım önde kalacak kadar geri çekilir, turnike açılır. Kateterin plastik kısmı tamamen ven içine yerleştirilir.', 'Kateter içindeki iğne çıkarılır, serum fizyolojik bulunan enjektör kateter girişine yerleştirilerek yavaş yavaş enjekte edilerek kateterin ven içinde olup olmadığı kontrol edilir. (Serum fizyolojik uygulanırken; uygulama bölgesinde şişme, kızarıklık, beyazlık ve ağrı gözlenmesi katerin ven içinde olmadığını gösterir.)', 'Katerin ven içinde olduğuna karar verildikten sonra tespit edilir, stopper/serum seti takılır. Kateter tespiti üzerine takılış tarihi yazılır.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç/krem uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },

  svk: {
    name: 'Santral Venöz Kateter',
    icon: '🩸',
    color: '#3B82F6',
    onem: `Santral venöz kateter damar erişimi sağlayan, her iki ucu açık, içi boş, esnek, ince plastik boru şeklindeki aletlerdir. Bu plastik borunun bir ucu kalbin yakınındaki ana toplardamarlardan birinin içine yerleştirilir. Diğer ucu ise göğüs kemiği ya da boyun/kasık bölgesinde deriden çıkar.
Vücudun dışında ince uzun boru şeklindeki kateter lümeni bulunur. Kateter lümen sayısı bir ya da birden fazla sayıda olabilir. Lümen sayısı az olan kateterler enfeksiyon riski daha düşük olduğu için genellikle daha fazla tercih edilirler. Her bir kateter lümeninin üzerinde kelepçe görevi yapan plastik "klemp" bulunur. Her bir kateter lümeninin en uç kısmında ise kateteri kapatan "kapak" yer alır. Bu uçlar aracılığıyla verilen ilaçlar veya sıvılar doğrudan damar içine verilmiş olur. Kateter kullanılmadığı zaman klempler ve kapaklar her zaman kapalı tutulmalıdır.`,
    endikasyonlar: [
      { title: 'Standart Uygulama', content: 'Bu protokol yenidoğan yoğun bakım ünitesinde santral venöz kateteri olan tüm bebeklere standart olarak uygulanır.' },
    ],
    endikasyonTablo: [],
    malzemeler: [
      'Non-steril eldiven',
      'Steril eldiven (2 adet)',
      'Antiseptik sprey (%2 klorheksidin içeren)',
      'Steril gazlı bez (Spanç) (Yeterli sayıda)',
      'Elastik sabitleme bandı (önceden kesilip hazırlanmış)',
      'Doktor istemine göre Heparin flakon (25 000 IU/5 mL)',
      'Serum fizyolojik',
      'İnsülin enjektörü',
      '10 mL enjektör',
      'Yeni steril kapak (lümen sayısı kadar) (Değişim yapılacaksa)',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
      ]},
      { title: 'İŞLEM', items: [
        'Eldiven giyilir.',
        'Yenidoğana uygun pozisyon (sırtüstü/hastaya özgü) verilir.',
        'Değiştirilecek olan pansumanın flasterleri nemlendirilerek nazikçe çıkarılır. Çıkarılan pansuman akıntı, kanama ve koku açısından değerlendirilir.',
        'Steril eldiven giyilir.',
        'Kateterin boyu, yerinde olup olmadığı ve cilde tespit edilen dikişleri kontrol edilir.',
        'Antiseptik solüsyonla ıslatılmış steril gazlı bez ile kateter giriş bölgesi merkezden dışarıya doğru dairesel hareketlerle temizlenir. Bu işlem üç kez tekrarlanarak bölgenin solüsyonla 1 dakika teması sağlanır.',
        'Serum fizyolojik ile ıslatılmış steril gazlı bez ile bölge antiseptik solüsyondan temizlenir ve steril kuru gazlı bez ile kurulanır.',
        'Kateter giriş yeri pansuman materyali (steril gazlı bez/şeffaf örtü) ile flasterlenerek kapatılır.',
        'Steril gazlı bezle yapılan pansumanlar 48 saatte bir, şeffaf örtü kullanılan pansumanlar haftada bir değiştirilmelidir. Pansumanın bütünlüğü bozulmuş, ıslanmış ya da kirlenmiş ise değiştirilmelidir.',
        'Steril eldiven değiştirilerek yeni steril eldiven giyilir. Boş lümenler enjektöre çekilmiş serum fizyolojik ile yıkanır. Lümen girişleri antiseptik solüsyon ile ıslatılmış gazlı bez ile silinir.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sağ/sol yan, yüzüstü veya sırtüstü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Tüm bulgu ve gözlemler kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Santral Venöz Kateter Bakım Rehberi 2019',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Temizsoy E., (2013), Yenidoğan Yoğun Bakım Ünitelerinde Periferik Santral Venöz Kateter Kullanımı, Hemşirelik Bakım ve Yönetimi, Zeynep Kamil Kadın ve Çocuk Hastalıkları Eğitim ve Araştırma Hastanesi.',
      'Taşdemir M (2009) Yenidoğanlarda Periferik Ven Yoluyla Takılan Santral Venöz Kateter Kullanımında Heparinin Etkisi. Çocuk Sağlığı Ve Hastalıkları Uzmanlık Tezi, İstanbul',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Değiştirilecek olan pansumanın flasterleri nemlendirilerek nazikçe çıkarılır. Çıkarılan pansuman akıntı, kanama ve koku açısından değerlendirilir.', 'Steril eldiven giyilir.', 'Kateterin boyu, yerinde olup olmadığı ve cilde tespit edilen dikişleri kontrol edilir.', 'Antiseptik solüsyonla ıslatılmış steril gazlı bez ile kateter giriş bölgesi merkezden dışarıya doğru dairesel hareketlerle temizlenir. Bu işlem üç kez tekrarlanarak bölgenin solüsyonla 1 dakika teması sağlanır.', 'Serum fizyolojik ile ıslatılmış steril gazlı bez ile bölge antiseptik solüsyondan temizlenir ve steril kuru gazlı bez ile kurulanır.', 'Kateter giriş yeri pansuman materyali (steril gazlı bez/şeffaf örtü) ile flasterlenerek kapatılır.', 'Steril eldiven değiştirilerek yeni steril eldiven giyilir. Boş lümenler enjektöre çekilmiş serum fizyolojik ile yıkanır. Lümen girişleri antiseptik solüsyon ile ıslatılmış gazlı bez ile silinir.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç/krem varsa kullanılır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
  umbilikal: {
    name: 'Umbilikal Kateter Hazırlık/Bakım/Çıkarma',
    icon: '🩸',
    color: '#3B82F6',
    onem: `Umbilikal venöz (UVC) ve umbilikal arteriyel (UAC) kateterler, yenidoğan yoğun bakım ünitesinde acil damar yolu ihtiyacının karşılanmasında, hemodinamik monitorizasyonun sağlanmasında, kan gazı takibi, sıvı-elektrolit tedavisi, parenteral beslenme ve vazopressör uygulamalarında kritik öneme sahiptir.
Bu kateterlerin yerleştirilmesi, sürdürülmesi ve çıkarılması, enfeksiyon, tromboz, kanama, vazospazm ve organ malpozisyonu gibi potansiyel komplikasyonlar açısından yüksek risk taşır. Bu nedenle işlem öncesi hazırlığın doğru yapılması, kateterin güvenli şekilde uygulanması, günlük bakımının standartlaştırılması ve uygun zamanlama ile komplikasyonsuz çıkarılması; bebeğin güvenliği, damar bütünlüğü ve tedavi başarısı açısından zorunludur.
Bu protokol ile umbilikal kateter uygulama süreçlerinde aseptik teknik, uzmanlık gerektiren izlem, düzenli bakım ve erken komplikasyon tanısı için standart yaklaşım sağlanması amaçlanmaktadır.`,
    endikasyonlar: [
      { title: 'Umbilikal Venöz Kateter (UVC) Endikasyonları', content: 'Acil damar yolu gereksinimi (şok, resüsitasyon, hipovolemi), ilaç ve sıvı tedavilerinin güvenli uygulanması (vazopressör, prostaglandin vb.), parenteral beslenme uygulaması, exchange transfüzyon ihtiyacı, göbekten kan örneği alınması gereken durumlar, periferal damar yolu bulunamaması veya yetersizliği.' },
      { title: 'Umbilikal Arteriyel Kateter (UAC) Endikasyonları', content: 'Sürekli invaziv kan basıncı monitörizasyonu, sık arteriyel kan gazı ihtiyacı, ağır solunum yetmezliği veya hemodinamik instabilite, kritik hastalarda güvenli arteriyel erişim gereksinimi.' },
      { title: 'Umbilikal Kateterin Çıkarılma Endikasyonları', content: 'Kateterin kullanım amacının sona ermesi, kateterle ilişkili enfeksiyon şüphesi veya kanıtı, kateter çalışmaması/tıkanması/yer değiştirmesi, göbek çevresinde akıntı/kanama/nekroz/inflamasyon, radyolojik/klinik malpozisyon, trombüs varlığı veya emboli şüphesi. UVC için en geç 7–10 gün, UAC için 5–7 gün kullanım süresinin dolması.' },
    ],
    endikasyonTablo: [],
    malzemeler: [
      'Steril eldiven, maske, bone, steril önlük',
      'Steril örtü ve set',
      'Umbilikal kateter (UVC/UAC için uygun boy ve tip)',
      'Steril bistüri veya makas',
      'Cilt antiseptiği (klorheksidin %0.2–0.5 veya povidon iyot, prematürelerde hassas cilt uyumlu kullanım)',
      'Steril serum fizyolojik',
      'Sütur materyali veya uygun tespit aparatı',
      'Enjektörler, üçlü musluklar, bağlantı setleri',
      'Flushing solüsyonu (hekim orderına göre)',
      'Kan gazı veya hemodinamik monitörizasyon ekipmanı',
      'Tespit materyalleri (İnvaziv Hat Sabitleme Örtüsü/şeffaf örtü)',
      'Kateter uzunluğu hesaplama cetveli',
      'Atık kutusu',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'İşlem için gerekli tüm malzemeler hazırlanır ve steril alan oluşturulur.',
        'İşlem bebeğin ailesine kısaca açıklanır (varsa).',
        'Bebek ısı kaybından korunacak şekilde hazırlanır ve monitörize edilir.',
        'Göbek çevresi uygun antiseptik ile steril tekniğe uygun olarak temizlenir.',
        'Kateterin yerleştirileceği uzunluk standart formüller ile hesaplanır (UVC/UAC için).',
        'Aseptik teknikle işlem başlatılır.',
      ]},
      { title: 'KATETERİN YERLEŞTİRİLMESİ', items: [
        'Göbek kordonu steril teknikle hazırlanır, yeterli uzunlukta kesilir.',
        'Arter veya ven lümeni dikkatlice ayrılır ve kateter uygun açı ile ilerletilir.',
        'Kateter ilerletilirken direnç algılanırsa işlem durdurulur.',
        'UVC\'nin karaciğer içine girmemesi, UAC\'in arter duvarında travma oluşturmaması için yumuşak ilerletme sağlanır.',
        'Kateter hesaplanan uzunlukta sabitlenir; sütur veya uygun tespit materyali kullanılır.',
        'Kan geri akımı ve flushing ile kateter açıklığı doğrulanır.',
        'Kateter yerinin doğrulanması için radyografi istenir.',
        'Radyolojik doğrulama sonrası kateter kullanıma açılır.',
      ]},
      { title: 'KATETER TAKILIYKEN GÜNLÜK BAKIM', items: [
        'Aseptik teknik ile her girişim yapılır.',
        'Kateter giriş yeri günlük olarak kızarıklık, akıntı, kanama ve hassasiyet açısından değerlendirilir.',
        'Kateter bağlantıları gevşeklik, sızıntı ve hava kabarcığı açısından kontrol edilir.',
        'Kateter lümeni hekim orderına göre uygun solüsyonla flush edilir.',
        'Şeffaf örtü nemlenme/gevşeme durumunda hemen değiştirilir.',
        'Her kan alma ve ilaç uygulaması öncesi üçlü musluklar antiseptik ile temizlenir.',
        'Trombüs gelişim riskine karşı kateter akımı ve direnç izlenir.',
        'Bebek hareketleriyle kateterin çekilmemesi, bağlantıların sabit olması, hijyenik bakım sırasında çekilmeye karşı destek sağlanması zorunludur.',
        'Günlük kateter devam gerekliliği hekim tarafından değerlendirilir.',
      ]},
      { title: 'UMBİLİKAL KATETERİN ÇIKARILMASI', items: [
        'Çıkarma zamanı hekim tarafından belirlenir. Kateter ilişkili bakteriyemi, damar yetersizliği veya tromboz belirtileri varsa kateter çıkarılmalıdır.',
        'Aseptik teknikle giriş yeri açılır.',
        'Kateter sabitleme materyali nazikçe kaldırılır.',
        'Kateter yavaş ve sürekli çekiş ile çıkarılır; direnç hissedilirse işlem durdurulur.',
        'Çıkarma sırasında kanama açısından bebek yakından gözlenir.',
        'Çıkarma sonrası göbek bölgesine steril kompres uygulanır ve hemostaz sağlanır.',
        'Giriş yeri 24 saat kızarıklık, akıntı ve kanama açısından izlenir.',
      ]},
      { title: 'İŞLEM SONRASI KAYIT VE İZLEM', items: [
        'Kateter tipi, boyu ve yerleştirilme/çıkarılma zamanı kayıt edilir.',
        'Kateterin ilerletildiği uzunluk kayıt edilir.',
        'Radyolojik doğrulama bulguları kayıt edilir.',
        'Günlük giriş yeri değerlendirme bulguları kayıt edilir.',
        'Kateterle ilişkili sorunlar (tıkanma, malpozisyon, enfeksiyon bulguları) kayıt edilir.',
        'Çıkarma sonrası hemostaz durumu kayıt edilir.',
        'Tüm gözlemler kayıt altına alınır ve ekip ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Santral Venöz Kateter Bakım Rehberi 2019',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Dönmez H., Umbilikal Ven Kateterizasyonu Ve İlaç Uygulamaları, Dr. Öğr. Üyesi, Necmettin Erbakan Üniversitesi Seydişehir Sağlık Bilimleri Fakültesi.',
      'Türk Neonatoloji Derneği Yenidoğan Sarılıklarında Yaklaşım, İzlem Ve Tedavi Rehberi, 2022',
      'Bülbül A., Okan F., (2008), Yenidoğanda Nadir Kullanılan İnvazif Girişimler, Şişli Etfal Hastanesi Tıp Bülteni 42:2',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['İşlem için gerekli tüm malzemeler hazırlanır ve steril alan oluşturulur.', 'Bebek ısı kaybından korunacak şekilde hazırlanır ve monitörize edilir.', 'Göbek çevresi uygun antiseptik ile steril tekniğe uygun olarak temizlenir.', 'Kateterin yerleştirileceği uzunluk standart formüller ile hesaplanır (UVC/UAC için).'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Aseptik teknik ile her girişim yapılır.', 'Kateter giriş yeri günlük olarak kızarıklık, akıntı, kanama ve hassasiyet açısından değerlendirilir.', 'Kateter bağlantıları gevşeklik, sızıntı ve hava kabarcığı açısından kontrol edilir.', 'Kateter lümeni hekim orderına göre uygun solüsyonla temizlenir.', 'Şeffaf örtü nemlenme/gevşeme durumunda hemen değiştirilir.', 'Her kan alma ve ilaç uygulaması öncesi üçlü musluklar antiseptik ile temizlenir.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç/krem uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },

  ng: {
    name: 'Nazogastrik Sonda (NGS) / Orogastrik Sonda (OGS) Takma/Bakım/Çıkarma',
    icon: '🍽️',
    color: '#3B82F6',
    onem: `Prematüre bebeklerin beslenmesinde en uygun yöntemi belirlemek çok zordur. Bebekler hastanede kalışları süresince iki ya da daha fazla yöntemle beslenmeye gereksinim duyabilirler. Prematüre bebeklerde 32-34. gestasyon haftasına kadar emme ve yutma koordinasyonu tam olarak gelişmez. Ventile edilen bebekleri de oral beslemek olası değildir.
Enteral beslenme; besinlerin oral, besin maddelerinin doğrudan sindirim sistemi yolu ile (barsak, mide) genellikle bir kateter aracılığı (NGS/OGS) ile verilmesidir. Bu yöntemlerden hangisinin tercih edilmesi gerektiğine, yenidoğanın gestasyon yaşı, klinik durumu ve ağızdan beslenebilme yeteneği göz önünde bulundurulur.`,
    endikasyonlar: [
      { title: 'Emme-Yutma Koordinasyonu Gelişmemiş', content: 'Prematüre bebeklerde 32-34. gestasyon haftasına kadar emme ve yutma koordinasyonunun gelişmemiş olması.' },
      { title: 'Ventilasyon', content: 'Bebeğin ventile edilmesi.' },
      { title: 'Oral Beslenmeyi Engelleyen Anomali', content: 'Oral beslenmesini engelleyen anomali varlığı.' },
    ],
    endikasyonTablo: [],
    malzemeler: [
      'Beslenme sondası (5Fr, 6Fr, 8Fr)',
      'Hipoallerjenik yapışkanlı bant',
      'Makas',
      'Enjektör',
      'Stetoskop',
      'Spanç',
      'Non-steril eldiven',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Eldiven giyilir.',
        'Yenidoğan sırt üstü pozisyon verilip başı yüksekte ve uygulama yapılacak kişiye dönük olacak şekilde çevrilir.',
      ]},
      { title: 'NG/OG SONDA TAKILMASI', items: [
        'Protokole uygun olarak ağız ve burun bakımı yapılır.',
        'Ölçüm yapılır (burun kökünden kulak memesine oradan sternumun ksifoid çıkıntısına kadar olan mesafe ölçülerek yapılır) ve sonda işaretlenir.',
        'Nazal yol ile uygulanacak ise; sonda önce burun deliğine paralel daha sonra arkaya ve aşağı doğru olacak şekilde, yavaş ve yumuşak hareketlerle ve parmak arasında kendi ekseni etrafında döndürülerek ilerletilir.',
        'Oral yol ile uygulanacak ise; yenidoğanın ağzını tam olarak açtıktan sonra, sonda ile dile paralel olacak şekilde, uvulaya dokunmadan önce ileri sonra aşağı ve arkaya doğru yavaş ve yumuşak hareketlerle ve parmak arasında kendi ekseni etrafında döndürülerek ilerletilir.',
        'Birinci yöntem: Enjektör sondanın ucuna yerleştirilerek aspire edilir ve mide içeriğinin gelip gelmediği kontrol edilir. Mide içeriği gelmiyorsa ve enjektörde direnç varsa sonda diğer yöntemlerle kontrole devam edilir.',
        'İkinci yöntem: Mideye enjektörle yenidoğanın gestasyon haftasına uygun olarak 1-2 ml hava verilir. Bu sırada epigastrik bölgede stetoskopla hava sesi dinlenir. Hava sesi duyulamıyorsa/emin olunamıyorsa verilen hava geri çekilerek dinleme işlemi tekrarlanır.',
        'Sondanın midede olduğundan emin olunamıyorsa çıkarma tekniğine uygun olarak çıkarılır ve işlem tekrarlanır.',
        'Sondanın midede olduğundan emin olunduğunda ince bir flasterle önce cilde daha sonra sonda etrafında iki kez döndürülerek ilk yapıştırılan yere paralel olarak tespiti yapılır.',
        'Sondanın kaç cm\'de tespit edildiği kaydedilir.',
      ]},
      { title: 'NGS/OGS BAKIMI', items: [
        'NGS/OGS tespiti için kullanılan flasterler ciltten ayrılırsa, ıslanırsa ve kirlenirse değiştirilir. Tespit için kullanılan flaster nemlendirilerek çıkarılır.',
        'Bakım sırasında sondanın midede olup olmadığından şüphe duyuluyor ise tekniğe uygun olarak kontrol edilir.',
        'NGS/OGS değişiminde deri bütünlüğünü korumak amacıyla kullanılmayan burun deliği/ağız kenarı kullanılır.',
        'Protokole uygun olarak ağız ve burun bakımı yapılır.',
      ]},
      { title: 'NG/OG SONDA ÇIKARILMASI', items: [
        'Tespit için kullanılan flaster nemlendirilerek çıkarılır.',
        'Sondanın dışarıdaki kısmı klemplenerek sürekli bir hareketle ve burun tabanına paralel olarak çekilir.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğana uygun pozisyon (sırtüstü veya hastaya özgü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Tüm bulgu ve gözlemler kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Çay S., Geylani Güleç S., (2015), Yenidoğan Beslenmesinde Kullanılan Enteral Yöntemler ve Hemşirelik Bakımı, G.O.P. Taksim E.A.H. Derleme / Review JAREN 2015;1(1):39-44',
      'Bozkurt, G., ve Sönmez Düzkaya, D. (2015). Yenidoğan Protokolleri Kitabı. Nobel Tıp Kitabevi.',
      'Özoğlu, N. (2022). Yenidoğan Yoğun Bakım Hemşirelik Uygulamaları Kitabı. Nobel Tıp Kitabevi.',
      'Oygür, N., Önal, E., ve Zenciroğlu, A. (2021). Türk Neonatoloji Derneği Doğum Salonu Yönetimi Rehberi 2021 Güncellemesi',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.', 'Eldiven giyilir.', 'Yenidoğan sırt üstü pozisyon verilip başı yüksekte ve uygulama yapılacak kişiye dönük olacak şekilde çevrilir.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['NGS/OGS tespiti için kullanılan flasterler ciltten ayrılırsa, ıslanırsa ve kirlenirse değiştirilir. Tespit için kullanılan flaster nemlendirilerek çıkarılır.', 'Bakım sırasında sondanın midede olup olmadığından şüphe duyuluyor ise tekniğe uygun olarak kontrol edilir.', 'NGS/OGS değişiminde deri bütünlüğünü korumak amacıyla kullanılmayan burun deliği/ağız kenarı kullanılır.', 'Protokole uygun olarak ağız ve burun bakımı yapılır.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen ilaç/krem uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },

};

const stomaProtocolData = {
  stoma: {
    name: 'Stoma Bakımı',
    icon: '⭕',
    color: '#F59E0B',
    onem: `Stoma, bağırsağın bir kısmı ile karın duvarı (mide bölgesi) arasında bulunan bir açıklıktır. Dışkı ve gazın vücuttan bir kese aracılığıyla atılmasını sağlar. Stomaya ostomi de denir.
Tıbbi ve/veya cerrahi müdahale gerektiren patolojisi olan prematür veya matür yenidoğanlar prenatal dönemde daha sık tanı almakta ve postnatal bakım ve tedavi olanaklarının gelişmesi sebebiyle uzun süreler yenidoğan bakım ünitelerinde tedavi edilmektedir. Buna paralel olarak, bu olgularda cerrahi müdahale gerektirecek patolojilerle daha sık karşılaşılır. Bu patolojilerin takip ve/veya tedavileri içerisinde stomalar, hastalığın ilerlemesini ve/veya komplikasyonların gelişmesini engelleyici veya hayat kurtarıcı yardımcı müdahaleler olarak karşımıza çıkarlar. Stoma açıldıktan sonra iyi ve doğru stoma bakımı yapılması stomanın ömrünü uzatır. Aynı zamanda iyi bir stoma bakımı, komplikasyonların gelişiminin engellenmesine ve/veya oluşmuş komplikasyonların tedavisinin daha kolayca yapılmasına yardımcı olur.`,
    endikasyonlar: [
      { title: 'Stoma Bakım Endikasyonları', content: 'Boşaltmalı torbalar 1/3\'i dolmuş olması, torbanın değişiminde sızıntı olması, ağrı ve cilt tahriş olması, değişim zamanının gelmesi.\n\nENDİKASYONA GÖRE STOMA BAKIMINDA KULLANILAN MALZEMELER VE SIKLIĞI\n• Steril gazlı bez\n• Non-steril eldiven\n• Serum fizyolojik\n• Enjektör\n• Kolostomi torbası (uygun boyda)/adaptörü\n• Kolostomi pastası\n• Yara bakım örtüsü şablon veya ölçüm aracı, kirli torbası (gerekli ise)\n• Makas\nUygulama Sıklığı: Günde 1-2 defa. Bebeğin dışkı miktarına göre değiştirilir.' },
    ],
    endikasyonTablo: [],
    malzemeler: [
      'Steril gazlı bez',
      'Non-steril eldiven',
      'Serum fizyolojik',
      'Enjektör',
      'Kolostomi torbası (uygun boyda)/adaptörü',
      'Kolostomi pastası (kullanımı hekim kararı ile)',
      'Yara bakım örtüsü şablon veya ölçüm aracı, kirli torbası (gerekli ise)',
      'Makas',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
      ]},
      { title: 'İŞLEM', items: [
        'Steril olmayan eldiven giyilir.',
        'İşlem iki kişi tarafından yapılır.',
        'Yenidoğan uygun pozisyon (sırtüstü veya hastaya özgü) verilir.',
        'Takılı olan kolostomi torbası/adaptörü cildi tahriş etmeyecek şekilde nazikçe çıkartılır.',
        'Stoma bölgesi gözlemlenir.',
        'Önceden enjektöre çekilmiş olan serum fizyolojik stoma üzerine sıkılarak stomanın temizliği sağlanır.',
        'Stoma çevresi serum fizyolojikle ıslatılmış steril gazlı bez ile yumuşak hareketlerle atuşman yapılarak silinir. Gerekiyorsa işlem ayrı steril gazlı bez ile tekrarlanır ve kurulanır.',
        'Stomanın çapı ölçülür. Arkasındaki kağıdı çıkartmadan önce torba/adaptör kesilir.',
        'Eğer pasta kullanılacak ise cilde yapıştırılmadan önce bariyer pasta torbanın/adaptörün açıklığının kenarına daire şeklinde uygulanır, kuruması beklenir.',
        'Torbanın/adaptörün kağıdı çıkarılarak stomayı içine alacak şekilde yerleştirilir ve torbanın alt ucu yenidoğanın üst bacağına paralel olacak şekilde cilde yapıştırılır.',
        'Torbanın/adaptörün çevresine parmaklarla 1-2 dakika yavaşça basınç uygulanır.',
        'Torbanın açık kısmı yukarıya doğru katlanarak klembi kapatılır.',
        'Kolostomi torbası boşaltılacağı zaman; bölgeye sızdırmaz örtü serilir, klemp açılıp ölçüm yapılacak malzeme torbanın ağzına yerleştirilir, torba içinde gaita kalmayacak şekilde boşaltılıp silinir. Tekrar klemplenerek sızıntı yönünden kontrol edilir. Boşaltılan gaita ölçülür.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Yenidoğanın başı 30-45 derece yükseltilerek uygun pozisyon (sırtüstü veya hastaya özgü) verilir.',
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Tüm bulgu ve gözlemler kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
      ]},
    ],
    kaynaklar: [
      'Oktav Bosnaklı, Serdar Moralioğlu, Ayşenur Cerrah Celayir, Yenidoğanlarda Stomalar ve Stomalı Yenidoğanın Bakımı, Turkiye Klinikleri J Pediatr Surg-Special Topics. 2017;7(1):63-72',
      'Cahide Ayık, Dilek Özden (2022), Stoma Komplikasyonları ve Hemşirelik Bakımı: Güncel Yaklaşımlar',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Suluhan D., Pars H., (2020), Pediatrik Stomalar Ve Hemşirelik Bakımı, Güneş Tıp Kitabevleri',
      'Bozkurt, G., ve Sönmez Düzkaya, D. (2015). Yenidoğan Protokolleri Kitabı. Nobel Tıp Kitabevi.',
      'Özoğlu, N. (2022). Yenidoğan Yoğun Bakım Hemşirelik Uygulamaları Kitabı. Nobel Tıp Kitabevi.',
      'Oygür, N., Önal, E., ve Zenciroğlu, A. (2021). Türk Neonatoloji Derneği Doğum Salonu Yönetimi Rehberi 2021 Güncellemesi',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Yenidoğan uygun (sırtüstü vaya hastaya özgü) verilir.', 'Takılı olan kolostomi torbası/adaptörü cildi tahriş etmeyecek şekilde nazikçe çıkartılır.', 'Stoma bölgesi gözlemlenir.', 'Önceden enjektöre çekilmiş olan serum fizyolojik stoma üzerine sıkılarak stomanın temizliği sağlanır.', 'Stoma çevresi serum fizyolojikle ıslatılmış steril gazlı bez ile yumuşak hareketlerle atuşman yapılarak silinir. Gerekiyorsa işlem ayrı steril gazlı bez ile tekrarlanır ve kurulanır.', 'Stomanın çapı ölçülür. Arkasındaki kağıdı çıkartmadan önce torba/adaptör kesilir.', 'Eğer pasta kullanılacak ise bariyer pasta torbanın/adaptörün açıklığının kenarına daire şeklinde uygulanır, kuruması beklenir.', 'Torbanın/adaptörün kağıdı çıkarılarak stomayı içine alacak şekilde yerleştirilir ve cilde yapıştırılır.', 'Torbanın/adaptörün çevresine parmaklarla 1-2 dakika yavaşça basınç uygulanır.', 'Torbanın açık kısmı yukarıya doğru katlanarak klembi kapatılır.', 'Kolostomi torbası boşaltılacağı zaman; bölgeye sızdırmaz örtü serilir, klemp açılıp ölçüm yapılacak malzeme torbanın ağzına yerleştirilir, torba içinde gaita kalmayacak şekilde boşaltılıp silinir. Tekrar klemplenerek sızıntı yönünden kontrol edilir. Boşaltılan gaita ölçülür.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen nemlendirici uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
};

Object.assign(protocolDetails, stomaProtocolData);

const pozisyonProtocolData = {
  pozisyon: {
    name: 'Yenidoğana Pozisyon Verme',
    icon: '↔️',
    color: '#8B5CF6',
    onem: `Fetüs için normal yaşam ortamı anne karnıdır ve intrauterin ortam ile burada yer alan yapılar fetüsün büyüme-gelişmesinde önemli bir role sahiptir. İntrauterin yaşam ortamlarından zamanından önce ayrılan prematüre bebekler, yenidoğan yoğun bakım ünitesi (YYBÜ) gibi oldukça farklı bir ortamla karşılaşırlar ve buna oryantasyon sağlamaya çalışırlar. Bu süreç içerisinde prematüre bebeklerin nörolojik ve fonksiyonel bozukluklarına yönelik davranış organizasyonunu sağlamada "Bireyselleştirilmiş Gelişimsel Bakım (BGB)" uygulamalarından yararlanılmaktadır.
Prematüre bebekler; vücut sistemlerinin immatür olması ve gelişimleri için uygun olmayan ekstrauterin yaşam ortamına ayak uydurmaya çalışmaları nedeniyle YYBÜ'ne alındıkları ilk zamanlarda yoğun stres yaşarlar. Gelişimsel bakım uygulamaları ile stres yaratan uyaranların azaltılması hedeflenmektedir. Yenidoğanlar bu dönemde merkezi sinir sistemi ve diğer sistemlerinin işlevselliğinin sürdürülmesi için özel pozisyonlarda yatırılmaya ihtiyaç duymaktadırlar.
YYBÜ'nde pozisyon uygulamalarının temel amacı; bebeklerin tedavi ve bakım kaynaklı girişimlerinin sebep olduğu ağrı/acıdan ve çevreden kaynaklanan uyaranlardan en az düzeyde etkilenmelerini sağlamak, aynı zamanda postürlerini koruyarak stresle baş etme mekanizmalarını geliştirmektir.
**Bireyselleştirilmiş Gelişimsel Bakım ve Pozisyon Uygulamaları**
YYBÜ'nde gelişimsel destekleyici bakımın uygulamasında BGB uygulamalarının klinik açıdan birçok fayda sağladığı bilinmektedir. Gelişimsel pozisyon verme uygulamaları, bebeğin anne karnındaki fleksiyon postüründe, orta hatta, çevrelenmiş ve konforlu pozisyonunu koruyarak YYBÜ'deki bebeklerin nöromotor gelişimini desteklemeyi ve oluşabilecek problemleri azaltmayı amaçlamaktadır.
**Yanlış Pozisyonların Gelişimsel Etkileri**
Yenidoğan yoğun bakımda takip edilen yenidoğanlarda kullanılan tüm pozisyonlar (doğru- yanlış) nörodavranışsal organizasyon, kas iskelet sistemi gelişimi ve beslenme performansını etkilemektedir. Etkisiz pozisyon, kafatasında düzleşme veya değişik kafa şekillerinin ortaya çıkmasına yol açarken, prematüre bebekleri destekleyecek pozisyonların verilmemesinin fizyolojik stabilitenin azalmasına, bebeğin stres düzeyinin artmasına neden olacağı belirtilmektedir.
**Gelişimsel Destekleyici Pozisyon Uygulamaları**
BGB kavramlarından gelişimsel destekleyici pozisyon uygulamaları ile yenidoğanlara prone pozisyonu, yan yatış pozisyonu, supine ve cenin pozisyonu verilmektedir.
`,
    endikasyonlar: [
      { title: 'Pozisyon Verme Endikasyonları', content: 'Huzursuzluk, hareket kısıtlılığı, ağrı, satürasyon düzeyleri, basınç yarası, mekanik ventilatöre bağlı olması.\n\nENDİKASYONA GÖRE POZİSYON VERMEDE KULLANILAN MALZEMELER VE SIKLIĞI\n• Non-steril eldiven\n• Bebek yuvası/temiz çarşaf\n• Basınç yarası engelleyici materyaller (pozisyon yastıkları/yatağı, jel simit/yatağı)\nUygulama Sıklığı: 2-3 saatte bir pozisyon verilir.' },
    ],
    endikasyonTablo: [],
    malzemeler: [
      'Non-steril eldiven',
      'Bebek yuvası/temiz çarşaf',
      'Basınç yarası engelleyici materyaller (pozisyon yastıkları/yatağı, jel simit/yatağı)',
    ],
    uygulamaAdimlari: [
      { title: 'İŞLEM ÖNCESİ HAZIRLIK', items: [
        'Malzemeler hazırlanır.',
        'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.',
        'Yenidoğanın ailesi yanında ise işlem hakkında bilgi verilir.',
      ]},
      { title: 'İŞLEM', items: [
        'Steril olmayan eldiven giyilir.',
        'Yatak çarşafı değiştirilirken yenidoğan sarsılmadan hafif kaldırılır, altındaki kirli çarşafları uzaklaştırılır ve temiz çarşafı serilir. Gerekli ise jel yatak kullanılır ve üzerine çarşaf serilir.',
        'Preterm yenidoğanlara yuva hazırlanır ve çarşaf değişiminde yerleştirilir.',
        'Yenidoğan ventilatöre bağlı ise entübasyon tüpünün çıkması, kullanılan araçların kablolarının altında kalmasını önlenir.',
        'Gerekli ise koruyucu jel simit yenidoğanın kulağının altına gelecek şekilde yerleştirilir.',
        'Gerekli ise omuzlarının altına ince bir çarşaf yerleştirilerek hafif ekstansiyona getirilir.',
      ]},
      { title: 'İŞLEM SONRASI', items: [
        'Atık malzemeler hastane atıklarının toplanması ve uzaklaştırılması, Hastane Atık Yönetim Planına göre yapılır.',
        'Eller, El Hijyeni Talimatı ve El Hijyeni Politikasına göre yıkanır.',
        'Tüm bulgu ve gözlemler kayıt edilir.',
        'Elde edilen veriler ekip üyeleri ile paylaşılır.',
        'Pozisyonlama ve destek malzemesi yerleşimi, postmenstüral yaşa bağlı olarak havlular veya matlar kullanılarak yapılır. DGY (Düzeltilmiş Gestasyonel Yaş) anlamına gelir.',
      ]},
    ],
    kaynaklar: [
      'Gamzegül Altay, 2021, Yenidoğan Yoğun Bakım Ünitesinde Yatan Bebeğe Pozisyon Verme Uygulamaları, Genel Sağlık Bilimleri Dergisi',
      'Taş Arslan, F., & Akkoyun, S. (2019). Yenidoğan Yoğun Bakım Ünitesinde Gelişimsel Bakım Model ve Uygulamaları. Gümüşhane Üniversitesi Sağlık Bilimleri Dergisi, 8(4), 468-473.',
      'Arpacı, T., & Altay, N. (2017). Yenidoğan Yoğun Bakım Ünitelerinde Bireyselleştirilmiş Gelişimsel Bakım: Güncel Yaklaşımlar. Türkiye Klinikleri Hemşirelik Bilimleri, 9(3), 245-254.',
      'Eras, Z., Atay, G., Şakrucu, E. D., Bingöler, E. B., & Dilmen, U. (2013). Yenidoğan yoğun bakım ünitesinde gelişimsel destek. Şişli Etfal Hastanesi Tıp Bülteni, 47(3), 97-103.',
      'Hastane Atık Yönetim Planı. (Kurumsal Doküman)',
      'El Hijyeni Talimatı. (Kurumsal Doküman)',
      'El Hijyeni Politikası. (Kurumsal Doküman)',
      'Bozkurt, G., ve Sönmez Düzkaya, D. (2015). Yenidoğan Protokolleri Kitabı. Nobel Tıp Kitabevi.',
      'Özoğlu, N. (2022). Yenidoğan Yoğun Bakım Hemşirelik Uygulamaları Kitabı. Nobel Tıp Kitabevi.',
      'Oygür, N., Önal, E., ve Zenciroğlu, A. (2021). Türk Neonatoloji Derneği Doğum Salonu Yönetimi Rehberi 2021 Güncellemesi',
    ],
    algoritmaAdimlari: [
      { title: 'HAZIRLIK AŞAMASI', items: ['Gerekli malzemeler hazırlanır.', 'Eller el hijyeni talimatı ve el hijyeni politikasına göre yıkanır.'] },
      { title: 'UYGULAMA AŞAMASI', items: ['Steril olmayan eldiven giyilir.', 'Yatak çarşafı değiştirilirken yenidoğan sarsılmadan hafif kaldırılır, altındaki kirli çarşafları uzaklaştırılır ve temiz çarşafı serilir. Gerekli ise jel yatak kullanılır ve üzerine çarşaf serilir.', 'Preterm yenidoğanlara yuva hazırlanır ve çarşaf değişiminde yerleştirilir.', 'Yenidoğan ventilatöre bağlı ise entübasyon tüpünün çıkması, kullanılan araçların kablolarının altında kalmasını önlenir.', 'Gerekli ise koruyucu jel simit yenidoğanın kulağının altına gelecek şekilde yerleştirilir.', 'Gerekli ise omuzlarının altına ince bir çarşaf yerleştirilerek hafif ekstansiyona getirilir.'] },
      { title: 'İLAÇ UYGULAMA', items: ['Order edilen nemlendirici uygulanır.'] },
      { title: 'KORUYUCU UYGULAMALAR', items: ['İşlem sonrası el hijyeni sağlanır.'] },
      { title: 'KAYIT', items: ['Tüm uygulamalar kayıt altına alınır.'] },
    ],
  },
};
Object.assign(protocolDetails, pozisyonProtocolData);

// COMPONENTS

// COMPONENTS

// İç sayfa header - geri, başlık, ana sayfa, arama
const DetailHeader = ({ title, onBack, onHome, onSearch, darkMode, setDarkMode }) => (
  <div className={`${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border-b px-4 py-3 sticky top-0 z-20 transition-colors duration-300`}>
    <div className="flex items-center gap-3">
      <button onClick={onBack} className={`p-2 -ml-2 ${darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}`}>
        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>
      <h1 className={`text-lg font-semibold flex-1 truncate ${darkMode ? 'text-white' : 'text-gray-800'}`}>{title}</h1>
      {/* Gece Modu Toggle */}
      <button 
        onClick={() => setDarkMode(!darkMode)} 
        className={`p-2 rounded-lg transition-all ${darkMode ? 'text-yellow-400 hover:bg-gray-700' : 'text-gray-500 hover:bg-gray-100'}`} 
        title={darkMode ? 'Gündüz Modu' : 'Gece Modu'}
      >
        {darkMode ? (
          <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="5"/><path d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
          </svg>
        ) : (
          <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>
          </svg>
        )}
      </button>
      <button onClick={onHome} className={`p-2 rounded-lg ${darkMode ? 'text-gray-400 hover:text-emerald-400 hover:bg-gray-700' : 'text-gray-500 hover:text-emerald-600 hover:bg-gray-100'}`} title="Ana Sayfa">
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      </button>
      <button onClick={onSearch} className={`p-2 rounded-lg ${darkMode ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'}`} title="Ara">
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" />
          <path d="M21 21l-4.35-4.35" />
        </svg>
      </button>
    </div>
  </div>
);

const MainProtocolCard = ({ item, isSelected, onClick, darkMode }) => (
  <button
    onClick={onClick}
    className={`p-3 rounded-xl border-2 text-center transition-all ${isSelected ? 'shadow-md' : ''}`}
    style={{ 
      borderColor: isSelected ? item.color : (darkMode ? '#374151' : '#E5E7EB'),
      backgroundColor: isSelected ? `${item.color}15` : (darkMode ? '#1F2937' : 'white')
    }}
  >
    <div className="text-2xl mb-1">{item.icon}</div>
    <div className={`text-sm font-semibold leading-tight ${darkMode ? 'text-white' : 'text-gray-800'}`}>{item.title}</div>
    <div className={`text-sm mt-0.5 ${darkMode ? 'text-gray-400' : 'text-gray-400'}`}>{item.count}</div>
  </button>
);

const AllProtocolsButton = ({ isSelected, onClick, darkMode }) => (
  <button
    onClick={onClick}
    className={`p-3 rounded-xl border-2 text-center transition-all ${
      isSelected 
        ? darkMode 
          ? 'border-emerald-400 bg-emerald-900/50' 
          : 'border-gray-800 bg-gray-800'
        : darkMode 
          ? 'border-gray-700 bg-gray-800' 
          : 'border-gray-200 bg-white'
    }`}
  >
    <div className="text-2xl mb-1">📋</div>
    <div className={`text-sm font-semibold leading-tight ${isSelected ? (darkMode ? 'text-emerald-300' : 'text-white') : darkMode ? 'text-white' : 'text-gray-800'}`}>Tüm Protokoller</div>
    <div className={`text-sm mt-0.5 ${isSelected ? (darkMode ? 'text-emerald-400' : 'text-gray-300') : darkMode ? 'text-gray-400' : 'text-gray-400'}`}>21</div>
  </button>
);

const SectionAccordion = ({ title, count, isOpen, onToggle, color, children, darkMode, theme }) => (
  <div className="mb-3">
    <button
      onClick={onToggle}
      className={`w-full flex items-center justify-between px-4 py-3 ${theme?.bgCard || 'bg-white'} border ${theme?.border || 'border-gray-200'} hover:bg-opacity-80 transition-all`}
      style={{ borderRadius: isOpen ? '12px 12px 0 0' : 12, borderBottom: isOpen ? 'none' : undefined }}
    >
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}15` }}>
          <span className="text-sm">{isOpen ? '📂' : '📁'}</span>
        </div>
        <span className={`font-semibold ${theme?.text || 'text-gray-800'}`}>{title}</span>
        <span className={`text-sm ${darkMode ? 'bg-gray-700 text-gray-400' : 'bg-gray-100 text-gray-500'} px-2 py-0.5 rounded-full`}>{count}</span>
      </div>
      <svg width="20" height="20" fill="none" stroke={darkMode ? '#9CA3AF' : '#9CA3AF'} strokeWidth="2" className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}>
        <path d="M6 9l6 6 6-6" />
      </svg>
    </button>
    {isOpen && (
      <div className={`${theme?.bgCard || 'bg-white'} border border-t-0 ${theme?.border || 'border-gray-200'} rounded-b-xl overflow-hidden`}>
        {children}
      </div>
    )}
  </div>
);

// SEARCH OVERLAY
const SearchOverlay = ({ isOpen, onClose, onSelectProtocol, onSelectAlgorithm, darkMode, theme }) => {
  const [query, setQuery] = useState('');
  
  if (!isOpen) return null;
  
  const searchTerm = query.toLowerCase().trim();
  const filteredProtocols = searchTerm ? subProtocols.filter(p => p.name.toLowerCase().includes(searchTerm)) : [];
  const filteredAlgorithms = searchTerm ? algorithms.filter(a => a.name.toLowerCase().includes(searchTerm)) : [];
  const hasResults = filteredProtocols.length > 0 || filteredAlgorithms.length > 0;
  
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex flex-col">
      <div className={darkMode ? 'bg-gray-800' : 'bg-white'}>
        <div className={`flex items-center gap-3 px-4 py-3 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
          <button onClick={onClose} className={`p-2 -ml-2 ${darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}`}>
            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <div className="flex-1 relative">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Protokol veya algoritma ara..."
              className={`w-full py-2 px-4 pr-10 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500 ${
                darkMode 
                  ? 'bg-gray-700 text-gray-100 placeholder-gray-400' 
                  : 'bg-gray-100 text-gray-800 placeholder-gray-400'
              }`}
              autoFocus
            />
            {query && (
              <button onClick={() => setQuery('')} className={`absolute right-3 top-1/2 -translate-y-1/2 ${darkMode ? 'text-gray-500 hover:text-gray-300' : 'text-gray-400 hover:text-gray-600'}`}>
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 6l12 12M6 18L18 6" />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
      
      <div className={`flex-1 overflow-y-auto ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
        {!searchTerm && (
          <div className={`p-8 text-center ${darkMode ? 'text-gray-400' : 'text-gray-400'}`}>
            <div className="text-4xl mb-3">🔍</div>
            <p>Protokol veya algoritma adı yazın</p>
          </div>
        )}
        
        {searchTerm && !hasResults && (
          <div className={`p-8 text-center ${darkMode ? 'text-gray-400' : 'text-gray-400'}`}>
            <div className="text-4xl mb-3">😕</div>
            <p>"{query}" için sonuç bulunamadı</p>
          </div>
        )}
        
        {filteredProtocols.length > 0 && (
          <div className="p-4">
            <h3 className={`text-sm font-semibold uppercase tracking-wide mb-2 px-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Protokoller ({filteredProtocols.length})</h3>
            <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
              {filteredProtocols.map(item => (
                <button key={item.id} onClick={() => { onSelectProtocol(item); onClose(); }} className={`w-full flex items-center gap-3 px-4 py-3 border-b last:border-b-0 text-left ${darkMode ? 'hover:bg-gray-700 border-gray-700' : 'hover:bg-gray-50 border-gray-100'}`}>
                  <span className="text-xl w-8 text-center">{item.icon}</span>
                  <span className={`flex-1 ${darkMode ? 'text-white' : 'text-gray-700'}`}>{item.name}</span>
                  <svg width="18" height="18" fill="none" stroke={darkMode ? '#6B7280' : '#D1D5DB'} strokeWidth="2"><path d="M7 4l5 5-5 5" /></svg>
                </button>
              ))}
            </div>
          </div>
        )}
        
        {filteredAlgorithms.length > 0 && (
          <div className="p-4 pt-0">
            <h3 className={`text-sm font-semibold uppercase tracking-wide mb-2 px-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Algoritmalar ({filteredAlgorithms.length})</h3>
            <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
              {filteredAlgorithms.map(item => (
                <button key={item.id} onClick={() => { onSelectAlgorithm(item); onClose(); }} className={`w-full flex items-center gap-3 px-4 py-3 border-b last:border-b-0 text-left ${darkMode ? 'hover:bg-gray-700 border-gray-700' : 'hover:bg-blue-50 border-gray-100'}`}>
                  <div className="w-8 h-8 rounded-lg flex items-center justify-center text-sm flex-shrink-0" style={{ backgroundColor: `${item.color}12` }}>{item.icon}</div>
                  <span className={`flex-1 text-sm ${darkMode ? 'text-white' : 'text-gray-700'}`}>{item.name}</span>
                  <span className="text-sm px-2 py-1 rounded-full bg-blue-100 text-blue-600 font-medium">Aç</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const SubProtocolRow = ({ item, onClick, darkMode, theme }) => (
  <button onClick={onClick} className={`w-full flex items-center gap-3 px-4 py-3 ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'} border-b ${darkMode ? 'border-gray-700' : 'border-gray-100'} last:border-b-0 text-left transition-colors`}>
    <span className="text-xl w-8 text-center">{item.icon}</span>
    <span className={`flex-1 ${darkMode ? 'text-white' : 'text-gray-700'}`}>{item.name}</span>
    <svg width="18" height="18" fill="none" stroke={darkMode ? '#6B7280' : '#D1D5DB'} strokeWidth="2"><path d="M7 4l5 5-5 5" /></svg>
  </button>
);

const AlgorithmRow = ({ item, onClick, darkMode, theme }) => (
  <button onClick={onClick} className={`w-full flex items-center gap-3 px-4 py-3 ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-blue-50'} border-b ${darkMode ? 'border-gray-700' : 'border-gray-100'} last:border-b-0 text-left transition-colors`}>
    <div className="w-8 h-8 rounded-lg flex items-center justify-center text-sm flex-shrink-0" style={{ backgroundColor: `${item.color}12` }}>{item.icon}</div>
    <span className={`flex-1 text-sm ${darkMode ? 'text-white' : 'text-gray-700'}`}>{item.name}</span>
    <svg width="18" height="18" fill="none" stroke={darkMode ? '#6B7280' : '#D1D5DB'} strokeWidth="2"><path d="M7 4l5 5-5 5" /></svg>
  </button>
);

const TabButton = ({ active, onClick, children, color }) => (
  <button
    onClick={onClick}
    className={`flex-1 py-3 text-sm font-semibold transition-all border-b-2 ${active ? 'text-white' : 'text-gray-500 border-transparent bg-gray-50'}`}
    style={active ? { backgroundColor: color, borderColor: color } : {}}
  >
    {children}
  </button>
);

const AccordionItem = ({ title, content, isOpen, onToggle, color, index, darkMode }) => (
  <div className={`border-b last:border-b-0 ${darkMode ? 'border-gray-700' : 'border-gray-100'}`}>
    <button onClick={onToggle} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
      <div className="flex items-center gap-3">
        <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: color }}>{index + 1}</span>
        <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{title}</span>
      </div>
      <svg width="20" height="20" fill="none" stroke={color} strokeWidth="2" className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}>
        <path d="M6 9l6 6 6-6" />
      </svg>
    </button>
    {isOpen && <div className={`px-4 pb-4 pl-14 text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>{content}</div>}
  </div>
);

const ListItem = ({ children, color, darkMode }) => (
  <div className="flex items-start gap-3 py-2">
    <span className="w-2 h-2 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: color }} />
    <span className={`text-sm ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>{children}</span>
  </div>
);

// HOME SCREEN - Header yok, arama hastane kısmında
const HomeScreen = ({ onSelectProtocol, onSelectAlgorithm, selectedMainId, onSelectMain, algorithmsOpen, setAlgorithmsOpen, protocolsOpen, setProtocolsOpen, darkMode, setDarkMode, theme }) => {
  const [searchOpen, setSearchOpen] = useState(false);
  
  const filteredSubs = selectedMainId ? subProtocols.filter(s => s.parentId === selectedMainId) : subProtocols;
  const filteredAlgorithms = selectedMainId
    ? algorithms.filter(a => { const parent = mainProtocols.find(m => m.id === selectedMainId); return a.color === parent?.color; })
    : algorithms;

  const handleSelectMain = (id) => {
    if (id === null) {
      setAlgorithmsOpen(true);
      setProtocolsOpen(true);
    } else {
      setAlgorithmsOpen(true);
      setProtocolsOpen(true);
    }
    onSelectMain(id);
  };

  return (
    <div className={`flex-1 flex flex-col min-h-full ${theme.bgSecondary} transition-colors duration-300`}>
      {/* Search Overlay */}
      <SearchOverlay 
        isOpen={searchOpen} 
        onClose={() => setSearchOpen(false)} 
        onSelectProtocol={onSelectProtocol} 
        onSelectAlgorithm={onSelectAlgorithm}
        darkMode={darkMode}
        theme={theme}
      />
      
      {/* Hospital Header - Arama ve Gece Modu sağda */}
      <div className={`${darkMode ? 'bg-gradient-to-r from-gray-800 to-gray-700' : ''} px-4 py-4 transition-colors duration-300`} style={!darkMode ? { background: 'linear-gradient(to right, #7d69bb, #7e22ce)' } : {}}>
        <div className="flex items-center gap-3">
          <div className={`w-11 h-11 ${darkMode ? 'bg-gray-600' : 'bg-white/20'} rounded-xl flex items-center justify-center text-xl`}>🏢</div>
          <div className="flex-1">
            <h2 className="text-white font-bold">SNH</h2>
            <p className="text-white/80 text-sm">Yenidoğan Yoğun Bakım Protokolleri</p>
          </div>
          {/* Gece Modu Toggle */}
          <button 
            onClick={() => setDarkMode(!darkMode)} 
            className={`p-2 ${darkMode ? 'bg-yellow-500/20 text-yellow-300' : 'bg-white/20 text-white'} rounded-lg hover:bg-white/30 transition-all`} 
            title={darkMode ? 'Gündüz Modu' : 'Gece Modu'}
          >
            {darkMode ? (
              <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" stroke="currentColor" strokeWidth="2" fill="none"/>
              </svg>
            ) : (
              <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24">
                <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" stroke="currentColor" strokeWidth="2" fill="none"/>
              </svg>
            )}
          </button>
          <button onClick={() => setSearchOpen(true)} className={`p-2 ${darkMode ? 'bg-gray-600' : 'bg-white/20'} rounded-lg text-white hover:bg-white/30 transition-all`} title="Ara">
            <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8" />
              <path d="M21 21l-4.35-4.35" />
            </svg>
          </button>
        </div>
      </div>

      {/* Ana Protokoller - 2 SATIR GRİD */}
      <div className={`px-4 py-3 ${theme.bgCard} ${theme.border} border-b transition-colors duration-300`}>
        <h3 className={`text-sm font-semibold ${theme.textSecondary} uppercase tracking-wide mb-3`}>Ana Protokoller</h3>
        <div className="grid grid-cols-3 gap-2">
          <AllProtocolsButton isSelected={selectedMainId === null} onClick={() => handleSelectMain(null)} darkMode={darkMode} />
          {mainProtocols.map(item => (
            <MainProtocolCard key={item.id} item={item} isSelected={selectedMainId === item.id} onClick={() => handleSelectMain(item.id)} darkMode={darkMode} />
          ))}
        </div>
      </div>

      <div className="px-4 pt-4 pb-0">
        {/* Algoritmalar */}
        <SectionAccordion title="Algoritmalar" count={filteredAlgorithms.length} isOpen={algorithmsOpen} onToggle={() => setAlgorithmsOpen(!algorithmsOpen)} color="#3B82F6" darkMode={darkMode} theme={theme}>
          {filteredAlgorithms.map(item => <AlgorithmRow key={item.id} item={item} onClick={() => onSelectAlgorithm(item)} darkMode={darkMode} theme={theme} />)}
        </SectionAccordion>

        {/* Alt Protokoller */}
        <SectionAccordion
          title={selectedMainId ? `${mainProtocols.find(m => m.id === selectedMainId)?.title} Protokolleri` : 'Alt Protokoller'}
          count={filteredSubs.length} isOpen={protocolsOpen} onToggle={() => setProtocolsOpen(!protocolsOpen)} color="#10B981" darkMode={darkMode} theme={theme}
        >
          {filteredSubs.map(item => <SubProtocolRow key={item.id} item={item} onClick={() => onSelectProtocol(item)} darkMode={darkMode} theme={theme} />)}
        </SectionAccordion>
      </div>
      
      {/* Spacer - footer'ı en alta itmek için */}
      <div className="flex-grow"></div>
      
      {/* Footer - Hazırlayan - Her zaman en altta */}
      <div className="text-center pb-1.5">
        <link href="https://fonts.googleapis.com/css2?family=Marck+Script&display=swap" rel="stylesheet" />
        <span 
          className={`text-sm ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}
          style={{ fontFamily: "'Marck Script', cursive", fontWeight: 600 }}
        >
          fim
        </span>
        <span className={`${darkMode ? 'text-red-400/50' : 'text-red-300/70'} text-sm ml-0.5`}>♥</span>
      </div>
    </div>
  );
};

// DETAIL SCREEN - Protokol tabında tüm accordionlar açık
const DetailScreen = ({ protocol, onBack, onHome, onSelectProtocol, onSelectAlgorithm, initialTab = 0, selectedAlgorithm = null, darkMode, setDarkMode, theme, scrollToTop }) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [searchOpen, setSearchOpen] = useState(false);
  const scrollRef = React.useRef(null);
  const [openAccordions, setOpenAccordions] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
  const [endikasyonListOpen, setEndikasyonListOpen] = useState(true);
  const [endikasyonTabloOpen, setEndikasyonTabloOpen] = useState(true);
  const [stomaEndikasyonOpen, setStomaEndikasyonOpen] = useState([true, true]);
  const [pozisyonEndikasyonOpen, setPozisyonEndikasyonOpen] = useState([true, true, true]);

  // Protocol değişince en üste scroll
  useEffect(() => {
    setActiveTab(initialTab);
    if (scrollToTop) scrollToTop();
  }, [protocol.id, initialTab, scrollToTop]);

  // Tab değişiminde en üste scroll
  const handleTabChange = (i) => {
    setActiveTab(i);
    if (scrollToTop) scrollToTop();
  };
  
  // Pozisyon algoritması için selectedAlgorithm'a göre accordion ayarla
  useEffect(() => {
    if (protocol.id === 'pozisyon') {
      if (selectedAlgorithm && selectedAlgorithm.match(/^\d+$/)) {
        const accordionIdx = parseInt(selectedAlgorithm);
        setOpenAccordions([49, 50, 51, 52, 53, accordionIdx]);
      } else {
        setOpenAccordions([0, 1, 2, 3, 4, 5, 6, 7, 8, 49, 50, 51, 52, 53, 60, 61, 62, 63, 64]);
      }
    }
  }, [protocol.id, selectedAlgorithm]);

  const toggleAccordion = (index) => {
    setOpenAccordions(openAccordions.includes(index) ? openAccordions.filter(i => i !== index) : [...openAccordions, index]);
  };

  const detail = protocolDetails[protocol.id];
  const isNewFormat = detail && (detail.onem || detail.endikasyonlar);
  
  const tabs = protocol.id === 'stoma'
        ? ['Protokol', 'Endikasyonlar', 'Algoritma']
        : protocol.id === 'pozisyon'
          ? ['Protokol', 'Endikasyonlar', 'Pozisyonlar', 'Algoritma']
          : protocol.id === 'ng'
            ? ['Protokol', 'Endikasyonlar', 'NG Kontrol', 'Algoritma']
            : protocol.id === 'fizyoterapi'
              ? ['Protokol', 'Endikasyon - Teknik - Amaç', 'Diğer Teknikler']
              : protocol.id === 'beyin'
                ? ['Protokol', 'Aileye Yönelik Bakım', 'Algoritma']
                : ['Protokol', 'Endikasyonlar', 'Algoritma'];

  const oldFormatDetail = !isNewFormat ? (detail || { name: protocol.name, icon: protocol.color, color: protocol.color, malzemeler: [], uygulamaAdimlari: [], kaynaklar: [] }) : null;

  const hasKomplikasyonlar = detail?.komplikasyonlar && detail.komplikasyonlar.length > 0;
  const hasDegerlendirme = detail?.degerlendirme && detail.degerlendirme.length > 0;
  const hasEvrelendirme = detail?.evrelendirme && detail.evrelendirme.length > 0;
  const hasOnleme = detail?.onleme && detail.onleme.length > 0;
  const hasOlcekler = detail?.olcekler && detail.olcekler.length > 0;

  let extraSections = 0;
  if (hasKomplikasyonlar) extraSections += 1;
  if (hasDegerlendirme) extraSections += 1;
  if (hasEvrelendirme) extraSections += 1;
  if (hasOnleme) extraSections += 1;
  if (hasOlcekler) extraSections += 1;
  
  if (protocol.id === 'stoma' && !detail.uygulamaAdimlari) extraSections -= 1;

  const accordionCount = isNewFormat ? (5 + extraSections) : (oldFormatDetail?.protokolBasliklari?.length || 4);

  // Soft Algoritma Flowchart bileşeni - Göz yormayan pastel renkler
  const AlgorithmFlowchart = ({ steps, color }) => (
    <div className="space-y-3">
      {steps?.map((step, idx) => (
        <div key={idx} className="flex flex-col items-center">
          {/* Step Box - Protokol rengiyle soft pastel arka plan */}
          <div className={`w-full rounded-xl p-4 shadow-sm ${darkMode ? 'bg-gray-800' : 'bg-white'}`} style={{ border: `2px solid ${color}40` }}>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold text-white" style={{ backgroundColor: color }}>{idx + 1}</span>
              <h4 className="font-semibold text-sm" style={{ color: color }}>{step.title}</h4>
            </div>
            <div className="space-y-1.5 pl-10">
              {step.items?.map((item, i) => {
                const isHeader = item === 'Cilt Özelliği:' || item === 'Yapılacak Uygulamalar:';
                return isHeader ? (
                  <p key={i} className="text-sm font-bold mt-2 mb-0.5" style={{ color: color }}>{item}</p>
                ) : (
                  <div key={i} className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: color }}></span>
                    <p className={`text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>{item}</p>
                  </div>
                );
              })}
            </div>
          </div>
          {/* Arrow - Protokol rengiyle soft ok */}
          {idx < steps.length - 1 && (
            <div className="flex flex-col items-center py-1">
              <div className="w-0.5 h-4" style={{ backgroundColor: `${color}60` }}></div>
              <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                <path d="M6 8L0 0H12L6 8Z" style={{ fill: `${color}60` }}/>
              </svg>
            </div>
          )}
        </div>
      ))}
    </div>
  );

  return (
    <div className={`flex-1 flex flex-col ${darkMode ? 'bg-gray-900' : 'bg-gray-50'} transition-colors duration-300`}>
      <DetailHeader title={protocol.name} onBack={onBack} onHome={onHome} onSearch={() => setSearchOpen(true)} darkMode={darkMode} setDarkMode={setDarkMode} />
      
      {/* Search Overlay */}
      <SearchOverlay 
        isOpen={searchOpen} 
        onClose={() => setSearchOpen(false)} 
        onSelectProtocol={(p) => { setSearchOpen(false); onSelectProtocol(p); }} 
        onSelectAlgorithm={(a) => { setSearchOpen(false); onSelectAlgorithm(a); }}
        darkMode={darkMode}
        theme={theme}
      />
      
      <div ref={scrollRef} className="flex-1 flex flex-col">
        {/* Protocol Header */}
        <div className="px-4 py-5" style={{ backgroundColor: darkMode ? `${protocol.color}15` : `${protocol.color}10` }}>
          <div className="flex items-center gap-4">
            <div className={`w-14 h-14 rounded-2xl flex items-center justify-center text-2xl shadow-sm ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>{protocol.icon}</div>
            <div className="flex-1">
              <h2 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}>{protocol.name}</h2>
              <p className="text-sm mt-0.5" style={{ color: protocol.color }}>{mainProtocols.find(m => m.id === protocol.parentId)?.title} Protokolü</p>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className={`flex ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border-b`}>
          {tabs.map((tab, i) => (
            <button
              key={tab}
              onClick={() => handleTabChange(i)}
              className={`flex-1 py-3 px-4 text-sm font-semibold transition-all border-b-2 ${
                activeTab === i 
                  ? 'text-white' 
                  : darkMode 
                    ? 'text-gray-400 border-transparent bg-gray-800' 
                    : 'text-gray-500 border-transparent bg-gray-50'
              }`}
              style={activeTab === i ? { backgroundColor: protocol.color, borderColor: protocol.color } : {}}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="px-4 pt-4 pb-0">
          {/* BEYİN ÖLÜMÜ PROTOKOLÜ İÇİN ÖZEL YAPI */}
          {activeTab === 0 && protocol.id === 'beyin' && isNewFormat && (
            <div className="space-y-4">

              {/* 1. TANIM */}
              {[0].map(idx => (
                <div key={idx} className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  <button onClick={() => toggleAccordion(idx)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>1</span>
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{detail.beyinTanim?.baslik}</span>
                    </div>
                    <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(idx) ? 'rotate-180' : ''}`}><path d="M6 9l6 6 6-6" /></svg>
                  </button>
                  {openAccordions.includes(idx) && (
                    <div className={`px-4 pb-4 pl-14 text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                      {detail.beyinTanim?.icerik}
                    </div>
                  )}
                </div>
              ))}

              {/* 2. TANI KRİTERLERİ - Özel render */}
              <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <button onClick={() => toggleAccordion(1)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                  <div className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>2</span>
                    <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{detail.beyinKriterler?.baslik}</span>
                  </div>
                  <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(1) ? 'rotate-180' : ''}`}><path d="M6 9l6 6 6-6" /></svg>
                </button>
                {openAccordions.includes(1) && (
                  <div className={`px-4 pb-4 pl-14 text-sm leading-relaxed space-y-3 ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                    <p>{detail.beyinKriterler?.giris}</p>
                    {/* Üç ana bulgu - BOLD */}
                    <ul className="space-y-1">
                      {detail.beyinKriterler?.ucBulgu?.map((b, i) => (
                        <li key={i} className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                          <span><strong className={darkMode ? 'text-white' : 'text-gray-800'}>{b.bold}</strong>{b.rest}</span>
                        </li>
                      ))}
                    </ul>
                    {/* Ön Koşullar */}
                    <p className={`font-semibold mt-2 ${darkMode ? 'text-white' : 'text-gray-800'}`}>{detail.beyinKriterler?.onKosullarBaslik}</p>
                    <ul className="space-y-1">
                      {detail.beyinKriterler?.onKosullar?.map((m, i) => (
                        <li key={i} className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                          <span>{m}</span>
                        </li>
                      ))}
                    </ul>
                    {/* Tespit maddeler */}
                    <p className={`font-semibold mt-2 ${darkMode ? 'text-white' : 'text-gray-800'}`}>{detail.beyinKriterler?.tespitBaslik}</p>
                    <ul className="space-y-1">
                      {detail.beyinKriterler?.tespitMaddeler?.map((m, i) => (
                        <li key={i}>
                          <div className="flex items-start gap-2">
                            <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                            <span>{m.metin}</span>
                          </div>
                          {m.icMaddeler && (
                            <ul className="ml-6 mt-1 space-y-1">
                              {m.icMaddeler.map((ic, j) => (
                                <li key={j} className="flex items-start gap-2">
                                  <span className="w-1 h-1 rounded-full mt-2 flex-shrink-0 opacity-60" style={{ backgroundColor: protocol.color }}></span>
                                  <span>{ic}</span>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                    {/* Apne testi ve son */}
                    <p className="mt-2">{detail.beyinKriterler?.apneMetni}</p>
                    <p>{detail.beyinKriterler?.sonMetin}</p>
                  </div>
                )}
              </div>

              {/* 3. ÇOCUKLARDA TANI */}
              <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <button onClick={() => toggleAccordion(2)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                  <div className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>3</span>
                    <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{detail.cocukTani?.baslik}</span>
                  </div>
                  <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(2) ? 'rotate-180' : ''}`}><path d="M6 9l6 6 6-6" /></svg>
                </button>
                {openAccordions.includes(2) && (
                  <div className={`px-4 pb-4 pl-14 text-sm leading-relaxed whitespace-pre-line ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                    {detail.cocukTani?.icerik}
                  </div>
                )}
              </div>

              {/* 4. DONÖR BAKIMI - Özel render */}
              <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <button onClick={() => toggleAccordion(3)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                  <div className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>4</span>
                    <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Beyin Ölümü Sürecinde Potansiyel Donörün Bakımı</span>
                  </div>
                  <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(3) ? 'rotate-180' : ''}`}><path d="M6 9l6 6 6-6" /></svg>
                </button>
                {openAccordions.includes(3) && (
                  <div className={`px-4 pb-4 pl-14 text-sm leading-relaxed space-y-3 ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                    <p className="whitespace-pre-line">{detail.donorBakimi?.giris}</p>
                    <p className={`font-semibold ${darkMode ? 'text-white' : 'text-gray-800'}`}>{detail.donorBakimi?.baslik}</p>
                    <ul className="space-y-2">
                      {detail.donorBakimi?.maddeler?.map((m, i) => (
                        <li key={i} className="flex items-start gap-2">
                          <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                          <span><strong className={darkMode ? 'text-white' : 'text-gray-800'}>{m.bold}</strong>{m.rest}</span>
                        </li>
                      ))}
                    </ul>
                    <p>{detail.donorBakimi?.son}</p>
                  </div>
                )}
              </div>

              {/* KAYNAKLAR */}
              <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <button onClick={() => toggleAccordion(4)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                  <div className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>5</span>
                    <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Kaynaklar</span>
                  </div>
                  <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(4) ? 'rotate-180' : ''}`}>
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>
                {openAccordions.includes(4) && (
                  <div className="px-4 pb-4">
                    {detail.kaynaklar?.map((kaynak, i) => (
                      <div key={i} className={`flex items-start gap-3 py-2 border-b last:border-b-0 ${darkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                        <span className="w-5 h-5 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5" style={{ backgroundColor: `${protocol.color}15`, color: protocol.color }}>{i + 1}</span>
                        <p className={`text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>{kaynak}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* DİĞER PROTOKOLLER İÇİN MEVCUT YAPI */}
          {activeTab === 0 && isNewFormat && protocol.id !== 'beyin' && (
            <div className="space-y-4">
              {/* Önemi - Sadece onem varsa göster */}
              {detail.onem && (
              <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <button onClick={() => toggleAccordion(0)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                  <div className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>1</span>
                    <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{protocol.id === 'stoma' ? 'Stoma Nedir?' : protocol.id === 'pozisyon' ? 'Pozisyonlama ve Elevasyonun Önemi' : 'Bakımın Önemi'}</span>
                  </div>
                  <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(0) ? 'rotate-180' : ''}`}>
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>
                {openAccordions.includes(0) && (
                  <div className={`px-4 pb-4 pl-14 text-sm leading-relaxed whitespace-pre-line ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                    {detail.onem?.split('\n').map((line, idx) => {
                      if (line.startsWith('**') && line.endsWith('**')) {
                        return <p key={idx} className={`font-bold mt-3 mb-1 ${darkMode ? 'text-white' : 'text-gray-800'}`}>{line.replace(/\*\*/g, '')}</p>;
                      }
                      if (line.includes('**')) {
                        const parts = line.split(/(\*\*[^*]+\*\*)/g);
                        return (
                          <p key={idx}>
                            {parts.map((part, i) => {
                              if (part.startsWith('**') && part.endsWith('**')) {
                                return <strong key={i} className={darkMode ? 'text-white' : 'text-gray-800'}>{part.replace(/\*\*/g, '')}</strong>;
                              }
                              return part;
                            })}
                          </p>
                        );
                      }
                      return <p key={idx}>{line}</p>;
                    })}
                  </div>
                )}
              </div>
              )}

              {/* Malzemeler */}
              <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <button onClick={() => toggleAccordion(1)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                  <div className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>{detail.onem ? 2 : 1}</span>
                    <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{protocol.id === 'fizyoterapi' ? 'Uygulanan Teknikler' : 'Kullanılan Malzemeler'}</span>
                  </div>
                  <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(1) ? 'rotate-180' : ''}`}>
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>
                {openAccordions.includes(1) && (
                  <div className={detail.malzemelerTablo ? 'px-2 pb-4' : 'px-4 pb-4 pl-14'}>
                    {/* Eğer malzemelerTablo varsa sadece tabloyu göster */}
                    {detail.malzemelerTablo ? (
                      <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                        <div className="overflow-x-auto">
                          <table className="w-full text-sm">
                            <thead>
                              <tr className={darkMode ? 'bg-gray-700' : 'bg-gray-50'}>
                                <th className={`px-2 py-2 text-left font-semibold ${darkMode ? 'text-white' : 'text-gray-700'}`} style={{ color: protocol.color }}>Gerekçe</th>
                                <th className={`px-2 py-2 text-left font-semibold ${darkMode ? 'text-white' : 'text-gray-700'}`} style={{ color: protocol.color }}>Gerekli Malzemeler</th>
                                <th className={`px-2 py-2 text-left font-semibold ${darkMode ? 'text-white' : 'text-gray-700'}`} style={{ color: protocol.color }}>Bakım Aralığı</th>
                              </tr>
                            </thead>
                            <tbody>
                              {detail.malzemelerTablo?.map((row, idx) => (
                                <tr key={idx} className={`border-t ${darkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                                  <td className={`px-2 py-2 align-top text-sm ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>{row.gerekce}</td>
                                  <td className={`px-2 py-2 align-top text-sm ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>
                                    {row.malzemeler?.map((m, j) => (
                                      <div key={j} className="flex items-start gap-1">
                                        <span className="mt-1 w-1 h-1 rounded-full flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                                        <span>{m}</span>
                                      </div>
                                    ))}
                                  </td>
                                  <td className={`px-2 py-2 align-top text-sm font-medium`} style={{ color: protocol.color }}>{row.aralik}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ) : (
                      /* Normal malzeme listesi */
                      detail.malzemeler?.map((item, i) => (
                        <div key={i} className="flex items-start gap-3 py-1.5">
                          <span className="w-2 h-2 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }} />
                          <span className={`text-sm ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>{item}</span>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>

              {/* Uygulama Adımları / NG Tüpü Olan Hastanın Hemşirelik Bakımı - basinc hariç */}
              {protocol.id !== 'stoma' && protocol.id !== 'fizyoterapi' && (
              <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <button onClick={() => toggleAccordion(2)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                  <div className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>{detail.onem ? 3 : 2}</span>
                    <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{protocol.id === 'ng' ? 'NG Tüpü Olan Hastanın Hemşirelik Bakımı' : 'Uygulama Adımları'}</span>
                  </div>
                  <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(2) ? 'rotate-180' : ''}`}>
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>
                {openAccordions.includes(2) && (
                  <div className="px-4 pb-4 pl-14">
                    {(() => {
                      let stepNumber = 0;
                      return detail.uygulamaAdimlari?.map((item, i) => {
                        // Check if item is an object (new format) or string (old format)
                        if (typeof item === 'object' && item.title && item.items) {
                          // New format with title and items array
                          return (
                            <div key={i} className="mb-4">
                              <div className={`font-bold text-sm mb-2 ${darkMode ? 'text-white' : 'text-gray-800'}`} style={{ color: protocol.color }}>
                                {item.title}
                              </div>
                              {item.items?.map((subItem, subIdx) => (
                                <div key={subIdx} className="flex items-start gap-2 py-1 ml-2">
                                  <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }} />
                                  <span className={`text-sm ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>{subItem}</span>
                                </div>
                              ))}
                            </div>
                          );
                        }
                        // Old format - string items
                        const isBoldHeader = item.startsWith('**') && item.endsWith('**');
                        const isBulletPoint = item.startsWith('•');
                        if (isBoldHeader) {
                          return (
                            <div key={i} className={`font-bold text-sm mt-3 mb-1 ${darkMode ? 'text-white' : 'text-gray-800'}`} style={{ color: protocol.color }}>
                              {item.replace(/\*\*/g, '')}
                            </div>
                          );
                        }
                        if (isBulletPoint) {
                          return (
                            <div key={i} className="flex items-start gap-2 py-0.5 ml-6">
                              <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }} />
                              <span className={`text-sm ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>{item.substring(1).trim()}</span>
                            </div>
                          );
                        }
                        stepNumber++;
                        return (
                          <div key={i} className="flex items-start gap-3 py-1.5">
                            <span className="w-5 h-5 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5" style={{ backgroundColor: `${protocol.color}20`, color: protocol.color }}>{stepNumber}</span>
                            <span className={`text-sm ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>{item}</span>
                          </div>
                        );
                      });
                    })()}
                  </div>
                )}
              </div>
              )}

              {/* Uygulama Adımları - Stoma için özel */}
              {protocol.id === 'stoma' && (
              <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <button onClick={() => toggleAccordion(2)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                  <div className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>3</span>
                    <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Uygulama Adımları</span>
                  </div>
                  <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(2) ? 'rotate-180' : ''}`}>
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>
                {openAccordions.includes(2) && (
                  <div className="px-4 pb-4 pl-14">
                    {detail.uygulamaAdimlari?.map((section, i) => (
                      <div key={i} className="mb-4">
                        <div className="font-bold text-sm mb-2" style={{ color: protocol.color }}>{section.title}</div>
                        {section.items?.map((item, j) => (
                          <div key={j} className="flex items-start gap-2 py-1 ml-2">
                            <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }} />
                            <span className={`text-sm ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>{item}</span>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              )}

              {/* Komplikasyonlar - PEG ve stoma için */}
              {detail.komplikasyonlar && detail.komplikasyonlar.length > 0 && (
                <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  <button onClick={() => toggleAccordion(4)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>{protocol.id === 'stoma' ? 3 : 5}</span>
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{protocol.id === 'stoma' ? 'Komplikasyonlar ve Girişimler' : 'Majör Komplikasyonlar'}</span>
                    </div>
                    <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(4) ? 'rotate-180' : ''}`}>
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                  {openAccordions.includes(4) && (
                    <div className="px-4 pb-4 space-y-4">
                      {detail.komplikasyonlar?.map((komplikasyon, i) => (
                        <div key={i} className={`border rounded-lg p-3 ${darkMode ? 'border-gray-700 bg-gray-750' : 'border-gray-200 bg-gray-50'}`}>
                          <h4 className="font-semibold text-sm mb-2" style={{ color: protocol.color }}>{komplikasyon.title}</h4>
                          <p className={`text-sm mb-2 ${darkMode ? 'text-gray-100' : 'text-gray-500'}`}>{komplikasyon.content}</p>
                          <ul className="space-y-1">
                            {komplikasyon.detay?.map((item, j) => {
                              if (item.startsWith('**') && item.endsWith('**')) {
                                return (
                                  <li key={j} className="flex items-start gap-2 text-sm">
                                    <span className="w-1.5 h-1.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                                    <span className={`font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}>{item.replace(/\*\*/g, '')}</span>
                                  </li>
                                );
                              }
                              if (item.startsWith('Nedenleri:')) {
                                const parts = item.split(':');
                                return (
                                  <li key={j} className="flex items-start gap-2 text-sm">
                                    <span className="w-1.5 h-1.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                                    <span><span className={`font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}>{parts[0]}:</span><span className={darkMode ? 'text-gray-100' : 'text-gray-600'}>{parts.slice(1).join(':')}</span></span>
                                  </li>
                                );
                              }
                              return (
                                <li key={j} className="flex items-start gap-2 text-sm">
                                  <span className="w-1.5 h-1.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                                  <span className={darkMode ? 'text-gray-100' : 'text-gray-600'}>{item}</span>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Değerlendirme - Basınç Yaralanması için */}
              {detail.degerlendirme && detail.degerlendirme.length > 0 && (
                <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  <button onClick={() => toggleAccordion(4)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>5</span>
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Basınç Yaralanmasının Tanımlanması ve Değerlendirilmesi</span>
                    </div>
                    <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(4) ? 'rotate-180' : ''}`}>
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                  {openAccordions.includes(4) && (
                    <div className="px-4 pb-4 space-y-4">
                      {detail.degerlendirme?.map((item, i) => (
                        <div key={i} className={`border rounded-lg p-3 ${darkMode ? 'border-gray-700 bg-gray-750' : 'border-gray-200 bg-gray-50'}`}>
                          <h4 className="font-semibold text-sm mb-2" style={{ color: protocol.color }}>{item.title}</h4>
                          {item.content && <p className={`text-sm mb-2 ${darkMode ? 'text-gray-100' : 'text-gray-500'}`}>{item.content}</p>}
                          <ul className="space-y-1">
                            {item.detay?.map((d, j) => (
                              <li key={j} className="flex items-start gap-2 text-sm">
                                <span className="w-1.5 h-1.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                                <span className={darkMode ? 'text-gray-100' : 'text-gray-600'}>{d}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Evrelendirme - Basınç Yaralanması için */}
              {detail.evrelendirme && detail.evrelendirme.length > 0 && (
                <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  <button onClick={() => toggleAccordion(5)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>6</span>
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Basınç Yaralanması Evrelendirilmesi ve Uygulamalar</span>
                    </div>
                    <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(5) ? 'rotate-180' : ''}`}>
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                  {openAccordions.includes(5) && (
                    <div className="px-4 pb-4 space-y-4">
                      {detail.evrelendirme?.map((item, i) => (
                        <div key={i} className={`border rounded-lg p-3 ${darkMode ? 'border-gray-700 bg-gray-750' : 'border-gray-200 bg-gray-50'}`}>
                          <h4 className="font-semibold text-sm mb-1" style={{ color: protocol.color }}>{item.title}</h4>
                          <p className={`text-sm mb-2 ${darkMode ? 'text-gray-100' : 'text-gray-500'}`}>{item.content}</p>
                          <div className={`text-sm ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                            <span className="font-semibold">Yapılacak Uygulamalar:</span>
                            <ul className="mt-1 space-y-1">
                              {item.uygulamalar?.map((u, k) => (
                                <li key={k} className="flex items-start gap-2">
                                  <span className="w-1 h-1 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                                  <span>{u}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Önleme - Basınç Yaralanması için */}
              {detail.onleme && detail.onleme.length > 0 && (
                <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  <button onClick={() => toggleAccordion(6)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>7</span>
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Basınç Yaralanması Gelişmesinin Önlenmesi</span>
                    </div>
                    <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(6) ? 'rotate-180' : ''}`}>
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                  {openAccordions.includes(6) && (
                    <div className="px-4 pb-4">
                      <ul className="space-y-2">
                        {detail.onleme?.map((item, i) => (
                          <li key={i} className="flex items-start gap-2 text-sm">
                            <span className="w-1.5 h-1.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                            <span className={darkMode ? 'text-gray-100' : 'text-gray-600'}>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}

              {/* Ölçekler - Basınç Yaralanması için */}
              {detail.olcekler && detail.olcekler.length > 0 && (
                <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  <button onClick={() => toggleAccordion(7)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>8</span>
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Basınç Yaralanmasında Kullanılan Ölçekler</span>
                    </div>
                    <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(7) ? 'rotate-180' : ''}`}>
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                  {openAccordions.includes(7) && (
                    <div className="px-4 pb-4">
                      <ul className="space-y-2">
                        {detail.olcekler?.map((item, i) => (
                          <li key={i} className="flex items-start gap-2 text-sm">
                            <span className="w-1.5 h-1.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                            <span className={darkMode ? 'text-gray-100' : 'text-gray-600'}>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}

              {/* Kaynaklar - Protokol içinde en sonda - Dinamik index */}
              {(() => {
                const kaynakIndex = 4 + extraSections;
                let kaynakNumber = protocol.id === 'pozisyon' ? 4 : (detail.onem ? (3 + extraSections + (detail.komplikasyonlar ? 1 : 0)) : (2 + extraSections));
                return detail.kaynaklar && (
                  <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                    <button onClick={() => toggleAccordion(kaynakIndex)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                      <div className="flex items-center gap-3">
                        <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>{kaynakNumber}</span>
                        <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Kaynaklar</span>
                      </div>
                      <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(kaynakIndex) ? 'rotate-180' : ''}`}>
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </button>
                    {openAccordions.includes(kaynakIndex) && (
                      <div className="px-4 pb-4 pl-14">
                        {detail.kaynaklar?.map((kaynak, i) => (
                          <div key={i} className={`flex items-start gap-3 py-2 border-b last:border-b-0 ${darkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                            <span className="w-5 h-5 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5" style={{ backgroundColor: `${protocol.color}15`, color: protocol.color }}>{i + 1}</span>
                            <p className={`text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>{kaynak}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
          )}

          {/* PROTOKOL TAB - Eski Format */}
          {activeTab === 0 && !isNewFormat && oldFormatDetail && (
            <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
              {oldFormatDetail.protokolBasliklari?.map((item, i) => (
                <AccordionItem key={i} index={i} title={item.title} content={item.content} isOpen={openAccordions.includes(i)} onToggle={() => toggleAccordion(i)} color={protocol.color} darkMode={darkMode} />
              ))}
            </div>
          )}

          {/* ENDİKASYONLAR TAB - Yeni Format */}
          {activeTab === 1 && isNewFormat && protocol.id === 'beyin' && (
            <div className="space-y-4">
              {/* Genel Bilgi accordion */}
              <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <button onClick={() => toggleAccordion(10)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                  <div className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>1</span>
                    <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Genel Bilgi</span>
                  </div>
                  <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(10) ? 'rotate-180' : ''}`}>
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>
                {openAccordions.includes(10) && (
                  <div className="px-4 pb-4 pl-14">
                    <p className={`text-sm leading-relaxed mb-3 ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                      {detail.aileyeYonelikBakim?.intro}
                    </p>
                    <ul className="space-y-2">
                      {detail.aileyeYonelikBakim?.maddeler?.map((madde, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm">
                          <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                          <span className={darkMode ? 'text-gray-100' : 'text-gray-600'}>{madde}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          )}

          {activeTab === 1 && isNewFormat && protocol.id !== 'beyin' && (
            <div className="space-y-4">
              {/* Endikasyon Listesi - Agiz için Accordion, diğerleri normal */}
              {protocol.id === 'agiz' ? (
                <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  {/* Accordion Header */}
                  <button
                    className={`w-full flex items-center justify-between px-4 py-4 text-left ${endikasyonListOpen ? `border-b ${darkMode ? 'border-gray-700' : 'border-gray-100'}` : ''} ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}
                    onClick={() => setEndikasyonListOpen(v => !v)}
                  >
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>📋</span>
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Endikasyon Listesi</span>
                    </div>
                    <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${endikasyonListOpen ? 'rotate-180' : ''}`}>
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                  {endikasyonListOpen && (
                    <>
                      {(() => {
                        let itemNumber = 0;
                        return detail.endikasyonlar?.map((item, i) => {
                          const isGenelBilgi = item.title === 'Genel Bilgi';
                          if (!isGenelBilgi) itemNumber++;
                          const displayNumber = isGenelBilgi ? null : itemNumber;
                          return (
                            <div key={i} className={`border-b last:border-b-0 ${darkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                              <div className="px-4 py-4">
                                <div className="flex items-start gap-3">
                                  {isGenelBilgi ? (
                                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{ backgroundColor: protocol.color }}>{(protocol.id === 'pvk' || protocol.id === 'arteriyel' || protocol.id === 'svk' || protocol.id === 'pozisyon') ? '#' : 'ℹ️'}</span>
                                  ) : displayNumber === null ? (
                                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm flex-shrink-0" style={{ backgroundColor: protocol.color }}>☰</span>
                                  ) : (
                                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{ backgroundColor: protocol.color }}>{displayNumber}</span>
                                  )}
                                  <div>
                                    <h4 className={`font-semibold mb-1 ${darkMode ? 'text-white' : 'text-gray-800'}`}>{item.title}</h4>
                                    <div className={`text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                                      {item.content?.split('\n').map((line, idx) => {
                                        if (line.startsWith('•')) {
                                          return (
                                            <div key={idx} className="flex items-start gap-2 py-0.5 ml-2">
                                              <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }} />
                                              <span>{line.substring(1).trim()}</span>
                                            </div>
                                          );
                                        }
                                        if (line.match(/^\d+\./)) {
                                          return (
                                            <div key={idx} className="flex items-start gap-2 py-0.5 ml-2">
                                              <span className="font-medium min-w-[20px]" style={{ color: protocol.color }}>{line.match(/^(\d+)\./)[1]}.</span>
                                              <span>{line.replace(/^\d+\.\s*/, '')}</span>
                                            </div>
                                          );
                                        }
                                        return <p key={idx} className={idx > 0 ? 'mt-1' : ''}>{line}</p>;
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        });
                      })()}
                    </>
                  )}
                </div>
              ) : protocol.id === 'stoma' ? (
                <div className="space-y-3">
                  {detail.endikasyonlar?.map((item, i) => (
                    <div key={i} className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                      <button
                        className={`w-full flex items-center justify-between px-4 py-4 text-left ${stomaEndikasyonOpen[i] ? `border-b ${darkMode ? 'border-gray-700' : 'border-gray-100'}` : ''} ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}
                        onClick={() => setStomaEndikasyonOpen(prev => prev.map((v, idx) => idx === i ? !v : v))}
                      >
                        <div className="flex items-center gap-3">
                          <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{ backgroundColor: protocol.color }}>{i + 1}</span>
                          <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{item.title}</span>
                        </div>
                        <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform flex-shrink-0 ${stomaEndikasyonOpen[i] ? 'rotate-180' : ''}`}>
                          <path d="M6 9l6 6 6-6" />
                        </svg>
                      </button>
                      {stomaEndikasyonOpen[i] && (
                        <div className="px-4 py-3">
                          {i === 0 ? (
                            <div className={`text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                              <div className="space-y-1 mb-4">
                                {['Boşaltmalı torbalar 1/3\'i dolmuş olması','Torbanın değişiminde sızıntı olması','Ağrı ve cilt tahriş olması','Değişim zamanının gelmesi'].map((e,ei) => (
                                  <div key={ei} className="flex items-start gap-2 py-0.5">
                                    <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }} />
                                    <span>{e}</span>
                                  </div>
                                ))}
                              </div>
                              <p className="font-semibold mb-2" style={{ color: protocol.color }}>ENDİKASYONA GÖRE STOMA BAKIMINDA KULLANILAN MALZEMELER VE SIKLIĞI</p>
                              <div className={`rounded-lg overflow-hidden border ${darkMode ? 'border-gray-600' : 'border-gray-200'}`}>
                                <table className="w-full text-xs">
                                  <thead>
                                    <tr style={{ backgroundColor: `${protocol.color}20` }}>
                                      <th className={`px-3 py-2 text-left font-semibold ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Bakım Malzemeleri</th>
                                      <th className={`px-3 py-2 text-left font-semibold ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Uygulama Sıklığı</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {[
                                      ['Steril gazlı bez', 'Günde 1-2 defa'],
                                      ['Non-steril eldiven', 'Bebeğin dışkı miktarına göre değiştirilir.'],
                                      ['Serum fizyolojik', ''],
                                      ['Enjektör', ''],
                                      ['Kolostomi torbası (uygun boyda)/adaptörü', ''],
                                      ['Kolostomi pastası', ''],
                                      ['Yara bakım örtüsü şablon veya ölçüm aracı, kirli torbası (gerekli ise)', ''],
                                      ['Makas', ''],
                                    ].map(([malzeme, siklik], ri) => (
                                      <tr key={ri} className={ri % 2 === 0 ? (darkMode ? 'bg-gray-700' : 'bg-gray-50') : (darkMode ? 'bg-gray-800' : 'bg-white')}>
                                        <td className={`px-3 py-2 ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>{malzeme}</td>
                                        <td className={`px-3 py-2 ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>{siklik}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          ) : (
                            <div className={`text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                              {item.content?.split('\n').map((line, idx) => {
                                if (line.startsWith('•')) {
                                  return (
                                    <div key={idx} className="flex items-start gap-2 py-0.5 ml-2">
                                      <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }} />
                                      <span>{line.substring(1).trim()}</span>
                                    </div>
                                  );
                                }
                                return <p key={idx} className={idx > 0 ? 'mt-1' : ''}>{line}</p>;
                              })}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>

              ) : protocol.id === 'pozisyon' ? (
                <div className="space-y-3">
                  {/* Endikasyon Accordion */}
                  {detail.endikasyonlar?.map((item, i) => (
                    <div key={i} className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                      <button
                        className={`w-full flex items-center justify-between px-4 py-4 text-left ${pozisyonEndikasyonOpen[i] ? `border-b ${darkMode ? 'border-gray-700' : 'border-gray-100'}` : ''} ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}
                        onClick={() => setPozisyonEndikasyonOpen(prev => prev.map((v, idx) => idx === i ? !v : v))}
                      >
                        <div className="flex items-center gap-3">
                          <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{ backgroundColor: protocol.color }}>{i + 1}</span>
                          <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{item.title}</span>
                        </div>
                        <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform flex-shrink-0 ${pozisyonEndikasyonOpen[i] ? 'rotate-180' : ''}`}>
                          <path d="M6 9l6 6 6-6" />
                        </svg>
                      </button>
                      {pozisyonEndikasyonOpen[i] && (
                        <div className="px-4 py-3">
                          <div className={`text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                            <div className="space-y-1 mb-4">
                              {['Huzursuzluk','Hareket kısıtlılığı','Ağrı','Satürasyon düzeyleri','Basınç yarası','Mekanik ventilatöre bağlı olması'].map((e,ei) => (
                                <div key={ei} className="flex items-start gap-2 py-0.5">
                                  <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }} />
                                  <span>{e}</span>
                                </div>
                              ))}
                            </div>
                            <p className="font-semibold mb-2" style={{ color: protocol.color }}>ENDİKASYONA GÖRE YENİDOĞANA POZİSYON VERMEDE KULLANILAN MALZEMELER VE SIKLIĞI</p>
                            <div className={`rounded-lg overflow-hidden border ${darkMode ? 'border-gray-600' : 'border-gray-200'}`}>
                              <table className="w-full text-xs">
                                <thead>
                                  <tr style={{ backgroundColor: `${protocol.color}20` }}>
                                    <th className={`px-3 py-2 text-left font-semibold ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Bakım Malzemeleri</th>
                                    <th className={`px-3 py-2 text-left font-semibold ${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Uygulama Sıklığı</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {[
                                    ['Non-steril eldiven', '2-3 saatte bir pozisyon verilir.'],
                                    ['Bebek yuvası/temiz çarşaf', ''],
                                    ['Basınç yarası engelleyici materyaller (pozisyon yastıkları/yatağı, jel simit/yatağı)', ''],
                                  ].map(([malzeme, siklik], ri) => (
                                    <tr key={ri} className={ri % 2 === 0 ? (darkMode ? 'bg-gray-700' : 'bg-gray-50') : (darkMode ? 'bg-gray-800' : 'bg-white')}>
                                      <td className={`px-3 py-2 ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>{malzeme}</td>
                                      <td className={`px-3 py-2 ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>{siklik}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}

                </div>
              ) : (
                <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  {/* Accordion Header */}
                  <button
                    className={`w-full flex items-center justify-between px-4 py-4 text-left ${endikasyonListOpen ? `border-b ${darkMode ? 'border-gray-700' : 'border-gray-100'}` : ''} ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}
                    onClick={() => setEndikasyonListOpen(v => !v)}
                  >
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>📋</span>
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Endikasyon Listesi</span>
                    </div>
                    <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${endikasyonListOpen ? 'rotate-180' : ''}`}>
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                  {endikasyonListOpen && (
                    <>
                      {(() => {
                        let itemNumber = 0;
                        return detail.endikasyonlar?.map((item, i) => {
                          const isGenelBilgi = item.title === 'Genel Bilgi';
                          let displayNumber;
                          if (protocol.id === 'stoma') {
                            displayNumber = i + 1;
                          } else if (protocol.id === 'pozisyon') {
                            displayNumber = 1;
                          } else {
                            if (!isGenelBilgi) itemNumber++;
                            displayNumber = isGenelBilgi ? null : itemNumber;
                          }
                          return (
                            <div key={i} className={`border-b last:border-b-0 ${darkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                              <div className="px-4 py-4">
                                <div className="flex items-start gap-3">
                                  {isGenelBilgi ? (
                                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{ backgroundColor: protocol.color }}>{(protocol.id === 'pvk' || protocol.id === 'arteriyel' || protocol.id === 'svk' || protocol.id === 'pozisyon') ? '#' : 'ℹ️'}</span>
                                  ) : displayNumber === null ? (
                                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm flex-shrink-0" style={{ backgroundColor: protocol.color }}>☰</span>
                                  ) : (
                                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{ backgroundColor: protocol.color }}>{displayNumber}</span>
                                  )}
                                  <div>
                                    <h4 className={`font-semibold mb-1 ${darkMode ? 'text-white' : 'text-gray-800'}`}>{item.title}</h4>
                                    <div className={`text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                                      {item.content?.split('\n').map((line, idx) => {
                                        if (line.startsWith('•')) {
                                          return (
                                            <div key={idx} className="flex items-start gap-2 py-0.5 ml-2">
                                              <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }} />
                                              <span>{line.substring(1).trim()}</span>
                                            </div>
                                          );
                                        }
                                        if (line.match(/^\d+\./)) {
                                          return (
                                            <div key={idx} className="flex items-start gap-2 py-0.5 ml-2">
                                              <span className="font-medium min-w-[20px]" style={{ color: protocol.color }}>{line.match(/^(\d+)\./)[1]}.</span>
                                              <span>{line.replace(/^\d+\.\s*/, '')}</span>
                                            </div>
                                          );
                                        }
                                        return <p key={idx} className={idx > 0 ? 'mt-1' : ''}>{line}</p>;
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        });
                      })()}
                    </>
                  )}
                </div>
              )}
              
              {/* Endikasyona Göre Uygulama Sıklığı Tablosu */}
              {detail.endikasyonTablo && detail.endikasyonTablo.length > 0 && (
                <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  {/* Accordion Header */}
                  <button
                    className={`w-full flex items-center justify-between px-4 py-4 text-left ${endikasyonTabloOpen ? `border-b ${darkMode ? 'border-gray-700' : 'border-gray-100'}` : ''} ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}
                    onClick={() => setEndikasyonTabloOpen(v => !v)}
                  >
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>📊</span>
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Endikasyona Göre Uygulama Sıklığı</span>
                    </div>
                    <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${endikasyonTabloOpen ? 'rotate-180' : ''}`}>
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                  {endikasyonTabloOpen && (
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className={darkMode ? 'bg-gray-700' : 'bg-gray-50'}>
                            <th className={`px-3 py-2 text-left font-semibold ${darkMode ? 'text-white' : 'text-gray-700'}`}>Endikasyon</th>
                            <th className={`px-3 py-2 text-left font-semibold ${darkMode ? 'text-white' : 'text-gray-700'}`}>Bakım Malzemeleri</th>
                            <th className={`px-3 py-2 text-left font-semibold ${darkMode ? 'text-white' : 'text-gray-700'}`}>Uygulama Sıklığı</th>
                          </tr>
                        </thead>
                        <tbody>
                          {detail.endikasyonTablo?.map((row, i) => (
                            <tr key={i} className={`border-t ${darkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                              <td className={`px-3 py-2 font-medium align-top ${darkMode ? 'text-gray-100' : 'text-gray-800'}`}>{row.endikasyon}</td>
                              <td className={`px-3 py-2 align-top ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>
                                {Array.isArray(row.malzemeler) ? (
                                  <ul className="space-y-0.5">
                                    {row.malzemeler?.map((m, j) => (
                                      <li key={j} className="flex items-start gap-1.5">
                                        <span className="mt-1.5 w-1 h-1 rounded-full flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                                        <span>{m}</span>
                                      </li>
                                    ))}
                                  </ul>
                                ) : row.malzemeler}
                              </td>
                              <td className={`px-3 py-2 font-medium align-top`} style={{ color: protocol.color }}>{row.siklik}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* ENDİKASYONLAR TAB - Eski Format */}
          {activeTab === 1 && !isNewFormat && oldFormatDetail && (
            <div className={`rounded-xl p-4 border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
              <p className={`text-sm mb-3 ${darkMode ? 'text-gray-100' : 'text-gray-500'}`}>Bu protokol aşağıdaki durumlarda uygulanmalıdır:</p>
              {oldFormatDetail.endikasyonlar?.map((item, i) => <ListItem key={i} color={protocol.color} darkMode={darkMode}>{item}</ListItem>)}
            </div>
          )}

          {/* STOMA ALGORİTMA TAB */}
          {activeTab === 2 && protocol.id === 'stoma' && detail.algoritmaAdimlari && (
            <div className="rounded-2xl p-4" style={{ backgroundColor: darkMode ? `${protocol.color}10` : `${protocol.color}08` }}>
              <AlgorithmFlowchart steps={detail.algoritmaAdimlari} color={protocol.color} />
            </div>
          )}

          {/* TÜP KONTROLÜ TAB - Sadece NG için */}
          {activeTab === 2 && protocol.id === 'ng' && (
            <div className="space-y-4">
              <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <div className="px-4 py-4" style={{ backgroundColor: `${protocol.color}15` }}>
                  <h3 className="font-semibold" style={{ color: protocol.color }}>Nazogastrik Tüpün Doğru Yerde Olup Olmadığının Kontrol Edilmesi Gereken Durumlar</h3>
                </div>
                <div className="p-4">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <span className="w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold text-white flex-shrink-0 mt-0.5" style={{ backgroundColor: protocol.color }}>1</span>
                      <span className={`${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Nazogastrik tüp ilk yerleştirildiğinde</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold text-white flex-shrink-0 mt-0.5" style={{ backgroundColor: protocol.color }}>2</span>
                      <span className={`${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Tüple beslemeye başlamadan veya ilaç uygulamadan önce</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold text-white flex-shrink-0 mt-0.5" style={{ backgroundColor: protocol.color }}>3</span>
                      <span className={`${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Öksürme, öğürme ya da kusma görüldüğünde</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold text-white flex-shrink-0 mt-0.5" style={{ backgroundColor: protocol.color }}>4</span>
                      <span className={`${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Orofarengeal aspirasyondan sonra</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold text-white flex-shrink-0 mt-0.5" style={{ backgroundColor: protocol.color }}>5</span>
                      <span className={`${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Eğer tüpün dışta kalan uzunluğu değişmiş ise</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold text-white flex-shrink-0 mt-0.5" style={{ backgroundColor: protocol.color }}>6</span>
                      <span className={`${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>NGT ile beslenmesi ve ilaç uygulaması devam eden hastalarda günde en az bir kez</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold text-white flex-shrink-0 mt-0.5" style={{ backgroundColor: protocol.color }}>7</span>
                      <span className={`${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Bilinci açık hastalarda, hastanın tarif ettiği rahatsızlık ya da besinin boğazına, ağzına geri gelmesi hissi olduğu durumlarda</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold text-white flex-shrink-0 mt-0.5" style={{ backgroundColor: protocol.color }}>8</span>
                      <span className={`${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Tüpün pozisyonunu değiştirecek herhangi bir hareketten sonra da tüpün doğru yerde olup olmadığının kontrolü yapılmalıdır</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold text-white flex-shrink-0 mt-0.5" style={{ backgroundColor: protocol.color }}>9</span>
                      <span className={`${darkMode ? 'text-gray-100' : 'text-gray-700'}`}>Tüpün yerinde olup olmadığından emin olunmadan hastaya su, besin ya da başka bir sıvı tüp yoluyla verilmemelidir</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}

          {/* ALGORİTMA TAB - Yeni Format - Soft tasarım */}
          {((protocol.id === 'ng' && activeTab === 3) || (protocol.id !== 'ng' && protocol.id !== 'stoma' && protocol.id !== 'pozisyon' && protocol.id !== 'beyin' && activeTab === 2)) && isNewFormat && detail.algoritmaAdimlari && (
            <div className="rounded-2xl p-4" style={{ backgroundColor: darkMode ? `${protocol.color}10` : `${protocol.color}08` }}>
              <AlgorithmFlowchart steps={detail.algoritmaAdimlari} color={protocol.color} />
            </div>
          )}

          {/* BEYİN ÖLÜMÜ ALGORİTMA TAB */}
          {protocol.id === 'beyin' && activeTab === 2 && detail.algoritmaAdimlari && (
            <div className="space-y-3">
              {detail.algoritmaAdimlari.map((step, idx) => (
                <div key={idx} className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  <button onClick={() => toggleAccordion(idx)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold" style={{ backgroundColor: protocol.color }}>{idx + 1}</span>
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{step.title}</span>
                    </div>
                    <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform ${openAccordions.includes(idx) ? 'rotate-180' : ''}`}>
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </button>
                  {openAccordions.includes(idx) && (
                    <div className="px-4 pb-4">
                      <ul className="space-y-2 pl-2">
                        {step.items.map((item, i) => (
                          <li key={i} className="flex items-start gap-2 text-sm">
                            <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: protocol.color }}></span>
                            <span className={darkMode ? 'text-gray-100' : 'text-gray-600'}>
                              {item.split('**').map((part, idx) => 
                                idx % 2 === 1 ? (
                                  <strong key={idx} className={darkMode ? 'text-white' : 'text-gray-800'}>{part}</strong>
                                ) : (
                                  part
                                )
                              )}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* POZİSYON - POZİSYONLAR TAB (index 2) */}
          {protocol.id === 'pozisyon' && activeTab === 2 && (
            <div className="space-y-3">
              {/* Genel Bilgiler */}
              <div className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                <button onClick={() => toggleAccordion(49)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${openAccordions.includes(49) ? `border-b ${darkMode ? 'border-gray-700' : 'border-gray-100'}` : ''} ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                  <div className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{ backgroundColor: protocol.color }}>#</span>
                    <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Genel Bilgiler</span>
                  </div>
                  <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform flex-shrink-0 ${openAccordions.includes(49) ? 'rotate-180' : ''}`}><path d="M6 9l6 6 6-6" /></svg>
                </button>
                {openAccordions.includes(49) && (
                  <div className="px-4 pb-4 pt-3 space-y-3">
                    {[
                      { bold: 'Bireyselleştirilmiş Gelişimsel Bakım ve Pozisyon Uygulamaları', text: `YYBÜ'nde gelişimsel destekleyici bakımın uygulamasında BGB uygulamalarının klinik açıdan birçok fayda sağladığı bilinmektedir. Gelişimsel pozisyon verme uygulamaları, bebeğin anne karnındaki fleksiyon postüründe, orta hatta, çevrelenmiş ve konforlu pozisyonunu koruyarak YYBÜ'deki bebeklerin nöromotor gelişimini desteklemeyi ve oluşabilecek problemleri azaltmayı amaçlamaktadır.` },
                      { bold: 'Yanlış Pozisyonların Gelişimsel Etkileri', text: `Yenidoğan yoğun bakımda takip edilen yenidoğanlarda kullanılan tüm pozisyonlar (doğru-yanlış) nörodavranışsal organizasyon, kas iskelet sistemi gelişimi ve beslenme performansını etkilemektedir. Etkisiz pozisyon, kafatasında düzleşme veya değişik kafa şekillerinin ortaya çıkmasına yol açarken, prematüre bebekleri destekleyecek pozisyonların verilmemesinin fizyolojik stabilitenin azalmasına, bebeğin stres düzeyinin artmasına neden olacağı belirtilmektedir.` },
                      { bold: 'Gelişimsel Destekleyici Pozisyon Uygulamaları', text: `BGB kavramlarından gelişimsel destekleyici pozisyon uygulamaları ile yenidoğanlara prone pozisyonu, yan yatış pozisyonu, supine ve cenin pozisyonu verilmektedir.` },
                    ].map((item, i) => (
                      <div key={i}>
                        <p className={`text-sm font-bold mb-1 ${darkMode ? 'text-white' : 'text-gray-800'}`} style={{ color: protocol.color }}>{item.bold}</p>
                        <p className={`text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>{item.text}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {[
                { num: 1, title: 'Prone (Yüz Üstü) Pozisyonu', paragraflar: [
                  "Ekstrauterin çevrede yapılan düzenlemeler ile bebeğin kendini güvende hissetmesine olanak sağlayan prone pozisyonu, YYBÜ'lerinde tercih edilen en uygun yatış pozisyonudur.",
                  "Prone pozisyonunun yenidoğanlar üzerindeki faydaları fizyolojik açıdan incelendiğinde, bu bebeklerin oksijen ihtiyaçlarının daha az olduğu, solunum hızı ve apne periyodlarının azaldığı, kalp atım hızının düzenli olduğu ve beyne olan venöz dönüşün arttığı belirlenmiştir. Prone pozisyonu verilen bebeklerin el-yüz ve el-ağız manevrası yaparak stresle daha kolay başa çıktıkları ve kendi kendilerini sakinleştirdikleri tespit edilmiştir.",
                ]},
                { num: 2, title: 'Yan Yatış Pozisyonu', paragraflar: [
                  "Yan yatış pozisyonu, yer çekiminin ekstansör etkilerini azaltması, baş ile beraber el ve ayakların orta hat oryantasyonunu kolaylaştırması, aynı zamanda ekstremite aktivitelerini desteklemesi bakımından YYBÜ'de prone pozisyonunun kullanılamadığı durumlarda tercih edilen pozisyonlardan biridir.",
                ]},
                { num: 3, title: 'Supine (Sırt Üstü) Pozisyonu', paragraflar: [
                  "Supine pozisyonu, yenidoğanların anne karnındaki fleksiyon pozisyonunu desteklemediğinden YYBÜ'lerinde tercih edilen bir pozisyon değildir. Buna rağmen ABÖS (Ani Bebek Ölüm Sendromu) riskini azaltmak için bebeklerin supine pozisyonunda uyuması gerektiği önerisi bilimsel olarak kanıtlanmıştır. Supine pozisyonu hemşirelik bakım uygulamalarının kolaylıkla uygulanması ve bakım verici ile yüz-yüze iletişimi artırması açısından önemlidir. Özellikle neonatal dönemde abdomen veya göğüse uygulanan cerrahi girişimlerin stabilizasyonu evresinde sıklıkla kullanılan bir pozisyondur.",
                ]},
                { num: 4, title: 'Cenin Pozisyonu', paragraflar: [
                  'Cenin pozisyonu, "bebeği yuvaya alma yöntemi" olarak da adlandırılmakla beraber, bebeğin kol ve bacaklarını el ile fleksiyonda tutularak, vücudu orta hatta yakın kapalı pozisyona alma işlemi olarak tanımlanır. Bu yöntem uygulanırken bebeğe diğer gelişimsel pozisyonlar (lateral, supine ve prone) verilebilir. İntrauterin ortam desteği sağlayan bir pozisyondur. Bu pozisyon bebeğin kendini anne karnında hissetmesine ve kendi kendini sakinleştirmesine, ağrı ve stresle başa çıkma davranışlarını geliştirmesine, bebeklerin kendini güvende hissederek vücut kontrolünü sağlamasına yardımcı olur.',
                ]},
              ].map((poz, i) => (
                <div key={i} className={`rounded-xl border overflow-hidden ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
                  <button onClick={() => toggleAccordion(50 + i)} className={`w-full flex items-center justify-between px-4 py-4 text-left ${openAccordions.includes(50 + i) ? `border-b ${darkMode ? 'border-gray-700' : 'border-gray-100'}` : ''} ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                    <div className="flex items-center gap-3">
                      <span className="w-7 h-7 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{ backgroundColor: protocol.color }}>{poz.num}</span>
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>{poz.title}</span>
                    </div>
                    <svg width="20" height="20" fill="none" stroke={protocol.color} strokeWidth="2" className={`transition-transform flex-shrink-0 ${openAccordions.includes(50 + i) ? 'rotate-180' : ''}`}><path d="M6 9l6 6 6-6" /></svg>
                  </button>
                  {openAccordions.includes(50 + i) && (
                    <div className="px-4 pb-4 space-y-2">
                      {poz.paragraflar.map((p, pi) => (
                        <p key={pi} className={`text-sm leading-relaxed ${darkMode ? 'text-gray-100' : 'text-gray-600'}`}>{p}</p>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* POZİSYON ALGORİTMA TAB - Tüm pozisyon algoritmaları accordion olarak */}
          {protocol.id === 'pozisyon' && activeTab === 3 && detail?.algoritmaAdimlari && (
            <div className="rounded-2xl p-4" style={{ backgroundColor: darkMode ? `${protocol.color}10` : `${protocol.color}08` }}>
              <AlgorithmFlowchart steps={detail.algoritmaAdimlari} color={protocol.color} />
            </div>
          )}

          {((protocol.id === 'ng' && activeTab === 3) || (protocol.id !== 'ng' && protocol.id !== 'stoma' && protocol.id !== 'pozisyon' && activeTab === 2)) && (!isNewFormat || !detail?.algoritmaAdimlari) && (
            <div className={`rounded-2xl border p-6 text-center ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
              <div className={`w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
                <span className="text-4xl">📊</span>
              </div>
              <h3 className={`text-lg font-bold mb-2 ${darkMode ? 'text-white' : 'text-gray-800'}`}>{protocol.name} Algoritması</h3>
              <p className={`text-sm ${darkMode ? 'text-gray-100' : 'text-gray-500'}`}>Algoritma içeriği yakında eklenecektir.</p>
            </div>
          )}
        </div>
        
        {/* Spacer - footer'ı en alta itmek için */}
        <div className="flex-grow"></div>
        
        {/* Footer - Hazırlayan - Her zaman en altta */}
        <div className="text-center pb-1.5">
          <link href="https://fonts.googleapis.com/css2?family=Marck+Script&display=swap" rel="stylesheet" />
          <span 
            className={`text-sm ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}
            style={{ fontFamily: "'Marck Script', cursive", fontWeight: 600 }}
          >
            fim
          </span>
          <span className={`${darkMode ? 'text-red-400/50' : 'text-red-300/70'} text-sm ml-0.5`}>♥</span>
        </div>
      </div>
    </div>
  );
};

// MAIN APP - Bottom nav yok
export default function YogunBakimApp() {
  const [view, setView] = useState('home');
  const [selectedProtocol, setSelectedProtocol] = useState(null);
  const [selectedAlgorithm, setSelectedAlgorithm] = useState(null);
  const [selectedMainId, setSelectedMainId] = useState(null);
  const [initialTab, setInitialTab] = useState(0);
  const [darkMode, setDarkMode] = useState(false);
  const scrollRef = React.useRef(null);

  useEffect(() => {
    document.title = 'Yenidoğan Yoğun Bakım Protokolleri';
    const favicon = document.querySelector("link[rel='icon']") || document.createElement('link');
    favicon.rel = 'icon';
    favicon.href = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>🏦</text></svg>";
    document.head.appendChild(favicon);
  }, []);

  // Prevent body scroll - only our container scrolls
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = '';
    };
  }, []);

  const scrollToTop = React.useCallback(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, []);

  // Scroll to top on view change
  useEffect(() => {
    scrollToTop();
  }, [view, selectedProtocol, scrollToTop]);
  
  // Accordion state'leri ana component'te - geri dönüşte korunur
  const [algorithmsOpen, setAlgorithmsOpen] = useState(true);
  const [protocolsOpen, setProtocolsOpen] = useState(true);

  const handleSelectProtocol = (protocol) => { 
    setSelectedProtocol(protocol); 
    setInitialTab(0);
    setView('detail');
  };
  
  const handleSelectAlgorithm = (algorithm) => { 
    const pozisyonAlgorithms = ['prone', 'lateral', 'supine', 'cenin'];
    const isPozisyonAlgorithm = pozisyonAlgorithms.includes(algorithm.protocolId);

    if (algorithm.protocolId === 'pozisyonAlg') {
      const pozisyonProtocol = subProtocols.find(p => p.id === 'pozisyon');
      if (pozisyonProtocol) {
        setSelectedProtocol(pozisyonProtocol);
        setSelectedAlgorithm(null);
        setInitialTab(3);
        setView('detail');
      }
      return;
    }
    
    if (isPozisyonAlgorithm) {
      const pozisyonProtocol = subProtocols.find(p => p.id === 'pozisyon');
      if (pozisyonProtocol) {
        const pozisyonOrder = ['prone', 'lateral', 'supine', 'cenin'];
        const accordionIdx = 50 + pozisyonOrder.indexOf(algorithm.protocolId);
        setSelectedProtocol(pozisyonProtocol);
        setSelectedAlgorithm(String(accordionIdx));
        setInitialTab(2);
        setView('detail');
      }
    } else {
      const linkedProtocol = subProtocols.find(p => p.id === algorithm.protocolId);
      if (linkedProtocol) {
        setSelectedProtocol(linkedProtocol);
        let tabIndex = 2;
        if (linkedProtocol.id === 'ng') tabIndex = 3;
        else if (linkedProtocol.id === 'stoma') tabIndex = 2;
        else if (linkedProtocol.id === 'pozisyon') tabIndex = 2;
        setSelectedAlgorithm(null);
        setInitialTab(tabIndex);
        setView('detail');
      }
    }
  };
  
  const handleBack = () => { 
    setView('home'); 
    setSelectedProtocol(null); 
    setSelectedAlgorithm(null); 
    setInitialTab(0);
  };
  
  const handleHome = () => { 
    setView('home'); 
    setSelectedProtocol(null); 
    setSelectedAlgorithm(null); 
    setInitialTab(0);
  };

  // Tema renkleri
  const theme = {
    bg: darkMode ? 'bg-gray-900' : 'bg-white',
    bgSecondary: darkMode ? 'bg-gray-800' : 'bg-gray-100',
    bgCard: darkMode ? 'bg-gray-800' : 'bg-white',
    text: darkMode ? 'text-white' : 'text-gray-800',
    textSecondary: darkMode ? 'text-gray-100' : 'text-gray-500',
    border: darkMode ? 'border-gray-700' : 'border-gray-200',
  };

  return (
    <div 
      ref={scrollRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch'
      }}
      className={`${theme.bg} transition-colors duration-300`}
    >
      <div className="flex flex-col min-h-full">
        {view === 'home' && (
          <HomeScreen 
            onSelectProtocol={handleSelectProtocol} 
            onSelectAlgorithm={handleSelectAlgorithm} 
            selectedMainId={selectedMainId} 
            onSelectMain={setSelectedMainId}
            algorithmsOpen={algorithmsOpen}
            setAlgorithmsOpen={setAlgorithmsOpen}
            protocolsOpen={protocolsOpen}
            setProtocolsOpen={setProtocolsOpen}
            darkMode={darkMode}
            setDarkMode={setDarkMode}
            theme={theme}
          />
        )}
        {view === 'detail' && selectedProtocol && (
          <DetailScreen 
            protocol={selectedProtocol} 
            onBack={handleBack} 
            onHome={handleHome} 
            onSelectProtocol={handleSelectProtocol} 
            onSelectAlgorithm={handleSelectAlgorithm}
            initialTab={initialTab}
            selectedAlgorithm={selectedAlgorithm}
            darkMode={darkMode}
            setDarkMode={setDarkMode}
            theme={theme}
            scrollToTop={scrollToTop}
          />
        )}
        
        {/* Disclaimer Footer */}
        <div className={`mt-auto py-4 px-4 text-center text-xs ${darkMode ? 'text-gray-500 bg-gray-800' : 'text-gray-400 bg-gray-50'}`}>
          Uygulamada yer alan bilgiler tanı ve tedavi değildir, bilgilendirme amacıyla hazırlanmıştır. Bilgiler güncelliğini yitirmiş olabilir. Lütfen bir sağlık profesyonelinden destek alınız.
        </div>
      </div>
    </div>
  );
}
